<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import simplebar from "simplebar-vue";
import OrdersApi from "@/services/orders-api";
import ItemsApi from "@/services/items-api";
import CustomersApi from "@/services/customers-api";
import ReportingApi from "@/services/reporting-api";
// import PricesApi from "@/services/prices-api";
import OrderModal from "@/components/orderModal"
import OrderSummary from "@/components/OrderSummary"
import OrdersList from "@/components/orderslist"
import TopItems from "@/components/topItems";
import Promotions from "@/components/promotion"; 
import PalierCustomer from "@/components/PalierCustomer"; 
import PalierCustomerNewUI from "@/components/PalierCustomerNewUi"; 
import SharedDocuments from "@/components/sharedDocuments"; 
// import {Priviliges} from "../../../privileges";
import UsersApi from "@/services/users-api";
import BannerApi from "@/services/banner-api";
//import carousel from 'vue-owl-carousel'
import sharedDocumentsApi from "@/services/sharedDocuments-api";

import i18n from "@/i18n";

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import QuickOrder from './quickOrder.vue';
import QuickOrderSwitch from "@/components/quick-order-switch";
import CatalogStockStatus from "@/components/CatalogStockStatus";
import CatalogSearchSuggestions from "@/components/CatalogSearchSuggestions";
import AgentSelectorComponent from "@/components/AgentSelectorComponent";

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    
    return null;
}
export default {
  page: {
    title: "Catalogue des articles",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { QuickOrderSwitch, CatalogStockStatus, CatalogSearchSuggestions, AgentSelectorComponent,
    Layout, simplebar,OrderModal, OrdersList ,TopItems, Promotions, VueSlickCarousel,PalierCustomer, PalierCustomerNewUI,/* carousel,*/
    QuickOrder, OrderSummary, SharedDocuments
  },
  props :{
    
    propGroup: {
      type: Number,
      default: () => ({})
    },

    propSubGroup: {
      type: Number,
      default: () => ({})
    },

    propFilter: {
      type: String,
    },
   
  },

  computed: {

    isRequiredBannerAds() {
      return process.env.VUE_APP_FEATURE_REQUIRED_BANNER_ADS === 'true';
    },
    requiredBannerCurrent() {
      return this.bannerAdsList && this.bannerAdsList[this.requiredBannerIndex];
    },
    isRequiredBannerLast() {
      return !this.bannerAdsList || this.requiredBannerIndex >= this.bannerAdsList.length - 1;
    },

    // new items / arrivals / launches are not offered to laboratory / partner accounts (the server ignores these filters for them)
    isHideSearchInNewItems() {
      return process.env.VUE_APP_FEATURES_HIDE_SEARCH_IN_NEW_ITEMS === 'true' || this.isPartner;
    },

    isHideSearchInNewItemsLast24Only() {
      return process.env.VUE_APP_FEATURES_HIDE_SEARCH_IN_NEW_ITEMS_LAST_24_ONLY === 'true' || this.isPartner;
    },

    isWebNouvEntrePara() {
      return process.env.VUE_APP_FEATURES_WEB_NOUV_ENTRE_PARA === 'true' && !this.isPartner;
    },

    isWebNouvLancementPara() {
      return process.env.VUE_APP_FEATURES_WEB_NOUV_LANCEMENT_PARA === 'true' && !this.isPartner;
    },

    cataloguePerPage() {
      return parseInt(process.env.VUE_APP_FEATURES_PER_PAGE_CATALOGUE, 10) || 5
    },

    isMSS(){
      return process.env.VUE_APP_CLIENT_NAME === "mss"
    },
    
    isCAB(){
      return process.env.VUE_APP_CLIENT_NAME === "cab"
    },

    filters() {

      const defaultOrder = ["group", "brand", "form", "dci"]
      const avnOrder = ["brand", "dci", "form", "group"]
      const mssOrder = ["brand", "form"]

      const isAvn = process.env.VUE_APP_CLIENT_NAME === "avn"
      const isMss = process.env.VUE_APP_CLIENT_NAME === "mss"

      const order = isAvn ? avnOrder : isMss ? mssOrder : defaultOrder

      return order.map(key => {

        const filter = { ...this.filterConfig[key] }

        if (isAvn && key === "brand") {
          filter.label = "Fournisseur"
          filter.legacyLabel = "Filtrer par Fournisseur"
          filter.placeholder = "Fournisseur"
        }

        return filter

      })
    },


    // below Bootstrap's xl breakpoint the cart sits under the catalogue and is never collapsed.
    // Reactive (viewportWidth follows resize/rotation): a plain window.innerWidth computed is cached
    // forever, so a tablet rotated / a window resized below 1200px after load lost the cart entirely.
    isLgScreen() {
      return this.viewportWidth < 1200;
    },
    // phones/tablets, catalogue mode: floating shortcut to the cart, hidden while the cart is on screen
    showCartShortcut() {
      return this.isLgScreen && !this.isQuickOrder && !this.cartInView;
    },
    // mobile catalogue: ref/brand, price/stock, promo and the add control under the designation. Only used when the
    // normal grid would push the add-to-cart column off screen (isMobileCatalog, measured); otherwise the normal grid
    isMobileCatalogEnabled(){
      return process.env.VUE_APP_FEATURE_MOBILE_CATALOG === 'true';
    },
    isCollapseCartBox(){
      return process.env.VUE_APP_FEATURE_COLLAPSE_CART_BOX === 'true';
    },
    // CAB (VUE_APP_THEME=0, its own theme) keeps the collapsed cart as an icon column; the other instances get the rail
    isLegacyCollapsedCart(){
      return process.env.VUE_APP_THEME == 0;
    },
    isHideBarreCode(){
      return process.env.VUE_APP_FEATURE_HIDE_BARRECODE === 'true';
    },
    isNewPalierCustomerUI(){
      return process.env.VUE_APP_NEW_PALIER_CUSTOMER_NEW_UI === 'true';
    },
    recommandationItemFeatureIsEnable(){
      return process.env.VUE_APP_FEATURE_RECOMMANDATION_ITEM === 'true';
    },
    equivalentItemFeatureIsEnable(){
      return process.env.VUE_APP_FEATURE_EQUIVALENT_ITEM === 'true';
    },
    // Saisie rapide is not offered on phones when the mobile catalogue is on (the catalogue is the phone way to order)
    quickOrderIsEnable(){
      return process.env.VUE_APP_FEATURE_QUICK_ORDER === 'true' && !(this.isMobileCatalogEnabled && this.isPhone);
    },
    // CSV import of Saisie rapide: off unless VUE_APP_FEATURE_QUICK_ORDER_CSV_IMPORT is 'true' (explicitly false on omn)
    isQuickOrderCsvImportEnabled(){
      return process.env.VUE_APP_FEATURE_QUICK_ORDER_CSV_IMPORT === 'true';
    },
    role() {
      return this.$cookies.get('userr');
    },

    draftOrderId() {
        return this.$cookies.isKey('drafto') ? this.$cookies.get('drafto') : null;
    },

    orderLinesPara() {
      return this.orderLines.filter(line => line.itemType === 0);
    },

    orderLinesPharma() {
      return this.orderLines.filter(line => line.itemType === 1);
    },

    permission() {
        const  storedPermissions = JSON.parse(getCookie('permission')) || [];
        return storedPermissions
    },
    isPartner() {
         const  isPartner = JSON.parse(getCookie('isPartner')) || false;
        return isPartner
        },

    isSupplierAdmin() {
      return (this.role === 1 && (this.permission && this.permission.some(pr => pr.includes('SUPPLIER_ADMIN'))));
    },

    isHideControlledSalesFilter(){
      return  process.env.VUE_APP_FEATURE_HIDE_CONTROLLED_SALES_FILTER === 'true'
    },

    isRepartitionSalesFilter(){
      return  process.env.VUE_APP_FEATURE_REPARTITION_SALES_FILTER === 'true'
    },

    isParaOnly(){
      return  process.env.VUE_APP_FEATURE_PARA_ONLY === 'true'
    },

    // PARA card over the whole row once the PHARMA figures are known to be absent (empty answer or no turnover);
    // null means still loading, so the row keeps its two halves and does not jump when PHARMA arrives
    // CAB (VUE_APP_THEME=0, its own theme) keeps the catalogue filters as they were before the filters UX review
    isLegacyCatalogFilters(){
      return process.env.VUE_APP_THEME == 0
    },

    isParaCardFullWidth(){
      return this.customerLandingPharmaList !== null && !(this.customerLandingPharmaList && this.customerLandingPharmaList.turnover)
    },

    computedItemsListFields() {
      const baseFields = [...this.itemsListFields];

      if (!this.isHideBarreCode) {
        baseFields.splice(1, 0, {
          key: "barcode",
          label: "Code à barre",
          thClass: "text-left",
          tdClass: "text-left font-weight-bold align-middle"
        });
      }

      // mobile catalogue: ref, price, promo, stock and the add control are in the designation cell (m-quick), so their own
      // columns are hidden and the designation takes the whole visible width of the grid
      if (this.isMobileCatalog) {
        const mobileHidden = ['ref', 'barcode', 'stockStatus', 'priceTaxIncl', 'gratuity', 'action'];
        return baseFields.map(f => {
          if (mobileHidden.includes(f.key)) return { ...f, thClass: (f.thClass || '') + ' d-none', tdClass: (f.tdClass || '') + ' d-none' };
          if (f.key === 'title') return { ...f, thClass: (f.thClass || '') + ' m-title', tdClass: (f.tdClass || '') + ' m-title', thStyle: 'min-width:' + this.mobileCatalogTitleWidth + 'px;' };
          return f;
        });
      }

      return baseFields;
    },
    
    filteredSharedDocumentByType() {
      // null on a failed call (and undefined when the axios interceptor swallows a 4xx/5xx): a throw here aborts
      // the whole page re-render, e.g. the cart never comes back after a resize
      return Array.isArray(this.sharedDocumentbyType) ? this.sharedDocumentbyType.filter(item => item.count > 0) : [];
    },

    panacheItemsToOrderTotal() {
      return this.itemsToOrder.reduce((total, item) => total + Number(item.quantityToOrder || 0), 0);
    },

    panacheOfferedItemsTotal() {
      return this.offeredItems.reduce((total, item) => total + Number(item.quantityOffered || 0), 0);
    },

    isSharedDocumentsEnabled() {
      return process.env.VUE_APP_FEATURE_SHARED_DOCUMENTS === 'true';
    },

    hasAgencySelector() {
      return this.agencyList && this.agencyList.length > 1;
    },

    // the cart's agency: the draft's own agency, else the selected one (a new draft is created there)
    cartAgencyName() {
      const agencyId = this.order && this.order.dbId ? this.order.dbId : this.selectedAgency;
      return this.getOrderAgencyName(agencyId);
    },
    cartAgencyColorStyle() {
      const agencyId = this.order && this.order.dbId ? this.order.dbId : this.selectedAgency;
      return { '--agency-rgb': this.getAgencyRgbColorById(agencyId) };
    },

    featureAgencyList() {
      try {
        return JSON.parse(process.env.VUE_APP_FEATURE_AGENCY_LIST || '[]');
      } catch (e) {
        return [];
      }
    },

    agencySelectOptions() {
      return this.agencyList.map(agency => ({
        value: this.getAgencyValue(agency),
        text: this.getAgencyName(agency),
        rgb: this.getAgencyRgbColorById(this.getAgencyValue(agency))
      }));
    },

    activeAgencyName() {
      return this.getAgencyNameById(this.selectedAgency) || 'Agence non sélectionnée';
    },

    pendingAgencyName() {
      return this.getAgencyNameById(this.pendingSelectedAgency) || 'Agence non sélectionnée';
    },

    canRequestAgencyChange() {
      return this.pendingSelectedAgency !== null && String(this.pendingSelectedAgency) !== String(this.selectedAgency);
    },

    selectedAgencyName() {
      return this.getAgencyNameById(this.selectedAgency);
    },

    selectedAgencyColorStyle() {
      const rgbColor = this.getAgencyRgbColorById(this.selectedAgency);
      return {
        '--agency-rgb': rgbColor,
        '--agency-soft-rgb': rgbColor
      };
    },

    addToCartPossitionButton() {
      return Number(process.env.VUE_APP_FEATURE_CUSTOM_POSITION_ADD_TO_CART_BUTTON);
    },

    isAdvancedSearchEnable() {
      return process.env.VUE_APP_FEATURE_ADVANCED_SEARCH === 'true';
    },

    isHideExpirationDateFromCatalog(){
      return process.env.VUE_APP_FEATURES_HIDE_EXPIRATION_DATE_FROM_CATALOG === 'true';
    },

      itemsListFields() {
        const fields = [
          { key: "ref", thClass: "text-left", tdClass: "text-left font-weight-bold align-middle" },
          { key: "title", thClass: "text-left", tdClass: "text-left align-middle font-weight-bold no-wrap", thStyle: "min-width:310px;" },
          { key: "image", label: "", thClass: "text-left", tdClass: "text-left align-middle font-weight-bold no-wrap", thStyle: "width:5px;" },
          { key: "expirationDate", label: "Date de péremption", tdClass: "align-middle" }, // this field is conditionally hidden based on the isHideExpirationDateFromCatalog feature flag
          { key: "stockStatus", thClass: "text-center", tdClass: "text-center align-middle", thStyle: "min-width:90px;" },
          { key: "packageCount", label: "Unités par carton", thClass: "text-right", tdClass: "text-right align-middle", thStyle: "width:150px;" },
          { key: "gratuity", label: "Promo", thClass: "text-right", tdClass: "text-right align-middle" },
          { key: "pricePublic", label: "Prix Public", thClass: "text-right", tdClass: "text-right align-middle no-wrap", thStyle: "width:100px;" },
          { key: "discountedPrice", thClass: "text-right", tdClass: "text-right align-middle no-wrap", thStyle: "width:100px;" },
          { key: "priceTaxIncl", label: "Prix TTC", thClass: "text-right", tdClass: "text-right font-weight-bold align-middle no-wrap", thStyle: "width:100px;" },
        ];


        const filteredFields = this.isHideExpirationDateFromCatalog
        ? fields.filter(f => f.key !== "expirationDate")
        : fields;
        
        const addToCartButton = {
          key: "action",
          label: "",
          thStyle: "width:111px;",
          tdClass: "align-middle cat-action"
        };

        const position = this.addToCartPossitionButton;

        if (!isNaN(position) && position >= 0 && position <= filteredFields.length) {
          filteredFields.splice(position, 0, addToCartButton);
        } else {
          filteredFields.push(addToCartButton);
        }

        return filteredFields;
      },

      allWordsBeginWithPercent() {
        return this.reference
          .trim()
          .split(/\s+/)
          .every(word => word.startsWith("%"));
      },

      gratuityMaxCount() {
        const item = this.itemsToOrder?.[0];

        if (!item || !item.panQte || item.panQte === 0) {
          return 0;
        }

        return Math.floor(this.panacheItemsToOrderTotal / item.panQte);
      },

      isCustomerRevenueStatusEnabled() {
        return process.env.VUE_APP_FEATURE_CUSTOMER_REVENUE_STATUS === 'true';
      },

      customerRevenueProgress() {
        if (!this.customerRevenueStatus || !this.customerRevenueStatus.plafond) return 0;
        return Math.min(100, Math.max(0, (this.customerRevenueStatus.encours / this.customerRevenueStatus.plafond) * 100));
      },

      // what the revenue card shows: a ceiling of 0 means "no ceiling" (the server does not block those customers)
      customerRevenueInfo() {
        const status = this.customerRevenueStatus || {};
        const ceiling = Number(status.plafond) || 0;
        const used = Number(status.encours) || 0;
        if (ceiling <= 0) return { hasCeiling: false, state: 'none', percentLabel: '', note: '' };
        const currency = (String(status.plafondAsString || '').match(/[A-Za-z]+\s*$/) || ['TND'])[0].trim();
        const format = (n) => {
          const [units, decimals] = Math.abs(n).toFixed(3).split('.');
          return units.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + decimals + ' ' + currency;
        };
        const ratio = (used / ceiling) * 100;
        const percentLabel = Math.round(ratio) + ' %';
        if (used > ceiling) return { hasCeiling: true, state: 'over', percentLabel, note: 'Plafond dépassé de ' + format(used - ceiling) };
        return { hasCeiling: true, state: ratio >= 80 ? 'warn' : 'ok', percentLabel, note: 'Disponible : ' + format(ceiling - used) };
      },

      customerRevenueProgressVariant() {
        if (!this.customerRevenueStatus) return 'primary';
        if (this.customerRevenueStatus.encours >= this.customerRevenueStatus.plafond) return 'danger';
        if (this.customerRevenueProgress >= 80) return 'warning';
        return 'success';
      }

   
  },

  mounted(){

    this.findAccessibleAgencyCurrentCustomer(),

    window.addEventListener('resize', this.onViewportResize, { passive: true });
    window.addEventListener('orientationchange', this.onViewportResize);
    this.observeCartColumn();

    this.pagemodel.perPage = this.cataloguePerPage

    if (this.permission.includes('REPORTING') || this.permission.includes('CUSTOMER_ADMIN') || this.isSupplierAdmin ) {
        this.getCustomerParaLanding();
        this.getCustomePharmaLanding();
    }

    
      //this.role=sessionStorage.getItem("userr");
      this.isAdmin = true;
      /*if(sessionStorage.getItem("privileges")!=null){
        this.privileges=sessionStorage.getItem("privileges")
        this.isAdmin=this.privileges.includes(Priviliges[0]["Admin_Role"] )
      }*/

      this.$root.$on('order-submitted', () => {
          this.$cookies.refresh()
          this.clearAll();
      })

      this.$root.$on('order-changed-event', () => {
        this.$cookies.refresh();
      })

      this.$root.$on('order-cart-modal-closed', () => {
        this.$cookies.refresh();
        this.loadOrderIfAny();
      })

      this.loadOrderIfAny();
    
      this.reference = this.propFilter && (this.propFilter != 'undefined') ? this.propFilter : '';
      this.selectedGroup = this.propGroup && (this.propGroup != 'undefined') ? {id: this.propGroup} : null;
      this.selectedSubGroup = this.propSubGroup && (this.propSubGroup != 'undefined') ? {id: this.propSubGroup} : null;
      
      if(this.role==0) {
          this.findItems()
          this.getCurrentYear()
        }

        if(this.role ==1){
          this.getCustomers()
          this.setSimulatedCustomer()
          // this.findItems()
        }


      // }
      this.getAllBrands()
      this.getAllDci()
      this.getAllItemForms()

      this.getGroups();
      //this.getManufacturers()
      this.getSimulatedCustomer();
      this.findBannerAds()

      this.countSharedDocument()
      this.getCustomerRevenueStatus()

      //this.getNewItems();


  },
     data () {
        return {
          //role:null,
          privileges:"",
         
          isAdmin: true,

            ordersListFields: [
            { key:"submissionDate", label: "Date d'ajout", tdClass:"align-middle font-weight-bold"},
            { key:"extId", label: "Nº BC",thClass:"",tdClass:"align-middle" },
            { key:"submissionUserName", label: "Vendeur",   thClass:" ", tdClass:" align-middle"},
            { key:"total", label:"Total HT",thClass:"text-right d-md-table-cell d-none" , tdClass: "text-right d-md-table-cell align-middle d-none"},
            { key:"isPartial", label: "isPartial",  thClass:"text-right ", tdClass:"align-middle text-right"},
            { key:"status", label: "Etat de livraison",thClass:"text-right" ,tdClass:"text-right align-middle"},
            { key:"actions", label:"",tdClass:"text-center align-middle"},
            ],

            filterConfig: {
              brand:{
                key: "brand",
                label: "Laboratoire",
                legacyLabel: "Filtrer par Laboratoire",
                icon: "fas fa-microscope",
                placeholder: "Laboratoire",
                options: () => this.brandsList,
                model: "selectedBrand"
              },
              dci: {
                key: "dci",
                label: "DCI",
                legacyLabel: "Filtrer par DCI",
                icon: "fas fa-flask",
                placeholder: "Famille",
                options: () => this.dciList,
                model: "selectedDci"
              },
              form: {
                key: "form",
                label: "Forme Pharmaceutique",
                icon: "fas fa-pills",
                placeholder: "Forme Pharmaceutique",
                options: () => this.itemFormList,
                model: "selectedItemForm"
              },
              group: {
                key: "group",
                label: "Classe Thérapeutique",
                legacyLabel: "Filtrer par Classe Thérapeutique",
                icon: "fas fa-capsules",
                placeholder: "Classe thérapeutique",
                options: () => this.groupsList,
                model: "selectedGroup"
              }
            },


          itemsListTimestamp: null,  
          itemsList:[],
          isTableLoading:false,
          isItemsTableBusy:false,
          paginationOptions: [5, 10, 12, 15, 30],
          pagemodel: {currentPage : 1, perPage : 5, totalRows: 0},
          //showDetailsModal:false,
          selectedItem:null,
          
          itemsFilter:null,
          
          selectedBrandName:null,
          selectedBrand:null,
          
          brandsList:[],
          selectedBrandsList:[],

          itemFormList:[],
          selectedItemForm:null,

          dciList:[],
          selectedDci:null,
          
          currentYear:null,

          groupsList: [],
          selectedGroup: null,

          subGroupsList: [],
          selectedSubGroup: null,
          selectedAgency: null,
          pendingSelectedAgency: null,
          agencyList: [],

          displayGrid: true,
          displayDescription: false,
          
          orderLines: [],
          order: {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0, totalBeforeDiscount: 0},    

          panacheItemsData: null,
          showPanacheItemsDataModal: false,
          itemsToOrder: [],
          offeredItems: [],
          gratuityCountRequestId: 0,
          
          quickOrderFields: [
            { key:"ref", sortable: false, thStyle:"width:150px; border:0px;padding: 0px 0px 3px 0px;"},
            { key:"itemTitle", sortable: false, thStyle:"width:480px; border:0px;padding: 0px 0px 3px 0px;"},
            { key:"quantity", sortable: false, tdClass:"text-right", thClass:"text-right", thStyle:"width:90px; border:0px;padding: 0px 0px 3px 0px;"},
            { key:"price", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:120px; border:0px;padding: 0px 0px 3px 0px;"},
            { key:"lineTotalAmount", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:100px; border:0px;padding: 0px 0px 3px 0px;"},
          ],

          orderFields: [
            { key:"itemTitle", sortable: false, tdClass:"p-0"},
            { key:"quantity", sortable: false, tdClass:"text-right", thClass:"text-right", thStyle:"width:65px"},
            { key:"price", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:100px"},
          ],
          draftFields: [
            {key:"actions", label:""},
            { key:"ref", sortable: false, tdClass:"pt-2"},
            { key:"creationDate", sortable: true, tdClass:"text-right pt-2", thClass:"text-right"},
          ],
          draftLines:[],
          draftsPagination: {currentPage : 1, perPage : 10, totalRows: 0},
          isDraftsTableLoading: false,
          showOrdersDetailsModal:false,
          
          selectedPriority: { value: 1, name: 'Normale : livraison J+1' },
          optionsPriorities: [
            { value: 0, name: 'Basse : veuillez selectionner la date de livraison souhaitée' },
            { value: 1, name: "Normale : livraison J+1" },
            { value: 2, name: "Urgente: livraison le jour même"  },
          ],

          orderMessage: '',
          isAddToOrderStarting:false,
          
          reference:null,
         
          
          desiredDeliveryDate:null,
          
          
          isCheckingOrder:false,
          


          filterItemAvailable: false,
          filterItemHasImage: false,
          filterItemHasDescription: false,
          filterDescription: null,
          filterPriceMax: null,
          filterPriceMin: null,
         

          showcard:false,
          cardItem:null,
          selectedDeliveryAddress: null,
          isHomePageRequestData:false,
          isPricesTableLoading:false,
          pricesList:[],
          pricesListFields:[
            { key:"sageId", thClass:"text-left", tdClass:"text-left" },
            { key:"code", thClass:"text-left", tdClass:"text-left" },
            { key:"startDate", thClass:"text-left", tdClass:"text-left" },
            { key:"endDate", thClass:"text-left", tdClass:"text-left" },
            { key:"index", thClass:"text-left", tdClass:"text-left" },
            { key:"priority", thClass:"text-left", tdClass:"text-left" },
            { key:"type", thClass:"text-left", tdClass:"text-left" },
            { key:"export", label:"", thClass:"text-right", tdClass:"text-right" },
          ],
          pricesPagemodel:{currentPage : 1, perPage : 10, totalRows: 0},
          exportPricesInProgress:false,
          customersList:[],
          customerLandingPharmaList:null,
          customerLandingParaList:null,
          customerTurnover:{},
          selectedCustomer:null,

          
          isReferenceSearchActif: true,

          ordersByItemList: [],
          pagemodelOrdersByItem: {currentPage : 1, perPage : 5, totalRows: 0},
          isOrdersByItemTableLoading: null,

          quantityInfo: {},

          // showAddClaimModal: false,
          // selectedClaimType: null,
          // optionsClaimType: [],
          // claimMessage: null,

          showMobileFilter: false,
          itemAttributes: [],


          showHistoryModal: false,

          customerOutstandingInfo: {inProgressStr: null},
          customerRevenueStatus: null,
          isCustomerRevenueStatusLoading: false,



          isSimilairItemsTableBusy:false,
          similairItemsList:[],
          similairItemsPagemodel: {currentPage : 1, perPage : 5, totalRows: 0},

          isKitItemsTableBusy:false,
          kitItemsList:[],
          kitItemsPagemodel: {currentPage : 1, perPage : 5, totalRows: 0},


          bannerSliderSettings: {
            "dots": true,
            "dotsClass": "slick-dots banner-dots",
            "arrows": true,
            "adaptiveHeight": true,
            "fade": false,
            "infinite": true,
            "speed": 600,
            "cssEase": "cubic-bezier(0.25, 0.8, 0.25, 1)",
            "autoplay": true,
            "autoplaySpeed": 5000,
            "slidesToShow": 1,
            "slidesToScroll": 1,
            "swipe": true,
            "touchThreshold": 8,
            "pauseOnHover": true,
            "pauseOnDotsHover": true,
            "pauseOnFocus": true
          },
          newItemsSettings: {
            "dots": false,
            "dotsClass": "slick-dots custom-dot-class",
            "edgeFriction": 0.35,
            "infinite": true, 
            "speed": 1500,
            "autoplaySpeed": 3500,
            "autoplay": true,
            "slidesToShow": 4,
            "slidesToScroll": 1,

            "swipe": true,

            //"fade": true,
            "arrows": true,

            "responsive": [
              {
                "breakpoint": 1024,
                "settings": {
                  "slidesToShow": 4,
                  "slidesToScroll": 1,
                }
              },
              {
                "breakpoint": 600,
                "settings": {
                  "slidesToShow": 2,
                  "slidesToScroll": 2,
                  "initialSlide": 2
                }
              },
              {
                "breakpoint": 480,
                "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1
                }
              }
  ]

          },

          newItems: null,
          searchInNewItemsOnly: false,
          searchInNewItemsLast24Only: false,
          searchInNewCreationsOnly: false,
          searchInItemsWithGratuitiesOnly: false,
          searchInItemsWithControlledSalesOnly: false,
          searchInItemsWithRepartitionSalesOnly: false,
          searchInWebNouvEntrePara: false,
          searchInWebNouvLancementPara: false,

          searchPharmaOnly: false,
          searchParaOnly: false,

          orderErrors: null,

          bannerAdsList:null,
          showRequiredBannerModal:false,
          requiredBannerIndex:0,
          showImageModal:false,
          isQuickOrder:false,
          quickOrderCsvImporting: false,
          quickOrderCsvImportErrors: [],
          collapsed: false ,
          viewportWidth: window.innerWidth,
          isMobileCatalog: false,
          isPhone: this.isPhoneDevice(),
          mobileCatalogTitleWidth: 220,
          mobileCatalogDecidedWidth: null,
          cartInView: false,

          icons: [
            { src: require('@/assets/images/double-arrow-left.svg'), title: 'COMMANDE', height: '17px' },
            { src: require('@/assets/images/pills.svg'), title: 'MEDICALE', height: '21px' },
            { src: require('@/assets/images/stethoscope.svg'), title: 'PARA', height: '21px' },
            { src: require('@/assets/images/rule-draft.svg'), title: 'BROUILLONS', height: '21px' },
          ],
          activeTabIndex: 0,
          sharedDocumentbyType: [],
          seletedDocumentType: null,
          showSharedDocumentsModal: false,


          quickOrderRefreshKey: 0

        };
     },

  created() {
    this.collapsed = this.isCollapseCartBox;
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onViewportResize);
    window.removeEventListener('orientationchange', this.onViewportResize);
    if (this.cartObserver) this.cartObserver.disconnect();
    clearTimeout(this.mobileCatalogTimer);
  },

  methods:{

    getAgencyValue(agency) {
      if (!agency) {
        return null;
      }
      const value = agency.id || agency.dbAgencyId || agency.value || agency.code || agency;
      return value == null ? null : String(value);
    },

    getAgencyName(agency) {
      if (!agency) {
        return '';
      }
      return agency.name || agency.label || agency.id || agency.dbAgencyId || agency.value || agency.code || agency;
    },

    getAgencyById(agencyId) {
      const selectedAgencyId = agencyId == null ? null : String(agencyId);
      return this.agencyList.find(item => this.getAgencyValue(item) === selectedAgencyId);
    },

    getAgencyNameById(agencyId) {
      const agency = this.getAgencyById(agencyId);
      return agency ? this.getAgencyName(agency) : '';
    },

    getAgencyRgbColorById(agencyId) {
      const agency = this.getAgencyById(agencyId);
      const rgbColor = agency && agency.rgbColor ? String(agency.rgbColor).trim() : '';
      return /^\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}$/.test(rgbColor) ? rgbColor : '0, 122, 51';
    },

    getFeatureAgencyValue(agency) {
      if (!agency) {
        return null;
      }
      const value = agency.id || agency.value || agency.dbAgencyId || agency.code || agency.dbId || agency.agence || agency;
      return value == null ? null : String(value);
    },

    getFeatureAgencyName(agency) {
      if (!agency) {
        return '';
      }
      return agency.name || agency.label || agency.text || agency.title || agency.cityName || this.getFeatureAgencyValue(agency);
    },

    getOrderAgencyName(dbId) {
      const agencyId = dbId == null ? null : String(dbId);
      if (!agencyId) {
        return '';
      }
      const featureAgency = this.featureAgencyList.find(agency => this.getFeatureAgencyValue(agency) === agencyId);
      if (featureAgency) {
        return this.getFeatureAgencyName(featureAgency);
      }
      return this.getAgencyNameById(agencyId) || agencyId;
    },


    isAccessibleAgencyValue(agencyId) {
      const value = this.getAgencyValue(agencyId);
      return value != null && this.agencyList.some(agency => this.getAgencyValue(agency) === value);
    },
    confirmAgencyChange() {
      if (!this.canRequestAgencyChange) {
        return;
      }

      this.newOrder();
      this.selectedAgency = this.pendingSelectedAgency;
    },

    cancelAgencyChange() {
      this.pendingSelectedAgency = this.getAgencyValue(this.selectedAgency);
    },

    onViewportResize() {
      this.viewportWidth = window.innerWidth;
      this.isPhone = this.isPhoneDevice();
    },

    // the cart column is v-if'd: (re)attach the observer whenever it is (re)rendered
    observeCartColumn() {
      if (this.cartObserver) { this.cartObserver.disconnect(); this.cartObserver = null; }
      this.$nextTick(() => {
        const el = this.$refs.cartColumn;
        this.cartInView = false;
        if (!el || typeof window.IntersectionObserver === 'undefined') return;
        // "in view" = the cart fills at least half of the screen (or is entirely visible): a sliver of a tall cart
        // at the bottom of the page must not hide the shortcut
        const steps = Array.from({ length: 21 }, (_, i) => i / 20);
        this.cartObserver = new IntersectionObserver((entries) => {
          this.cartInView = entries.some(e => e.isIntersecting &&
            e.intersectionRect.height >= Math.min(e.boundingClientRect.height, window.innerHeight) * 0.5);
        }, { threshold: steps });
        this.cartObserver.observe(el);
      });
    },

    // mobile line: stock is shown only when CatalogStockStatus has something to say (3 / unknown render "_")
    hasMobileStock(item) {
      return [0, 1, 2, 4, 5, 6, 7].includes(Number(item.stockStatus)) && item.stockStatus !== null && item.stockStatus !== undefined && item.stockStatus !== '';
    },

    gratuitiesWithStartingFrom(item) {
      return Array.isArray(item && item.gratuities)
        ? item.gratuities.filter(gratuity =>
            Number(gratuity && (gratuity.startingFrom ?? 0)) > 0
          )
        : [];
    },

    formatGratuityOffer(gratuity) {
      return `${gratuity.gratuity} +${gratuity.gratuityGranted}`;
    },

    gratuitiesWithoutStartingFrom(item) {
      return Array.isArray(item && item.gratuities)
        ? item.gratuities.filter(gratuity =>
            Number(gratuity && (gratuity.startingFrom ?? 0)) <= 0
          )
        : [];
    },
    formatGratuityStartingFrom(gratuity) {
      return `(${String.fromCharCode(8805)} ${gratuity.startingFrom})`;
    },
    // phones only: touch screen whose short side is under 600px (tablets and small desktops never qualify)
    isPhoneDevice() {
      const coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      return !!coarse && Math.min(window.screen.width, window.screen.height) < 600;
    },

    // VUE_APP_FEATURE_MOBILE_CATALOG, phones only: render the normal grid, then switch to the mobile layout only if the
    // add-to-cart cell ends past the visible part of the grid (the user would have to scroll sideways to order).
    // Cached per viewport width so a new search does not flash the normal grid again.
    evaluateMobileCatalog(force) {
      if (!this.isMobileCatalogEnabled || !this.isPhoneDevice()) { this.isMobileCatalog = false; return; }
      if (!force && this.mobileCatalogDecidedWidth === this.viewportWidth) return;
      this.isMobileCatalog = false;
      this.$nextTick(() => {
        const table = this.$refs.catalogTable && this.$refs.catalogTable.$el;
        const cell = table && table.querySelector('tbody td.cat-action');
        if (!cell) { this.mobileCatalogDecidedWidth = null; return; }   // no rows yet: decide when items arrive
        let box = cell.parentElement;
        while (box && box !== document.body && !/(auto|scroll|hidden)/.test(getComputedStyle(box).overflowX)) box = box.parentElement;
        const boxRight = box && box !== document.body ? box.getBoundingClientRect().right : window.innerWidth;
        this.isMobileCatalog = cell.getBoundingClientRect().right > Math.min(boxRight, window.innerWidth) + 2;
        // designation = the whole visible grid width (minus the cell padding). Measures are in screen pixels but
        // min-width is applied in CSS pixels under .zoom-container's zoom (60% between 500 and 800px): divide by it
        let zoom = 1;
        for (let el = cell; el; el = el.parentElement) { const z = parseFloat(getComputedStyle(el).zoom); if (z > 0) zoom *= z; }
        const boxLeft = box && box !== document.body ? Math.max(box.getBoundingClientRect().left, 0) : 0;
        const visible = Math.floor(Math.min(boxRight, window.innerWidth) - boxLeft);
        this.mobileCatalogTitleWidth = Math.max(200, Math.floor((visible - 26 * zoom) / zoom));
        if (this.isMobileCatalog) this.$nextTick(() => this.fitMobileCatalogTitle(visible));
        this.mobileCatalogDecidedWidth = this.viewportWidth;
      });
    },

    // second pass for browsers that report zoom differently: scale the min-width by what actually rendered
    fitMobileCatalogTitle(visible) {
      const table = this.$refs.catalogTable && this.$refs.catalogTable.$el;
      const th = table && table.querySelector('th.m-title');
      const rendered = th && th.getBoundingClientRect().width;
      if (!rendered || rendered >= visible - 40 || rendered > visible) return;
      this.mobileCatalogTitleWidth = Math.floor(this.mobileCatalogTitleWidth * (visible - 26) / rendered);
    },

    scrollToCart() {
      const el = this.$refs.cartColumn;
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },

    getCustomerRevenueStatus() {

      if(!this.isCustomerRevenueStatusEnabled){
        return
      }

      if(this.role == 0 && !this.permission.includes('CUSTOMER_ADMIN') ){
        return
      }

      // a laboratory / partner account must not see the simulated pharmacy's credit: the server refuses it
      // (authenticateCustomer) and the card stays hidden while customerRevenueStatus is null
      if(this.isPartner){
        this.customerRevenueStatus = null;
        return
      }

      // un appel est déclenché à chaque mutation du panier et chacun fait un
      // aller-retour ERP (PWEB_CA_MOIS) : inutile d'en empiler plusieurs
      if(this.isCustomerRevenueStatusLoading){
        return
      }

      this.isCustomerRevenueStatusLoading = true;
      return CustomersApi.getCustomerRevenueStatus()
        .then(status => { this.customerRevenueStatus = status || null; })
        .finally(() => { this.isCustomerRevenueStatusLoading = false; });
    },

    advancedSearch() {
      this.reference = this.reference
        .trim()
        .split(/\s+/)
        .map(word => `%${word.replace(/^%+/, '')}`)
        .join(" ");

      this.resetPagination();
      this.findItems();
    },

    openSharedDocumentModal(item) {
      this.seletedDocumentType = item.type;
      this.showSharedDocumentsModal = true;
    },

    getLabelByType(type) {
      switch(type) {
        case 0: return "Nos Packs";
        case 1: return "Catalogues Fournisseurs";
        default: return "-";
      }
    },

      countSharedDocument(){
        sharedDocumentsApi.countSharedDocument().then((result) => {
            this.sharedDocumentbyType = result;
        }).catch(() => {
            this.sharedDocumentbyType = null;
        })
      },

    toggleCollapse(index) {
      if (index === 3) {
        this.getDrafts()
        this.activeTabIndex = 1
      }else{
        this.activeTabIndex = 0
      }

        this.collapsed = !this.collapsed;
    },
    newOrder(){
      this.orderLines= [],
      this.order= {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0, totalBeforeDiscount: 0}
    },

    refreshItemList(perPage ,pageSize){

      this.pagemodel.pageSize = pageSize,
      this.pagemodel.perPage = perPage,

      this.findItemsByReference()

    },

    openImageModal(item){
      if(item && item.image){
        this.selectedItem = item
        this.showImageModal = true
      }

    },

    findBannerAds(){
      const ignorePagination= true
      const isCatalogBannerAds= true ;
      BannerApi.getBannersAds(1 ,10,ignorePagination,isCatalogBannerAds)
        .then((result) => {
          if(result){
              this.bannerAdsList=result.list;
              this.openRequiredBannerIfUnseen();
          }
        })
    },

    getSeenBannerIds() {
      try {
        const raw = getCookie('seenBannerAds');
        const ids = raw ? JSON.parse(decodeURIComponent(raw)) : [];
        return Array.isArray(ids) ? ids : [];
      } catch (e) {
        return [];
      }
    },
    openRequiredBannerIfUnseen() {
      if (!this.isRequiredBannerAds || !this.bannerAdsList || !this.bannerAdsList.length) return;
      const seen = this.getSeenBannerIds();
      if (this.bannerAdsList.some(b => !seen.includes(b.id))) {
        this.requiredBannerIndex = 0;
        this.showRequiredBannerModal = true;
      }
    },
    nextRequiredBanner() {
      if (!this.isRequiredBannerLast) this.requiredBannerIndex++;
    },
    finishRequiredBanner() {
      const ids = this.bannerAdsList.map(b => b.id);
      const expires = new Date(Date.now() + 24 * 3600 * 1000).toUTCString();
      document.cookie = 'seenBannerAds=' + encodeURIComponent(JSON.stringify(ids)) + '; expires=' + expires + '; path=/; SameSite=Lax';
      this.showRequiredBannerModal = false;
    },
    isFilterActive() {
      return this.selectedBrandsList.length  || this.reference  ||
                this.selectedGroup  || 
                this.selectedSubGroup  ||
                this.filterItemAvailable  ||
                this.filterItemHasImage  ||
                this.filterItemHasDescription  ||
                this.filterPriceMin  ||
                this.filterPriceMax  ||
                this.filterDescription  ;
    },

    getCurrentYear(){
        var dt = new Date();
        this.currentYear  = dt.getFullYear();
    },

    loadOrderIfAny() {

      this.$cookies.refresh();
      if (!this.draftOrderId) {
        this.clearOrder();
      }

      if(this.role == 1 && !this.selectedCustomer) {
        this.clearOrder();
        return;
      } 

      if (this.draftOrderId) {
        OrdersApi.getOrder(this.draftOrderId).then(
          result => {
            if (result){
              if (result.status == 0) {
                this.order=result;
                this.orderLines = this.order.lines;
              }

            }
            this.$root.$emit('order-changed-event', this.order.lines ? this.order.lines.length : 0)
          }
        )
      }

      // OrdersApi.getLastDraft().then(
      //     result => {
      //       if (result){
      //         this.order=result;
      //         this.orderLines = this.order.lines;
      //       }
      //       this.$root.$emit('order-changed-event', this.order.lines ? this.order.lines.length : 0)
      //     }
      //   )        
    },

    findItemsByReference() {

        //empty similar
        this.cardItem = null;
        this.similairItemsList=[];
        this.kitItemsList=[],
        this.similairItemsPagemodel= {currentPage : 1, perPage : 5, totalRows: 0};

        if(this.filterPriceMax != null && this.filterPriceMin != null && parseInt(this.filterPriceMax) < parseInt(this.filterPriceMin)) {
          this.filterPriceMin = null;
        }

        this.selectedBrandsList=[];
        if (this.selectedBrand) {
          this.selectedBrandsList.push(this.selectedBrand.id);
        
        }
        

        this.isTableLoading = true;
        this.itemsListTimestamp = new Date().getTime();
        ItemsApi.findItems(this.pagemodel.currentPage, this.pagemodel.perPage, this.selectedBrandsList == null ? null : this.selectedBrandsList, this.reference, 
                this.selectedGroup == null ? null : this.selectedGroup.id, 
                this.selectedSubGroup == null ? null : this.selectedSubGroup.id, 
                this.filterItemAvailable == null ? null : this.filterItemAvailable, 
                this.filterItemHasImage == null ? null : this.filterItemHasImage,
                this.filterItemHasDescription == null ? null : this.filterItemHasDescription,
                !this.filterItemHasDescription == null || !this.filterDescription ? null : this.filterDescription,
                this.filterPriceMin == null ? null : this.filterPriceMin,
                this.filterPriceMax == null ? null : this.filterPriceMax,
                

                this.selectedItemForm == null ? null : this.selectedItemForm.id,
                this.selectedDci == null ? null : this.selectedDci.id ,

                this.searchInNewItemsOnly == null ? null : this.searchInNewItemsOnly,
                this.searchInNewItemsLast24Only == null ? null : this.searchInNewItemsLast24Only,
                
                this.searchInNewCreationsOnly == null ? null : this.searchInNewCreationsOnly,
                this.searchInItemsWithGratuitiesOnly == null ? null : this.searchInItemsWithGratuitiesOnly,
                this.searchInItemsWithControlledSalesOnly == null ? null : this.searchInItemsWithControlledSalesOnly,

                this.searchParaOnly == null ? null : this.searchParaOnly,
                this.searchPharmaOnly == null ? null : this.searchPharmaOnly,

                this.itemsListTimestamp,
                this.searchInItemsWithRepartitionSalesOnly == null ? null : this.searchInItemsWithRepartitionSalesOnly,
                
                this.searchInWebNouvLancementPara == null ? null : this.searchInWebNouvLancementPara,
                this.searchInWebNouvEntrePara == null ? null : this.searchInWebNouvEntrePara,
                this.selectedAgency == null ? null : this.selectedAgency,


                )

        .then(itemsList => {

          if(itemsList){

             if (itemsList.requestTimestamp && itemsList.requestTimestamp != this.itemsListTimestamp) {
              console.log('old request ignored')
              return;
            }

            this.itemsList = itemsList.list
            this.pagemodel.totalRows = itemsList.total;
            this.pagemodel.currentPage = itemsList.page;
            this.pagemodel.perPage = itemsList.pageSize;
            this.pagemodel.pageSize = itemsList.pageSize;
            this.itemsList.forEach(function(item){
                item.quantity = item.repartitionQuantity && item.repartitionQuantity > 0 ? item.repartitionQuantity : 1;
            });   
                    
            if(this.isAdvancedSearchEnable && this.itemsList.length == 0 && !this.allWordsBeginWithPercent && this.reference && this.reference.trim() != '') {
                this.advancedSearch();
            }

          } else {

            this.itemsList = []
            this.pagemodel.totalRows = 0;
            this.pagemodel.currentPage = 1;
            this.pagemodel.perPage = this.paginationOptions[0];
            this.pagemodel.pageSize = this.paginationOptions[0];

          }
        })
        .finally(() => {
        this.isTableLoading = false;
        this.goTopPage();

      })

    },

    goTopPage() {
       //window.scrollTo({top: 0,left: 0,behavior: 'smooth'});
    },

     statusToColor(status) {
      switch(status) {
        case 0: return 'secondary';
        case 1: return 'danger';
        case 2: return 'warning';
        case 3: return 'success';
        case 4: return 'secondary';
        default: return 'black';
      }
    },

     statusToLabel(status) {
      switch(status) {
        case 0: return 'draft';
        case 1: return 'new';
        case 2: return 'confirmed';
        case 3: return 'delivered';
        case 4: return 'canceled';
        default: return '_';
      }
    },

  

   

    // a suggestion under the catalogue search: show that article in the catalogue
    onCatalogSuggestionPick(item){
      this.reference = item.ref;
      this.resetPagination();
      this.findItems();
    },

    findItems(){

      //this.showMobileFilter = false;
      this.findItemsByReference(); 
    },

    getNewItems(){
      ItemsApi.getNewItems(this.selectedAgency).then(
        (result)=>{
          this.newItems=result;
        }
      )
    },

    getGroups(){
      ItemsApi.getGroups().then(
        (result)=>{
          this.groupsList=result;

          if (this.propGroup) {
            for (var i=0; i< this.groupsList.length; i++) {
                if (this.groupsList[i].id == this.propGroup) {
                   this.selectedGroup = this.groupsList[i];
                   return;
                }
            }
          }

          this.selectedGroup = null;
        }
      )
    },

    getSubGroups(){
      
      if (this.selectedGroup == null) {
        return;
      }

      ItemsApi.getSubGroups(this.selectedGroup).then(
        (result)=>{
          this.subGroupsList=result;

          if (this.propSubGroup) {
            for (var i=0; i< this.subGroupsList.length; i++) {
                if (this.subGroupsList[i].id == this.propSubGroup) {
                   this.selectedSubGroup = this.subGroupsList[i];
                   return;
                }
            }
          }
        }
        )
        this.selectedSubGroup = null;
      },
   
    getAllBrands(){
        ItemsApi.getAllBrands().then(
            result => {
              if(result) {
                this.brandsList=result;
              }
                
            }
        )
    },

    getAllDci(){
        ItemsApi.getAllDci().then(
            result => {
              if(result) {
                this.dciList=result;
              }
                
            }
        )
    },

    getAllItemForms(){
        ItemsApi.getAllItemForms().then(
            result => {
              if(result) {
                this.itemFormList=result;
              }
                
            }
        )
    },

    checkOrder(){

      this.orderErrors = null;

      this.isCheckingOrder=true
      OrdersApi.checkOrder(this.order.id, this.orderMessage, 
      this.selectedPriority==null ? null : this.selectedPriority.value, 
      this.selectedDeliveryAddress==null ? null : this.selectedDeliveryAddress.id,
      false,this.desiredDeliveryDate,this.promotionCode).then(
        (result)=>{
          if(result){
            this.showOrdersDetailsModal =true
          }
        }
      ).finally(
        ()=>{
          this.isCheckingOrder=false
        }
      )
      
      .catch(error => {  this.orderErrors = error;  /* console.log(error); return false; */ /*Vue.prototype.$snotify.error(error); return false;*/})

    },

    validateDetails(){
      this.showOrdersDetailsModal=false;  
    },

    
    handleRemovePanacheItem(error){
      this.showOrdersDetailsModal =false;
      this.handlePanacheItemsError(error);
    },

    handleUpdatePanacheItem(error){
      this.showOrdersDetailsModal =false;
      this.handlePanacheItemsError(error);
    },

    handlePanacheItemsError(error) {

      if (error?.status === 428) {
      
        const data = error?.data || {};
        const normalize = item => ({ ...item, note: item?.note || "" });

        this.panacheItemsData = data;
        this.itemsToOrder = Array.isArray(data.itemsToOrder) ? data.itemsToOrder.map(normalize) : [];
        this.offeredItems = Array.isArray(data.offeredItems) ? data.offeredItems.map(normalize) : [];
        this.showPanacheItemsDataModal = this.itemsToOrder.length > 0 && this.offeredItems.length > 0;
        
      }
    },

    addToOrder(data) {

      this.$cookies.refresh();
      if (!this.draftOrderId) {
        this.orderLines=[]
        this.order= {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0, totalBeforeDiscount: 0};
      }
      

      this.activeTabIndex = 0;
      this.isAddToOrderStarting=true
      // if(!data.isQuantityChanged && data.quantity==0){
      //   data.quantity=1
      //   data.isQuantityChanged=true
      // }
      OrdersApi.addLineToOrder(this.order.id, data.id, data.quantity,null,false,'CATALOG',  this.selectedAgency) 
      .then(order => {
          if(order) {
            this.orderLines = order.lines;
            this.order = order; 
            this.getCustomerRevenueStatus();

            this.reference = null;
            // focus back on the search field, except on phones (it pops the keyboard and scrolls the page back to the top)
            if (!this.isPhoneDevice()) {
              var referenceSearchInput = document.getElementById("reference-search-input");
              if (referenceSearchInput) {
                referenceSearchInput.focus();
              }
            }
          }
        })
        .then(()=>{
          this.isAddToOrderStarting=false
        })
        .catch((error) => {
          this.handlePanacheItemsError(error);
        })
        .finally(()=>{
          this.isAddToOrderStarting=false
        })
    },

    editOrderLine(item){
      OrdersApi.editLineToOrder(this.order.id, item.itemId, item.editedQuantity, this.selectedSupplier, this.selectedPromotion,false) 
      .then(order => {
        if(order) {
          this.orderLines = order.lines;
          this.order = order; 
          this.getCustomerRevenueStatus();
        }
      }).catch((error) => {
          this.handlePanacheItemsError(error);
        })
      .finally(() => {
        item.isOrderQuantityEdit = false

      }) 

      
    },

    removeOrderLine(item){
        Swal.fire({
        title: i18n.t('order.alerts.delete.title'),
        html: item.itemTitle,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('order.alerts.delete.cancelButtonText'),
        confirmButtonText:  i18n.t('order.alerts.delete.confirmButtonText')
      }).then(result => {
        if (result.value) {
          OrdersApi.removeOrderLine(this.order.id, item.itemId,this.selectedSupplier,false)
          .then(order => {
            if (!order) {
              this.clearAll()
            } else {
              this.orderLines = order.lines;
              this.order = order;
              this.getCustomerRevenueStatus();
            }
          }).catch((error) => {
              this.handlePanacheItemsError(error);
          });
        }
      })
    },

    refresh(draftId){
      this.findOrderLines(draftId)
    },

    getOrderLines(draft){
       this.activeTabIndex = 0;
        this.findOrderLines(draft.id)
    },

    findOrderLines(draftId){
      OrdersApi.getOrderLines(draftId).then(
          order => {
            if (order){
              this.orderLines=order.lines
              this.order=order
              this.getCustomerRevenueStatus()
            }

          }
        )
    },

    cancelOrder(){
        Swal.fire({
        title: 'Annuler le bon de commande ?' /*i18n.t('order.alerts.deleteDraft.title')*/,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        cancelButtonText:  'Non', //i18n.t('order.alerts.deleteDraft.cancelButtonText'),
        confirmButtonText: 'Oui, supprimer'//i18n.t('order.alerts.deleteDraft.confirmButtonText'),
      }).then(result => {
        if(result.value){
          OrdersApi.removeDraft(this.order).then(
            isRemoved => {
              if (isRemoved) {
                  this.clearAll();
              }
            }
          )
        }
      })
    },

    getDraftMethode(){

      console.log("isPartner", this.isPartner)
      if(this.isPartner){
        this.getDraftOrdersByCurrentUser()
       }else{
        this.getDrafts()
      }
    },

    getDrafts(){
      this.isDraftsTableLoading=true
      OrdersApi.getOrdersByCustomer(this.draftsPagination.currentPage, this.draftsPagination.perPage,null, true,0,this.isCurrent,null,null, null,null)
      .then(drafts => {
        if(drafts){
        this.draftLines = drafts.list
        this.draftsPagination.totalRows = drafts.total;
        this.draftsPagination.currentPage = drafts.page;
        this.draftsPagination.perPage = drafts.pageSize;
        this.draftsPagination.pageSize = drafts.pageSize;
        }

      })

      .finally(() => {
        this.isDraftsTableLoading=false 
      })
    },

    getDraftOrdersByCurrentUser(){
      this.isDraftsTableLoading=true
      OrdersApi.getDraftOrdersByCurrentUser(this.draftsPagination.currentPage, this.draftsPagination.perPage)
      .then(drafts => {
        if(drafts){
        this.draftLines = drafts.list
        this.draftsPagination.totalRows = drafts.total;
        this.draftsPagination.currentPage = drafts.page;
        this.draftsPagination.perPage = drafts.pageSize;
        this.draftsPagination.pageSize = drafts.pageSize;
        }

      })

      .finally(() => {
        this.isDraftsTableLoading=false 
      })
    },

    removeDraft(draft){
        Swal.fire({
        title: i18n.t('order.alerts.deleteDraft.title'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('order.alerts.deleteDraft.cancelButtonText'),
        confirmButtonText: i18n.t('order.alerts.deleteDraft.confirmButtonText')
      }).then(result => {
        if(result.value){
          OrdersApi.removeDraft(draft).then(
            isRemoved => {
              if (isRemoved) {
                 this.getDrafts()
                 this.clearAll();
              }
            }
          )
        }
      })
    },

    findTheNewItem(newItemRef) {
      this.reference=newItemRef;

      this.selectedBrandsList = null;
      this.selectedGroup = null;
      this.selectedSubGroup = null;
      this.selectedBrand = null;
      this.filterItemAvailable = null;
      this.filterItemHasImage = null;
      this.filterItemHasDescription = null;
      this.filterItemHasDescription = null;
      this.filterPriceMin = null;
      this.filterPriceMax = null;
      this.selectedItemForm = null;
      this.selectedDci = null;

      this.findItems();
    },

    clearAll(){
      
      this.clearOrder()

        if (this.role != 0) {

          this.selectedCustomer = null;

          this.selectedBrand = null;
          this.selectedGroup = null;
          this.selectedSubGroup = null;

          this.reference = null;
        }

        
    },

    clearOrder() {
        this.orderLines=[]
        this.order= {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0, totalBeforeDiscount: 0};

        //these cookies are written without a domain (host-only), they must be expired the same way
        document.cookie = 'drafto' + '=; Max-Age=0; path=/';
        document.cookie = 'draftoc' + '=; Max-Age=0; path=/';

        this.quickOrderCsvImportErrors = []
        this.quickOrderRefreshKey++;
    },

    getItemsOEMs(){
      this.isGettingOemsStarting=true
      ItemsApi.getItemsOEMs(this.selectedItem==null ? null : this.selectedItem.id).then(
        (result)=>{
          this.selectedItemOEMsList=result
        }
      ).finally(
        ()=>{
          this.isGettingOemsStarting=false
        }
      )

    },
    getItemsManufacturers(){
      this.isGettingItemsManufacturersStarting=true;
      this.selectedItemManufacturersList=[]
      ItemsApi.getItemsManufacturers(this.selectedItem==null ? null : this.selectedItem.id).then(
        (result)=>{
          this.selectedItemManufacturersList=result
        }
      ).finally(
        ()=>{
          this.isGettingItemsManufacturersStarting=false
        }
      )
    },

    scrollToCard(){
      var elmnt = document.getElementById("similairItemsCard");
      elmnt.scrollIntoView(true); 
    },



    closeOrderModal(){
        this.showOrdersDetailsModal=false
        this.clearAll();
    },

    downloadPaymentConditions(){
      CustomersApi.downloadPaymentConditions()
    },

    resetPagination(){
          this.pagemodel.currentPage = 1;
    },

    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
          response => {
          this.customersList=response;
          }
      )
    },

    getCustomerParaLanding(){
      const type = "PARA"
      ReportingApi.getCustomerLanding(type).then(
          response => {
          this.customerLandingParaList=response;
          } 
      )
    },
    
    getCustomePharmaLanding(){
      const type = "PHARMA"
      ReportingApi.getCustomerLanding(type).then(
          response => {
          this.customerLandingPharmaList=response;
          } 
      )
    },

    setSimulatedCustomer(){

      this.selectedAgency = null
      
      UsersApi.setSimulatedCustomer(this.selectedCustomer==null ? null : this.selectedCustomer.id).then(
        (result)=>{

          if(result){
            this.resetVariables()
            this.findItems()

            this.clearOrder();
            
            this.loadOrderIfAny();
            this.customerLandingPharmaList = null
            this.customerLandingParaList = null

            if ( this.isPartner == false && this.isSupplierAdmin ){
            this.getCustomePharmaLanding()
            this.getCustomerParaLanding()
            }

            this.getCustomerRevenueStatus()
            this.$store.dispatch('notification/getNotifications', {page: 1,pageSize: 3});

            this.findAccessibleAgencyCurrentCustomer()
          } else {

            this.clearAll();
          }
        }
      )
    },

    getSimulatedCustomer(){
      UsersApi.getSimulatedCustomer().then(
        (result)=>{
          if(result){
            this.selectedCustomer=result
          }
        }
      )
    },

    resetVariables(){

          this.orderLines= []
          this.order= {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0, totalBeforeDiscount: 0}          
          this.draftLines=[]
          this.draftsPagination= {currentPage : 1, perPage : 10, totalRows: 0}
          this.isDraftsTableLoading= false
          this.showOrdersDetailsModal=false
          this.orderMessage= ''
          this.isAddToOrderStarting=false
          this.desiredDeliveryDate=null
          this.isCheckingOrder=false
          this.promotionCode=null
          this.selectedDeliveryAddress =null
          //this.$refs['orderLines-tab'].activate();
    },

    findOrdersByItem(itemRef) {

      this.isOrdersByItemTableLoading = true

      OrdersApi.findOrdersByItem(this.pagemodelOrdersByItem.currentPage, this.pagemodelOrdersByItem.perPage, itemRef)
      .then(orders => {
        if(orders){
          this.ordersByItemList = orders.list
          this.pagemodelOrdersByItem.totalRows = orders.total;
          this.pagemodelOrdersByItem.currentPage = orders.page;
          this.pagemodelOrdersByItem.perPage = orders.pageSize;
          this.pagemodelOrdersByItem.pageSize = orders.pageSize;

        }

      })

      .finally(() => {
        this.isOrdersByItemTableLoading=false 
      })

    },

    getRelatedItems(items){
      this.getSimilairItems(items) ;
      this.getRecommendedItemslist(items)

    },

    findAccessibleAgencyCurrentCustomer(){
      CustomersApi.findAccessibleAgencyCurrentCustomer()      
      .then(
        (result)=>{
          if(result){
              this.agencyList = result.agenceSecondary || []
              const defaultAgency = this.getAgencyValue(result.agence);
              this.selectedAgency = defaultAgency
              this.pendingSelectedAgency = defaultAgency
            }
        }
      ).finally(() => {
        this.isSimilairItemsTableBusy = false;

      })
    },


    getSimilairItems(items){

      if(items.length == 0) {
        return;
      }

      var item = items[0];


      this.cardItem=item
      this.showcard=true
      
      //this.scrollToCard()
      
      this.isSimilairItemsTableBusy=true
      ItemsApi.getSimilairItems(this.similairItemsPagemodel.currentPage,
                                this.similairItemsPagemodel.perPage,
                                item==null ? null : item.id,
                                this.selectedAgency == null ? null : this.selectedAgency
                              )
      .then(
        (result)=>{
          if(result){
            this.similairItemsList = result.list
            this.similairItemsPagemodel.totalRows = result.total;
            this.similairItemsPagemodel.currentPage = result.page;
            this.similairItemsPagemodel.perPage = result.pageSize;
            this.similairItemsPagemodel.pageSize = result.pageSize;
            this.similairItemsList.forEach(function(item){
                item.quantity = 1;
            });          
            }
        }
      ).finally(() => {
        this.isSimilairItemsTableBusy = false;

      })
    },

    getRecommendedItemslist(items){
  
        if(items.length == 0 || !this.recommandationItemFeatureIsEnable) {
          return;
        }

        var item = items[0];


        this.cardItem=item
        this.showcard=true

        //this.scrollToCard()

        this.isKitItemsTableBusy=true
        ItemsApi.getRecommendedItemslist(this.kitItemsPagemodel.currentPage,
                                          this.kitItemsPagemodel.perPage,
                                          item==null ? null : item.ref,
                                          this.selectedAgency == null ? null : this.selectedAgency
                                        )
                                          
        .then(
          (result)=>{
            if(result){
              this.kitItemsList = result.list
              this.kitItemsPagemodel.totalRows = result.total;
              this.kitItemsPagemodel.currentPage = result.page;
              this.kitItemsPagemodel.perPage = result.pageSize;
              this.kitItemsPagemodel.pageSize = result.pageSize;
              this.kitItemsList.forEach(function(item){
                  item.quantity = 1;
              });          
              }
          }
        ).finally(() => {
          this.isKitItemsTableBusy = false;

        })
    },


    getReferences(order) {

        if (!order || !order.lines) {
            return []
        }

        return [...new Set(
            order.lines
                .map(line => line.ref)
                .filter(ref => ref)
        )]
    },

    handleValidatePanacheOffer(){
        OrdersApi.submitPanacheOffer(this.order.id, this.itemsToOrder, this.offeredItems, this.selectedAgency)
        .then(order => {  
          if(order) {
            this.orderLines = order.lines;
            this.order = order; 
            this.showPanacheItemsDataModal = false

            // the quick-order component only exists in Saisie rapide mode: from the catalogue this threw after every panaché
            if (this.$refs.quickOrder) this.$refs.quickOrder.refreshErrorLines(this.getReferences(order))
          }
        })
    }

    // submitClaimMissingItem(itemRef) {

    //   if (!itemRef) {
    //      return
    //   }

    //   Swal.fire({
    //     title: "<h4 style='margin-top:20px;'> Article ["+itemRef+"]</h4>",
    //     html: "Réclamer une référence introuvable ?",
    //     //icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#f46a6a",
    //     cancelButtonColor: "#34c38f",
    //     cancelButtonText: "Ignorer",
    //     confirmButtonText:  "Envoyer la Réclamation"
    //   }).then(result => {
    //     if (result.value) {
    //         ItemsApi.submitClaim(null, null, itemRef, null)
    //   .then(() => {
    //       this.showAddClaimModal = false;
    //   })
    //     }
    //   });

      
    // }

  },
  watch :{

      // the cart column is v-if'd on these: keep the shortcut's observer on the live element
      collapsed() { this.observeCartColumn(); this.evaluateMobileCatalog(true); },
      isLgScreen() { this.observeCartColumn(); },

      // mobile catalogue: decided once per viewport width (and again when the grid's room changes)
      viewportWidth() {
        clearTimeout(this.mobileCatalogTimer);
        this.mobileCatalogTimer = setTimeout(() => this.evaluateMobileCatalog(), 150);
      },
      itemsList() { this.evaluateMobileCatalog(); },
      // Saisie rapide no longer offered (phone + mobile catalogue): back to the catalogue
      quickOrderIsEnable(enabled) { if (!enabled && this.isQuickOrder) this.isQuickOrder = false; },
      // rows only exist once the busy row is gone
      isTableLoading(loading) { if (!loading) this.evaluateMobileCatalog(); },

      isQuickOrder(newVal) {
        if (newVal) {
          // Saisie rapide has no Commande / Brouillons tabs: always show the order
          this.activeTabIndex = 0;
          this.collapsed = false

          this.$nextTick(() => {
            // start the scroll at the import box, which now sits above the quick order grid
            const el = this.$refs.quickOrderImportBox || this.$refs.quickOrderSection;
            if (el && el.scrollIntoView) {
              el.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          });
        }else{

          this.collapsed = true
          
        }
      },


    role: function() {

        if(this.role==0) {
          this.findItems()
        }

        if(this.role ==1){
          this.getCustomers()
          this.setSimulatedCustomer()
          this.findItems()
        }
    
    },
   

    // selectedBrandsList: function() {

    //    if (this.selectedBrandsList.length == 0) {
    //       this.resetPagination();
    //       this.findItems();
    //     }
        
    // },

    selectedGroup: function() {

        this.subGroupsList = [];

        this.resetPagination();
        this.findItems();

        if (this.selectedGroup != null) {
          this.getSubGroups();
        }

    },

    selectedBrand: function() {
      this.resetPagination();
      this.findItems();
    },

    selectedDci: function() {
      this.resetPagination();
      this.findItems();
    },

    selectedItemForm: function() {
      this.resetPagination();
      this.findItems();
    },

    selectedSubGroup: function() {

        this.resetPagination();
        this.findItems();
    },

    selectedAgency: function() {

        this.resetPagination();
        this.findItems();
    },

    filterItemAvailable: function() {

      this.resetPagination();
      this.findItems();
    },

    filterItemHasImage: function() {

      this.resetPagination();
      this.findItems();
    },

    searchInNewItemsOnly: function() {
      this.resetPagination();
      this.findItems();
    },

    searchInNewItemsLast24Only: function() {
      this.resetPagination();
      this.findItems();
    },

    searchParaOnly: function() {
      if (this.searchParaOnly) {
        this.searchPharmaOnly = false;
      }
      this.resetPagination();
      this.findItems();
    },

    searchPharmaOnly: function() {
      if (this.searchPharmaOnly) {
        this.searchParaOnly = false;
      }
      this.resetPagination();
      this.findItems();
    },    

    searchInWebNouvLancementPara: function() {
      this.resetPagination();
      this.findItems();
    },

    searchInWebNouvEntrePara: function() {
      this.resetPagination();
      this.findItems();
    },

    searchInNewCreationsOnly: function() {
      this.resetPagination();
      this.findItems();
    },

    searchInItemsWithGratuitiesOnly: function() {
      this.resetPagination();
      this.findItems();
    },

    searchInItemsWithControlledSalesOnly: function() {
      this.resetPagination();
      this.findItems();
    },

    searchInItemsWithRepartitionSalesOnly: function() {
      this.resetPagination();
      this.findItems();
    },

    filterItemHasDescription: function() {

      if (!this.filterItemHasDescription) {
        this.filterDescription = null;
      }

      this.resetPagination();
      this.findItems();
    },

    'filter':function(){
        this.reference = this.filter
        this.findItems()
    },

    selectedCustomer:function(){
      this.setSimulatedCustomer()
    },

    propFilter:function(){
      this.reference = this.propFilter && (this.propFilter != 'undefined') ? this.propFilter : '';
      this.findItems();
    },

    propGroup:function(){
      this.selectedGroup = this.propGroup && (this.propGroup != 'undefined') ? {id: this.propGroup} : null;

      this.findItems();
      this.getGroups();

    },

    propSubGroup:function(){
      this.selectedSubGroup = this.propSubGroup && (this.propSubGroup != 'undefined') ? {id: this.propSubGroup} : null;
      this.findItems();
    },


    order:function() {

      if(this.order &&  this.order.id) /* ? this.$cookies.remove('drafto') :*/ {
        //this.$cookies.set('draftoc', this.order.lines.length);
        //this.$cookies.set('drafto', this.order.id);

        document.cookie = 'drafto' + "=" + this.order.id + ";" + "10000" + ";path=/";
        document.cookie = 'draftoc' + "=" + this.order.allQtyCount + ";" + "10000" + ";path=/";

      } else {
        this.$cookies.remove('drafto');
        this.$cookies.remove('draftoc');
      }

      this.$root.$emit('order-changed-event', this.order.lines ? this.order.lines.length : 0)

      this.orderErrors = null;
    },
  }
};

</script>

<style>
/* mandatory banner ads modal */
.required-banner-modal .modal-dialog { max-width: 960px; }
.required-banner-modal.modal.fade .modal-dialog { transform: translateY(24px) scale(.97); transition: transform .35s cubic-bezier(.2, .8, .2, 1), opacity .35s; }
.required-banner-modal.modal.show .modal-dialog { transform: none; }
.required-banner-modal .modal-content.required-banner-content { border: 0; background: transparent; box-shadow: none; }
.rb-stage { display: flex; justify-content: center; align-items: center; min-height: 120px; }
.rb-story { position: relative; display: inline-block; line-height: 0; max-width: 100%; border-radius: 16px; overflow: hidden; box-shadow: 0 30px 80px rgba(0, 0, 0, .5); }
.rb-image { display: block; max-width: 100%; max-height: 82vh; width: auto; height: auto; }
.rb-scrim { position: absolute; left: 0; right: 0; pointer-events: none; }
.rb-scrim-top { top: 0; height: 90px; background: linear-gradient(to bottom, rgba(0, 0, 0, .45), transparent); }
.rb-scrim-bottom { bottom: 0; height: 110px; background: linear-gradient(to top, rgba(0, 0, 0, .5), transparent); }
.rb-progress { position: absolute; top: 12px; left: 14px; right: 14px; display: flex; gap: 5px; }
.rb-progress-seg { flex: 1; height: 3px; border-radius: 2px; background: rgba(255, 255, 255, .4); overflow: hidden; }
.rb-progress-fill { display: block; height: 100%; width: 0; border-radius: 2px; background: #fff; }
.rb-progress-seg.done .rb-progress-fill { width: 100%; }
.rb-progress-seg.active .rb-progress-fill { animation: rb-fill .6s cubic-bezier(.2, .8, .2, 1) forwards; }
@keyframes rb-fill { from { width: 0; } to { width: 100%; } }
.rb-counter { position: absolute; top: 24px; right: 16px; color: #fff; font-size: 13px; line-height: 1; letter-spacing: .5px; text-shadow: 0 1px 3px rgba(0, 0, 0, .6); }
.rb-counter strong { font-size: 15px; }
.rb-slide-enter-active, .rb-slide-leave-active { transition: opacity .3s ease, transform .3s ease; }
.rb-slide-enter { opacity: 0; transform: translateX(28px); }
.rb-slide-leave-to { opacity: 0; transform: translateX(-28px); }
.rb-btn { position: absolute; right: 16px; bottom: 16px; display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; border: 0; border-radius: 999px; line-height: 1.4; color: #fff; font-weight: 600; background: linear-gradient(135deg, #1853ba, #3d7bff); box-shadow: 0 6px 16px rgba(0, 0, 0, .35); cursor: pointer; outline: none; transition: transform .2s, box-shadow .2s; }
.rb-btn:hover { transform: translateY(-1px); box-shadow: 0 10px 22px rgba(0, 0, 0, .45); }
.rb-btn:active { transform: scale(.97); }
.rb-btn svg { transition: transform .2s; }
.rb-btn:hover svg { transform: translateX(3px); }
.rb-btn-final { background: linear-gradient(135deg, #6fae1c, #8ac727); }
@media (max-width: 575px) { .rb-btn { right: 10px; bottom: 10px; padding: 8px 20px; } .rb-progress { left: 10px; right: 10px; } }

/* banner slider: image keeps its natural size (never upscaled, shrinks only to fit), frame height follows each slide */
.banner-slider { position: relative; border-radius: 12px; overflow: hidden; }
.banner-slider .banner-slide { display: flex; justify-content: center; align-items: center; }
.banner-slider .banner-slide-img { display: block; max-width: 100%; width: auto; height: auto; }
.banner-slider .slick-slide > div { line-height: 0; }
.banner-slider .slick-prev, .banner-slider .slick-next { position: absolute; top: 50%; z-index: 3; width: 44px; height: 44px; transform: translateY(-50%); padding: 0; display: flex; align-items: center; justify-content: center; border: 1px solid rgba(255, 255, 255, .5); border-radius: 50%; color: #fff; background: rgba(20, 30, 60, .38); -webkit-backdrop-filter: blur(6px); backdrop-filter: blur(6px); box-shadow: 0 4px 14px rgba(0, 0, 0, .25); cursor: pointer; outline: none; transition: background .25s, transform .25s, box-shadow .25s; }
.banner-slider .slick-prev { left: 14px; }
.banner-slider .slick-next { right: 14px; }
.banner-slider .slick-prev:hover, .banner-slider .slick-next:hover { background: rgba(20, 30, 60, .7); transform: translateY(-50%) scale(1.1); box-shadow: 0 6px 18px rgba(0, 0, 0, .35); }
.banner-slider .slick-prev:hover svg { transform: translateX(-2px); }
.banner-slider .slick-next:hover svg { transform: translateX(2px); }
.banner-slider .slick-prev:before, .banner-slider .slick-next:before { display: none; }
.banner-slider .banner-arrow-icon { display: flex; line-height: 0; }
.banner-slider .banner-arrow-icon svg { transition: transform .25s; }
.banner-slider .slick-prev:active, .banner-slider .slick-next:active { transform: translateY(-50%) scale(.95); }
@media (max-width: 767px) { .banner-slider .slick-prev, .banner-slider .slick-next { display: none !important; } }
.banner-slider .banner-dots { bottom: 10px; display: flex !important; justify-content: center; align-items: center; gap: 6px; }
.banner-slider .banner-dots li { width: auto; height: auto; margin: 0; }
.banner-slider .banner-dots li button { width: 8px; height: 8px; padding: 0; border-radius: 4px; background: rgba(255, 255, 255, .7); box-shadow: 0 0 3px rgba(0, 0, 0, .35); transition: width .3s, background .3s; }
.banner-slider .banner-dots li button:before { display: none; }
.banner-slider .banner-dots li.slick-active button { width: 24px; background: #fff; }
/* quick order instances: Catalogue <-> Saisie rapide switch transitions */
@keyframes qo-mode-enter { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: none; } }
/* soft ease-out; the Saisie rapide blocks arrive one after another (header, import box, grid) */
.qo-mode-enter { animation: qo-mode-enter .5s cubic-bezier(.22, 1, .36, 1) both; }
.qo-mode-enter--d1 { animation-delay: .06s; }
.qo-mode-enter--d2 { animation-delay: .12s; }
.qo-cart-col { transition: flex-basis .5s cubic-bezier(.22, 1, .36, 1), max-width .5s cubic-bezier(.22, 1, .36, 1); }
@media (prefers-reduced-motion: reduce) {
  .qo-mode-enter { animation: none; }
  .qo-cart-col { transition: none; }
}
/* quick order mode: Commande | Brouillons tabs of the cart card as soft pills: no container, no underline,
   no scrolling, so they don't look like the Catalogue | Saisie rapide switch (b-tabs renders the nav, so not scoped) */
/* Saisie rapide: the Commande | Brouillons tabs are not shown (drafts stay reachable in Catalogue mode) */
.qo-cart-tabs.nav-tabs { display: none; }
.qo-cart-tabs.nav-tabs .nav-item { flex: 0 0 auto; margin: 0; padding: 0; }
.qo-cart-tabs.nav-tabs .nav-link { display: flex; align-items: center; margin: 0; padding: .45rem .95rem; border: 0; border-radius: 999px; background: transparent; color: #667085; font-size: 14px; font-weight: 600; white-space: nowrap; }
.qo-cart-tabs.nav-tabs .nav-link:hover { color: #101828; background: #f2f4f7; }
.qo-cart-tabs.nav-tabs .nav-link.active { color: var(--primary, #34469c); background: rgba(52, 70, 156, .1); }
.qo-cart-tab { display: inline-flex; align-items: center; gap: .45rem; }
.qo-cart-tab .bx { font-size: 18px; color: #98a2b3; }
.qo-cart-tabs.nav-tabs .nav-link.active .qo-cart-tab .bx { color: var(--primary, #34469c); }

    .no-wrap {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .style-vselect .vs__search {
      line-height: 1;
      color: #394066;
      font-size: 1em
    }

    .style-vselect-position-filter .vs__search::placeholder {
      line-height: 1;
      color: #394066;
      font-size: 1em
    }

    .style-vselect-position-filter .vs__search 
    .style-vselect-position-filter .vs__dropdown-toggle,
    .style-vselect-position-filter .vs__search,
    .style-vselect-position-filter .vs__selected,
    .style-vselect-position-filter .vs__dropdown-menu {
      line-height: 1;
      color: #34c38e;
      font-size: 1em;
    }

    .style-vselect-selectedcustomer .vs__search::placeholder,
    .style-vselect-selectedcustomer .vs__dropdown-toggle,
    .style-vselect-selectedcustomer .vs__search,
    .style-vselect-selectedcustomer .vs__dropdown-menu {
      line-height: 1.5;
      font-size: 1em;
      background: white;
    }

    .style-vselect-selectedcustomer .vs__clear,
    .style-vselect-selectedcustomer .vs__open-indicator {
      fill: #2a2c74;
    }

    






    .style-vselect-filter .vs__search::placeholder,
    .style-vselect-filter .vs__dropdown-toggle,
    .style-vselect-filter .vs__search,
    .style-vselect-filter .vs__dropdown-menu {
      line-height: 1.5 !important;
      font-size: 1em;
      background: white;

      color: #74788d;
      
    }

    .style-vselect-filter .vs__clear,
    .style-vselect-filter .vs__open-indicator {
      fill: #2a2c74;
    }

    .style-vselect-filter .vs__dropdown-toggle {
        /*border-color: #96c11f;*/
        line-height: 1.5;
        font-size: 1em;
        background: white;
    }

    .vs--single-filter .vs__selected {
        /*color: #96c11f ;*/
        color: #000;
        font-weight:600;
    }


    #admin .nav-tabs-custom  {
      border-bottom:  2px solid #f6f6f6;
    }

    #notAdmin .nav-tabs-custom  {
    border-bottom:  2px solid #ffffff;
    }











.custom-carousel .slick-prev:before,
.custom-carousel .slick-next:before {
   color: #74788d; /*#7ca01a;*/
}






.strikethrough {
  text-decoration: line-through;
}

</style>

<template>
<Layout>
  <div>

    <div class="row pt-4 page-top-spacer" />

    <div v-if="role==0 && false" class="row pt-4 d-print-none">
      <div  class ="col-lg-4 col-md-4 col-sm-12 col-xs-12 p-4" >
          <div class="card h-100 ">
            <div class="card-body card  bg-Default">
            <simplebar style="max-height: 12em; min-height:12em">
              <div > 
                <div class="row pl-4 pr-4 pb-3">
                  <div class="col-4 text-left">
                    <div class="mt-3">
                      <p class="text-muted mb-1">{{$t("outstanding.inProgress")}}</p>
                      <h5>{{customerOutstandingInfo.inProgressStr}} </h5>
                    </div>
                  </div>

                  <div class="col-4 text-center">
                    <div class="mt-3">
                      <p class="text-muted mb-1">{{$t("outstanding.ceiling")}}</p>
                      <h5>{{customerOutstandingInfo.ceilingStr}} </h5>
                    </div>
                  </div>

                  <div class="col-4 text-right">
                    <div class="mt-3">
                      <p class="text-muted mb-1">{{$t("outstanding.exceeding")}}</p>
                      <h5 class="text-danger">
                        {{customerOutstandingInfo.exceedingStr}} 
                      </h5>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div :class="customerOutstandingInfo.paymentConditionsPDFExist ? 'col-9' : 'col-12'">
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item">
                        <div class="py-2">
                          <div class="row">
                            <div class="col-6 text-left">
                              <h5 class="font-size-14 text-primary">{{$t("outstanding.status")}}</h5>
                            </div>
                            <div class="col-6 text-right font-size-14 text-muted">{{customerOutstandingInfo.status}}  %
                            </div>
                          </div>
                          <b-progress  
                              :value="customerOutstandingInfo.status" 
                              variant="warning" 
                              height="6px" 
                          />
                          <!-- <div class="progress animated-progess progress-sm">
                            <div
                              class="progress-bar bg-warning"
                              role="progressbar"
                              style="width: 69%"
                              aria-valuenow="69"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div> -->
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div v-if="customerOutstandingInfo.paymentConditionsPDFExist" class="col-3 align-self-center text-center text-primary">
                      <a @click.prevent="downloadPaymentConditions()" :title="$t('outstanding.conditions.hover')" class="font-size-12 font-weight-bold text-center" style="cursor:pointer"><i class="fas fa-download  mr-1"></i>{{$t('outstanding.conditions.label')}} </a> 
                  </div>

                </div>
              </div>
              <div class="text-center" v-if="isGettingCustomerOutstandingInfo" >
                <b-spinner variant="primary" ></b-spinner>
              </div>
            </simplebar>

            </div>
          </div>
      </div>
      <div  class ="col-lg-4 col-md-4 col-sm-12 col-xs-12  p-4" >
          <div class="card  h-100 ">
            <div class="card-body card bg-Defaul">

              <div class="row pt-3 pl-4 pr-4 pb-1">
                <div class="col-9 text-left">
                  <span class="text-muted font-size-14"><i>{{$t("topItems.newOrderTitle.main")}} {{this.currentYear}} <span class="font-size-12"></span></i></span>
                </div>

                <div class="col-3 pl-0 text-right">
                  <a href="javascript:void(0)" class="pl-0" @click="showHistoryModal=true">
                    <h5 class="card-title pb-2 pl-0 font-size-14 text-primary" :title="$t('topItems.historyModal.title')"><i class="fas fa-history  mr-1" /> <span class="font-size-14"></span></h5>
                  </a>
                </div>
              </div> 
             <TopItems :isCatalogPage=true />
            </div>
          </div>
      </div>
      <div class ="col-lg-4 col-md-4 col-sm-12 col-xs-12 p-4" >
          <div class="card  h-100">
            <div class="card-body card  bg-Default">
                <Promotions :isSmall="true" :isCatalogPage="true" />
            </div>
          </div>
      </div>

    </div>




        <div class="row justify-content-center my-3" v-if="!isRequiredBannerAds && bannerAdsList && bannerAdsList.length > 0">
          <div class="col-12 col-lg-10 col-xl-8 px-2">
            <div class="banner-slider">
              <VueSlickCarousel v-if="bannerAdsList.length > 1" v-bind="bannerSliderSettings">
                <template #prevArrow>
                  <span class="banner-arrow-icon">
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 5 8 12 15 19"></polyline></svg>
                  </span>
                </template>
                <template #nextArrow>
                  <span class="banner-arrow-icon">
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 5 16 12 9 19"></polyline></svg>
                  </span>
                </template>
                <div v-for="banner in bannerAdsList" :key="banner.id">
                  <div class="banner-slide">
                    <img class="banner-slide-img" :src="'/api/image/get/' + banner.generatedName" alt="">
                  </div>
                </div>
              </VueSlickCarousel>
              <div v-else class="banner-slide">
                <img class="banner-slide-img" :src="'/api/image/get/' + bannerAdsList[0].generatedName" alt="">
              </div>
            </div>
          </div>
        </div>


    <!-- <div class="row mb-2 pb-4 pr-4 pl-4 pb-2  " v-if="bannerAdsList && bannerAdsList.length > 0" >
            <div class="col-12">
              <carousel id="high-carousel" :smartSpeed="4000" :autoplayTimeout="10000"  :autoplay="bannerAdsList.length == 1 ? false : true" :autoplayHoverPause="false" :nav="false"  :dots="false"  :loop="true" 
                :items="1" >

                  <template slot="prev"><span hidden ref="bannerAdsPrev" class="prev">prev</span></template>
                  <template slot="next"><span hidden  ref="bannerAdsNext" class="next">next</span></template>

                  <div  class="row" v-for="(banner) in this.bannerAdsList" :key="banner.id"> 
                        <div class="col-12 p-sm-2 p-0">
                          <img :src="'/api/image/get/' + banner.generatedName"  width="100%" style="border: 1px solid #ecedf0; border-radius:7px;" >
                        </div>
                  </div>
             </carousel>
            </div>
    </div> -->
    <div v-if="role==1" class="row" >
      <div class="col-12 pr-md-4 pr-0 pl-md-4 pl-0 pb-2 text-left">
          <span class="text-dark font-weight-bold pb-2" style="font-size:1.2em;" > <i class="mdi mdi-eye pr-2 " style="font-size:15px;"></i>{{$t("catalog.simulatedCustomer.label")}}</span>
      </div>

      <div class="col-12 pr-md-4 pr-0 pl-md-4 pl-0 text-right">
          <b-form-group label-for="">
              <v-select class="style-vselect-selectedcustomer" style="font-size:1.2em;" :options="customersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" label="fullCompanyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
              </v-select>
            </b-form-group>
      </div>
    </div>


   


    <!-- Paliers de remises -->
    <div v-if="isNewPalierCustomerUI" class="row ml-0 ml-sm-4 ml-0 mr-0 mr-sm-4 pt-2 pb-1 mb-sm-3 mb-0 pl-0  d-print-none palier-row ">


        <div v-if="customerLandingParaList || (isCustomerRevenueStatusEnabled && customerRevenueStatus)" class="d-flex flex-column" :class="isParaCardFullWidth ? 'col-lg-12' : 'col-lg-6 pr-lg-4'"  > 
          <PalierCustomerNewUI v-if="customerLandingParaList" class="flex-grow-1" fill title="PARA : "
                        :info="customerLandingParaList"
                      />
          <!-- revenue status directly under the PARA card, both modes (gauge with a ceiling; one line without: plafond 0 = no ceiling) -->
          <div v-if="isCustomerRevenueStatusEnabled && customerRevenueStatus" class="mt-3 rs-card" :class="['rs-card--' + customerRevenueInfo.state, { 'rs-card--loading': isCustomerRevenueStatusLoading }]">
            <template v-if="customerRevenueInfo.hasCeiling">
              <div class="rs-card__head">
                <span class="rs-card__label"><i class="bx bx-wallet" aria-hidden="true"></i>Encours client</span>
                <span class="rs-card__badge">{{ customerRevenueInfo.percentLabel }}</span>
              </div>
              <div class="rs-card__amounts">
                <strong>{{ customerRevenueStatus.encoursAsStr || customerRevenueStatus.encours }}</strong>
                <span class="rs-card__of">/ {{ customerRevenueStatus.plafondAsString || customerRevenueStatus.plafond }}</span>
              </div>
              <div class="rs-card__bar" role="progressbar" :aria-valuenow="Math.round(customerRevenueProgress)" aria-valuemin="0" aria-valuemax="100">
                <span :style="{ width: customerRevenueProgress + '%' }"></span>
              </div>
              <span class="rs-card__note">{{ customerRevenueInfo.note }}</span>
            </template>
            <template v-else>
              <div class="rs-card__head">
                <span class="rs-card__label"><i class="bx bx-wallet" aria-hidden="true"></i>Encours client</span>
                <span class="rs-card__badge">Sans plafond</span>
              </div>
              <div class="rs-card__amounts">
                <strong>{{ customerRevenueStatus.encoursAsStr || customerRevenueStatus.encours }}</strong>
              </div>
            </template>
          </div>

        </div>

        <div v-if="customerLandingPharmaList" class="col-lg-6  pl-lg-4 d-flex flex-column"  > 
          <PalierCustomerNewUI v-if="customerLandingPharmaList" class="flex-grow-1" fill title="PHARMA : " 
                      :info="customerLandingPharmaList"/>
        </div>


   </div>

      <div v-else  class="row ml-0 ml-sm-4 ml-0 mr-0 mr-sm-4 pt-2 pb-1 mb-sm-3 mb-0 pl-0  d-print-none palier-row " >
        <div v-if="customerLandingParaList || (isCustomerRevenueStatusEnabled && customerRevenueStatus)" class="d-flex flex-column" :class="isParaCardFullWidth ? 'col-lg-12' : 'col-lg-6 pr-lg-4'"  > 
          <PalierCustomer v-if="customerLandingParaList" class="flex-grow-1" title="PARA : "
                        :info="customerLandingParaList"
                      />
          <!-- revenue status directly under the PARA card, both modes (gauge with a ceiling; one line without: plafond 0 = no ceiling) -->
          <div v-if="isCustomerRevenueStatusEnabled && customerRevenueStatus" class="mt-3 rs-card" :class="['rs-card--' + customerRevenueInfo.state, { 'rs-card--loading': isCustomerRevenueStatusLoading }]">
            <template v-if="customerRevenueInfo.hasCeiling">
              <div class="rs-card__head">
                <span class="rs-card__label"><i class="bx bx-wallet" aria-hidden="true"></i>Encours client</span>
                <span class="rs-card__badge">{{ customerRevenueInfo.percentLabel }}</span>
              </div>
              <div class="rs-card__amounts">
                <strong>{{ customerRevenueStatus.encoursAsStr || customerRevenueStatus.encours }}</strong>
                <span class="rs-card__of">/ {{ customerRevenueStatus.plafondAsString || customerRevenueStatus.plafond }}</span>
              </div>
              <div class="rs-card__bar" role="progressbar" :aria-valuenow="Math.round(customerRevenueProgress)" aria-valuemin="0" aria-valuemax="100">
                <span :style="{ width: customerRevenueProgress + '%' }"></span>
              </div>
              <span class="rs-card__note">{{ customerRevenueInfo.note }}</span>
            </template>
            <template v-else>
              <div class="rs-card__head">
                <span class="rs-card__label"><i class="bx bx-wallet" aria-hidden="true"></i>Encours client</span>
                <span class="rs-card__badge">Sans plafond</span>
              </div>
              <div class="rs-card__amounts">
                <strong>{{ customerRevenueStatus.encoursAsStr || customerRevenueStatus.encours }}</strong>
              </div>
            </template>
          </div>

        </div>

        <div v-if="customerLandingPharmaList" class="col-lg-6  pl-lg-4 d-flex flex-column"  > 
          <PalierCustomer v-if="customerLandingPharmaList" class="flex-grow-1" title="PHARMA : " 
                      :info="customerLandingPharmaList"/>
        </div>
      </div>
       

                      

 



    

    <!-- New Items Carroussel -->
    <!-- <div v-if="newItems && newItems.length" class="row ml-0 ml-sm-4 ml-0 mr-0 mr-sm-4 pt-2 pb-1 mb-sm-3 mb-0 pl-0  d-print-none " 
          style="background-color:#f8f7fb;">


        <div class="col-lg-12 pl-4 pr-4  "  > 

         
              
              <VueSlickCarousel class="custom-carousel" v-if="newItems && newItems.length" v-bind="newItemsSettings"  >


                            <div v-for="(newItem, index) in newItems" :key="index" class="col-lg-12 col-md-12 col-sm-12 p-2 col-xs-12 my-auto text-left " style="vertical-align: middle;">
                              
                              <div class="row" >


                                <div class="col-12" >
                                 
                                  <a @click="findTheNewItem(newItem.ref)"  :style="{cursor: 'pointer'}" href="javascript:void(0);">
                                    <span class="font-size-12 text-dark font-weight-bold "> {{newItem.title}}  </span> 
                                   
                                    
                                    <br/><span class="text-muted font-size-14 pt-2"><strong :class="newItem.days < 65 ? 'badge badge-danger' : 'badge badge-warning'" class=" font-weight-bold mr-1">NOUVEAU</strong> depuis {{newItem.days}} jours</span>
                                    <a  href="javascript:void(0);" class="text-muted"> 
                                     </a>     
                                  </a>

                                </div>

                              </div>
                              
                              
                            </div>

            </VueSlickCarousel>
        </div>

    </div> -->
  
    <!-- Quick order instances, phones: full-width switch (from md up it sits in the catalogue / cart headers) -->
    <div v-if="quickOrderIsEnable" class="row pl-0 pl-sm-4 d-print-none d-md-none">
      <div class="col-12 mt-2 pr-sm-4">
        <quick-order-switch v-model="isQuickOrder" hint block tip />
      </div>
    </div>

    <div class="row pl-0 pl-sm-4  d-print-none align-items-stretch">

      <div v-if="!isQuickOrder"   
      class="mt-2 pr-sm-4 transition-width"
      :class="[
        this.isCollapseCartBox && this.collapsed ? 'col-xl-11-5 col-12' : 'col-xl-9 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2 pr-sm-4',
        'pl-xl-2',
        quickOrderIsEnable ? 'qo-mode-enter' : ''
      ]" >
        <div class="card h-100">
          <div class="card-body card  bg-Default">

            <!-- <b-tabs :id="isAdmin ? 'admin' : 'notAdmin'"  class="pb-4 pt-0"   fill justified nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold text-uppercase ">
              <b-tab :title-item-class="isAdmin ? '' : 'd-none'"   lazy   >
                <template v-slot:title>
                    <span class="d-inline-block d-md-none">
                    <i class="fas fa-book font-size-16 "/>
                    </span>
                    <i class="d-none d-md-inline-block fas fa-book  font-size-18 pr-2"/><br/><span class="d-none d-md-inline-block font-size-16">{{$t("catalog.title")}}</span>
                </template> -->
                  <!-- phones with the mobile catalogue: title on the full width (the right side is empty there, or holds the
                       shared-documents buttons, which then go under the title) -->
                  <div class="pt-1 row mb-4 align-items-center" >
                    <div :class="isMobileCatalogEnabled && isPhone ? 'col-12' : 'col-md-5 col-6'" >
                      <h3 class="text-primary font-weight-bold mb-0">Catalogue des articles</h3>
                    </div>

                    <!-- shared-documents buttons and the Catalogue | Saisie rapide switch on ONE line, right-aligned,
                         so they no longer stack when both are shown -->
                    <div class="cat-head-actions" :class="isMobileCatalogEnabled && isPhone ? 'col-12' : 'col-md-7 col-6'" >
                      <template v-if="isSharedDocumentsEnabled">
                        <b-button
                          v-for="item in filteredSharedDocumentByType"
                          :key="item.type"
                          class="font-weight-bold font-size-14 text-uppercase"
                          variant="danger"
                          @click="openSharedDocumentModal(item)"
                        >
                          {{ getLabelByType(item.type) }} <span style="font-size:10px">({{ item.count }})</span>
                        </b-button>
                      </template>

                      <!-- where the "Saisie Rapide" button was -->
                      <div v-if="quickOrderIsEnable" class="d-none d-md-block cat-head-switch">
                        <quick-order-switch v-model="isQuickOrder" tip />
                      </div>
                    </div>
                  </div>
                  <AgentSelectorComponent
                    v-model="pendingSelectedAgency"
                    :visible="hasAgencySelector && ((role === 1 && selectedCustomer != null) || role === 0)"
                    :agency-select-options="agencySelectOptions"
                    :selected-agency-color-style="selectedAgencyColorStyle"
                    :active-agency-id="selectedAgency"
                    :cart-has-items="orderLines.length > 0"
                    :can-request-agency-change="canRequestAgencyChange"
                    :selected-agency-name="selectedAgencyName"
                    :active-agency-name="activeAgencyName"
                    :pending-agency-name="pendingAgencyName"
                    @confirm="confirmAgencyChange"
                    @cancel="cancelAgencyChange"
                  />

                  <!-- <div class="row">
                      <div class="col-6">
                        <span class="text-muted  font-weight-bold font-size-14">
                          <i class="fas fa-star-half-alt mr-2" />Nos Nouveautés<span class="text-muted font-size-12"><i>, cliquer sur un article pour le commander</i></span>
                        </span>
                      </div>

                      <div class="col-6 text-right">
                        <span class="text-muted  font-weight-bold font-size-14">
                            Afficher toutes les nouveautés
                        </span>
                      </div>
                      
                  </div> -->
                  <template v-if="!isLegacyCatalogFilters">
                  <div class="cat-filters__caption">Afficher uniquement</div>
                  <!-- one flowing line for both groups of chips (the card body is a flex column) -->
                  <div class="cat-chips-line">
                  <div class="row pt-2 cat-chips">

                    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 cat-chip--alloc" v-if="isRepartitionSalesFilter">
                        <b-form-checkbox  v-model="searchInItemsWithRepartitionSalesOnly" switch class="mb-1 float-md-left"  >
                          <label style="letter-spacing: 1px;" class="text-uppercase" :class="searchInItemsWithRepartitionSalesOnly ? 'text-danger font-weight-bold' : 'text-dark'">
                            Articles en <strong>Répartition</strong>
                          </label>
                        </b-form-checkbox>
                    </div>

                    <div v-if="!isParaOnly" class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 cat-chip--range">
                        <b-form-checkbox  v-model="searchParaOnly" switch class="mb-1 float-md-left"  >
                          <label :class="searchParaOnly ? 'text-danger font-weight-bold' : 'text-muted'">Produits <strong>Para-Pharmaceutiques</strong></label>
                        </b-form-checkbox>
                    </div>

                    <div v-if="!isParaOnly" class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 cat-chip--range">
                        <b-form-checkbox  v-model="searchPharmaOnly" switch class="mb-1 float-md-left"  >
                          <label :class="searchPharmaOnly ? 'text-danger font-weight-bold' : 'text-muted'">Produits <strong>Pharmaceutiques</strong></label>
                        </b-form-checkbox>
                    </div>
                  </div>
                  
                  <div class="row pt-2 cat-chips">
                      <div v-if="!isHideSearchInNewItemsLast24Only" class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 cat-chip--new">
                        <b-form-checkbox  v-model="searchInNewItemsLast24Only" switch class="mb-1 float-md-left"  >
                          <label :class="searchInNewItemsLast24Only ? 'text-danger font-weight-bold' : 'text-muted'">A Nouveau Disponibles <strong :class="searchInNewItemsLast24Only ? 'text-danger' : 'text-dark'">Aujourd'hui</strong></label>
                        </b-form-checkbox>


                      </div>

                      <div v-if="!isHideSearchInNewItems" class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 cat-chip--new">
                        <b-form-checkbox  v-model="searchInNewItemsOnly" switch class="mb-1 float-md-left"  >
                          <label :class="searchInNewItemsOnly ? 'text-danger font-weight-bold' : 'text-muted'">A Nouveau Disponibles</label>
                        </b-form-checkbox>
                      </div>

                      <div v-if="isWebNouvEntrePara" class="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-xs-12 cat-chip--new">
                        <b-form-checkbox  v-model="searchInWebNouvEntrePara" switch class="mb-1 float-md-left"  >
                          <label :class="searchInWebNouvEntrePara ? 'text-danger font-weight-bold' : 'text-muted'">{{this.isMSS ? 'Arrivages du jour' : 'En arrivage'  }} </label>
                        </b-form-checkbox>
                      </div>


                      <div v-if="!isPartner" class="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-xs-12 cat-chip--new">
                        <b-form-checkbox  v-model="searchInNewCreationsOnly" switch class="mb-1 float-md-left"  >
                          <label :class="searchInNewCreationsOnly ? 'text-danger font-weight-bold' : 'text-muted'">Nouveautés</label>
                        </b-form-checkbox>
                      </div>

                      <div v-if="isWebNouvLancementPara" class="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-xs-12 cat-chip--new">
                        <b-form-checkbox  v-model="searchInWebNouvLancementPara" switch class="mb-1 float-md-left"  >
                          <label :class="searchInWebNouvLancementPara ? 'text-danger font-weight-bold' : 'text-muted'">{{this.isMSS ? 'De retour en stock' : 'Lancements'  }} </label>
                        </b-form-checkbox>
                      </div>


                      <div class="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-xs-12 cat-chip--promo">
                        <b-form-checkbox  v-model="searchInItemsWithGratuitiesOnly" switch class="mb-1 float-md-left"  >
                          <label :class="searchInItemsWithGratuitiesOnly ? 'text-danger font-weight-bold' : 'text-muted'">{{this.isMSS ? 'En Promotion' : 'Avec Promotion'  }}</label>
                        </b-form-checkbox>
                      </div>

                      <div class="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-xs-12 cat-chip--alloc" v-if="!isHideControlledSalesFilter" >
                        <b-form-checkbox v-model="searchInItemsWithControlledSalesOnly" switch class="mb-1 float-md-left"  >
                          <label :class="searchInItemsWithControlledSalesOnly ? 'text-danger font-weight-bold' : 'text-muted'">Ventes contrôlées</label>
                        </b-form-checkbox>
                      </div>

                  </div>
               

                  </div>
                <div id="filter-row" class="row cat-filter-grid">

                  <div
                    v-for="(filter, index) in filters"
                    :key="filter.key"
                    :class="['col-12 col-sm-6 col-lg-3 pt-3 pt-lg-0 cat-field', index === 0 ? 'pl-0 pr-2' : 'px-2', { 'cat-field--filled': $data[filter.model] }]"
                  >

                    <span class="cat-field__label">
                      <i :class="filter.icon + ' mr-2'"></i>
                      {{ filter.label }}
                    </span>

                    <v-select
                      class="style-vselect style-vselect-filter vs--single-filter cat-select"
                      :placeholder="filter.label"
                      :options="filter.options()"
                      v-model="$data[filter.model]"
                      label="name"
                    >
                      <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                    </v-select>

                  </div>

                </div>


                  <div class="row cat-search">
                    
                          <div class="col-12 cat-field cat-search__label-col" :class="{ 'cat-field--filled': reference }">
                            <span class="cat-field__label">
                              <i class="fab fa-searchengin mr-2" />Référence ou désignation ou code à barre
                            </span>
                          </div>

                          <div class="col-12">
                            <div class="position-relative">
                            <b-input-group>
                              <b-form-input id="reference-search-input" v-model="reference" placeholder="Référence ou désignation ou code à barre" @keyup.native.enter="resetPagination();findItems();"
                              class="cat-search__input" :autocomplete="quickOrderIsEnable ? 'off' : null"
                              ></b-form-input>
                              <template v-slot:append>
                                  <b-button  size="sm" variant="primary" class="cat-search__btn" @click="resetPagination();findItems();">
                                     <span class="cat-search__btn-content"><i class="bx bx-search-alt" /></span> 
                                  </b-button>

                              </template>                            
                            </b-input-group>
                            <!-- instances with Saisie rapide: its article suggestions under the catalogue search -->
                            <CatalogSearchSuggestions v-if="quickOrderIsEnable" :query="reference" input-id="reference-search-input"
                              @pick="onCatalogSuggestionPick" />
                            </div>

                           <div  v-if="isAdvancedSearchEnable && reference && reference.trim().length && !allWordsBeginWithPercent" class="cat-search__wider">
                              <span>
                                <a class="cat-search__wider-link" @click="advancedSearch">
                                  <i><strong>Pas trouvé ?</strong> Tentez une <strong>recherche élargie !</strong></i>
                                </a>
                              </span>
                           </div>


                          </div>
                  </div>
                  </template>
                  <!-- CAB: catalogue filters as before the filters UX review (same models and requests) -->
                  <template v-else>
                  <div class="row pt-2">

                    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12" v-if="isRepartitionSalesFilter">
                        <b-form-checkbox  v-model="searchInItemsWithRepartitionSalesOnly" switch class="mb-1 float-md-left"  >
                          <label style="letter-spacing: 1px;" class="text-uppercase" :class="searchInItemsWithRepartitionSalesOnly ? 'text-danger font-weight-bold' : 'text-dark'">
                            Articles en <strong :style="searchInItemsWithRepartitionSalesOnly ? '' : 'background-color: rgb(223 217 88 / 23%);padding: 2px;border-radius: 3px;'">Répartition</strong>
                          </label>
                        </b-form-checkbox>
                    </div>

                    <div v-if="!isParaOnly" class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12">
                        <b-form-checkbox  v-model="searchParaOnly" switch class="mb-1 float-md-left"  >
                          <label :class="searchParaOnly ? 'text-danger font-weight-bold' : 'text-muted'">Produits <strong>Para-Pharmaceutiques</strong></label>
                        </b-form-checkbox>
                    </div>

                    <div v-if="!isParaOnly" class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12">
                        <b-form-checkbox  v-model="searchPharmaOnly" switch class="mb-1 float-md-left"  >
                          <label :class="searchPharmaOnly ? 'text-danger font-weight-bold' : 'text-muted'">Produits <strong>Pharmaceutiques</strong></label>
                        </b-form-checkbox>
                    </div>
                  </div>
                  
                  <div class="row pt-2">
                      <div v-if="!isHideSearchInNewItemsLast24Only" class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12">
                        <b-form-checkbox  v-model="searchInNewItemsLast24Only" switch class="mb-1 float-md-left"  >
                          <label :class="searchInNewItemsLast24Only ? 'text-danger font-weight-bold' : 'text-muted'">A Nouveau Disponibles <strong :class="searchInNewItemsLast24Only ? 'text-danger' : 'text-dark'">Aujourd'hui</strong></label>
                        </b-form-checkbox>


                      </div>

                      <div v-if="!isHideSearchInNewItems" class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12">
                        <b-form-checkbox  v-model="searchInNewItemsOnly" switch class="mb-1 float-md-left"  >
                          <label :class="searchInNewItemsOnly ? 'text-danger font-weight-bold' : 'text-muted'">A Nouveau Disponibles</label>
                        </b-form-checkbox>
                      </div>

                      <div v-if="isWebNouvEntrePara" class="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-xs-12">
                        <b-form-checkbox  v-model="searchInWebNouvEntrePara" switch class="mb-1 float-md-left"  >
                          <label :class="searchInWebNouvEntrePara ? 'text-danger font-weight-bold' : 'text-muted'">{{this.isMSS ? 'Arrivages du jour' : 'En arrivage'  }} </label>
                        </b-form-checkbox>
                      </div>


                      <div v-if="!isPartner" class="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-xs-12">
                        <b-form-checkbox  v-model="searchInNewCreationsOnly" switch class="mb-1 float-md-left"  >
                          <label :class="searchInNewCreationsOnly ? 'text-danger font-weight-bold' : 'text-muted'">Nouveautés</label>
                        </b-form-checkbox>
                      </div>

                      <div v-if="isWebNouvLancementPara" class="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-xs-12">
                        <b-form-checkbox  v-model="searchInWebNouvLancementPara" switch class="mb-1 float-md-left"  >
                          <label :class="searchInWebNouvLancementPara ? 'text-danger font-weight-bold' : 'text-muted'">{{this.isMSS ? 'De retour en stock' : 'Lancements'  }} </label>
                        </b-form-checkbox>
                      </div>


                      <div class="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-xs-12">
                        <b-form-checkbox  v-model="searchInItemsWithGratuitiesOnly" switch class="mb-1 float-md-left"  >
                          <label :class="searchInItemsWithGratuitiesOnly ? 'text-danger font-weight-bold' : 'text-muted'">{{this.isMSS ? 'En Promotion' : 'Avec Promotion'  }}</label>
                        </b-form-checkbox>
                      </div>

                      <div class="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-xs-12" v-if="!isHideControlledSalesFilter" >
                        <b-form-checkbox v-model="searchInItemsWithControlledSalesOnly" switch class="mb-1 float-md-left"  >
                          <label :class="searchInItemsWithControlledSalesOnly ? 'text-danger font-weight-bold' : 'text-muted'">Ventes contrôlées</label>
                        </b-form-checkbox>
                      </div>

                  </div>
               

                <div id="filter-row" class="row pt-4">

                  <div
                    v-for="(filter, index) in filters"
                    :key="filter.key"
                    :class="['col-12 col-sm-6 col-lg-3 pt-3 pt-lg-0', index === 0 ? 'pl-0 pr-2' : 'px-2']"
                  >

                    <span class="text-dark font-size-14">
                      <i :class="filter.icon + ' mr-2'"></i>
                      {{ filter.legacyLabel || filter.label }}
                    </span>

                    <v-select
                      class="style-vselect style-vselect-filter vs--single-filter font-size-16"
                      :placeholder="filter.placeholder"
                      :options="filter.options()"
                      v-model="$data[filter.model]"
                      label="name"
                    >
                      <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                    </v-select>

                  </div>

                </div>


                  <div class="row pt-4 pb-4">
                    
                          <div class="col-12">
                            <span class="text-dark font-size-14">
                              <i class="fab fa-searchengin mr-2" />Par référence ou désignation ou code à barre
                            </span>
                          </div>

                          <div class="col-12">
                            <b-input-group>
                              <b-form-input id="reference-search-input" v-model="reference" placeholder="Réf ou désignation ou code à barre" @keyup.native.enter="resetPagination();findItems();"
                              class="text-dark font-weight-bold font-size-14  "
                              ></b-form-input>
                              <template v-slot:append>
                                  <b-button  size="sm" variant="primary" @click="resetPagination();findItems();">
                                     <span class="font-weight-bold"> <i class="bx bx-search-alt font-weight-bold font-size-16 pr-1 pl-1 text-white align-middle"/>  </span> 
                                  </b-button>

                              </template>                            
                            </b-input-group>

                           <div  v-if="isAdvancedSearchEnable && reference && reference.trim().length && !allWordsBeginWithPercent" class="text-center mt-4">
                              <span>
                                <a style="cursor: pointer; word-spacing: 2px;" class="text-danger font-size-14" @click="advancedSearch">
                                  <i><strong>Pas trouvé ?</strong> Tentez une <strong>recherche élargie !</strong></i>
                                </a>
                              </span>
                           </div>


                          </div>
                  </div>
                  </template>




                  
                   









<!-- <div class="row pt-3">
  <div class="col-6">
      <hr/>
      <h5 class="text-dark font-weight-bold">Marques <span :class="selectedBrandsList.length ? 'text-danger font-weight-bold' : 'text-muted font-weight-normal'" class="font-size-14 ">({{ selectedBrandsList.length }} / {{brandsList.length}})</span></h5>
      <span class="text-muted font-size-12 font-weight-normal">{{ selectedBrandsList.length }} marque<span v-if="selectedBrandsList.length > 1">s</span> sélectionnée<span v-if="selectedBrandsList.length > 1">s</span> </span>
  </div>

  <div class="col-6 text-right">
    <hr/>
    <b-button v-if="selectedBrandsList.length" size="sm" variant="danger" @click="resetPagination();findItems();">

          <strong>Chercher</strong> 
          <i class="bx bx-search-alt font-weight-bold font-size-16 ml-2 align-middle"></i>
    </b-button>
  </div>
</div> -->


<!-- <div class="row pt-3">
<div class="col-12">
      
      <simplebar style="max-height: 150px;" class="brandsfilter" data-simplebar-auto-hide="false">
          

        


        <b-form-group class="m-0 p-0" >
              <b-form-checkbox v-for="brand in brandsList" :key="brand.id" :value="brand.id" 
                    v-model="selectedBrandsList" class="custom-checkbox custom-checkbox-outline custom-checkbox-danger mt-2 mt-1">   
                      <span :class="selectedBrandsList && selectedBrandsList.includes(brand.id) ? 'text-danger font-weight-bold' : 'text-muted'" class="font-size-14">{{brand.name}}</span>
              </b-form-checkbox>
        </b-form-group>
      </simplebar>
</div>
</div> -->

<!-- <div class="row pt-3">
  <div class="col-12">
      <hr/>
      <h5 class="text-dark font-weight-bold">Disponibilité et Prix</h5>
  </div>
</div>
<div class="row pt-3">
  <div class="col-9 text-left">
      <span class="font-size-16" :class="filterItemAvailable ? 'text-dark font-weight-bold ' : 'text-muted'"><i class="fas fa-clipboard-check mr-2"/>Disponibles en Stock</span>
  </div>

  <div class="col-3 text-right">
    <b-form-checkbox switch size="lg" class="mb-1 float-md-right "  v-model="filterItemAvailable"/>
  </div>
</div>
<div class="row pt-3">
  <div class="col-6 pr-1 text-left">
    <span :class="filterPriceMin ? 'font-weight-bold text-dark' : ''">Prix Min (avant remise)</span>
    <b-form-input :class="filterPriceMin ? 'border border-danger font-weight-bold' : ''" v-model="filterPriceMin" 
        placeholder="Min"  type="number"
        @keyup.native.enter="resetPagination();findItems();"
        class="text-dark font-size-12"
        ></b-form-input>
  </div>
  <div class="col-6">
    <span :class="filterPriceMax ? 'font-weight-bold text-dark' : ''">Prix Max (avant remise)</span>
    <b-form-input :class="filterPriceMax ? 'border border-danger font-weight-bold' : ''" v-model="filterPriceMax"
       placeholder="Max" type="number"
       @keyup.native.enter="resetPagination();findItems();"
        class="text-dark font-size-12"
        ></b-form-input>
  </div>
</div> -->

<!-- <div class="row pt-3">
  <div class="col-12">
      <hr/>
      <h5 class="text-dark font-weight-bold">Images</h5>
  </div>
</div>
<div class="row pt-3">
  <div class="col-9 text-left">
      <span class="font-size-16" :class="filterItemHasImage ? 'text-dark font-weight-bold ' : 'text-muted'"><i class="fas fa-photo-video mr-2"/>Seulement avec images</span>
  </div>

  <div class="col-3 text-right">
    <b-form-checkbox switch size="lg" v-model="filterItemHasImage" class="mb-1 float-md-right "/>
  </div>
</div> -->

<!-- <div class="row pt-3">
  <div class="col-12">
      <hr/>
      <h5 class="text-dark font-weight-bold">Description</h5>
  </div>
</div>
<div class="row pt-3">
  <div class="col-9 text-left">
      <span class="font-size-16" :class="filterItemHasDescription ? 'text-dark font-weight-bold ' : 'text-muted'"><i class="fas fa-info-circle mr-2"/>Seulement avec description</span>
  </div>

  <div class="col-3 text-right">
    <b-form-checkbox switch size="lg" v-model="filterItemHasDescription" class="mb-1 float-md-right "/>
  </div>
</div> 
<div class="row pt-3">
  <div class="col-12 text-left">
    <b-input-group>
        <b-form-input v-model="filterDescription" :class="filterItemHasDescription ? '' : 'bg-white '" :disabled="!filterItemHasDescription" placeholder="Description contient ?" @keyup.native.enter="resetPagination();findItems();"
        class="text-dark font-size-12"
        ></b-form-input>
        <template v-slot:append>
            <b-button  size="sm" :variant="filterItemHasDescription ? 'secondary' :'light'" :disabled="!filterItemHasDescription"  @click="resetPagination();findItems();">
            <i class="bx bx-search-alt font-weight-bold font-size-14 text-white align-middle"></i>
            </b-button>
        </template>                            
      </b-input-group>
  </div>
</div>-->


                <!-- ------------ -->
                <!-- Main Catalog -->
                <div class="table-responsive pt-2">   
                  <OrderSummary :order="order" class="mt-4 mb-3" />
                  
                  <b-table
                  ref="catalogTable"
                  :busy="isTableLoading"
                  :items="itemsList"
                  :fields="computedItemsListFields"
                  :perPage="pagemodel.perPage"
                  class="table cat-grid"

                  selectable
                  select-mode="single"
                  selected-variant="primary"
                  @row-selected="getRelatedItems"
                  
                  
                  >
                  <template v-slot:head(ref)>
                    {{ $t("catalog.header.reference") }} 
                  </template>
                  <template v-slot:head(title)>
                    {{ $t("catalog.header.title") }} 
                  </template>
                  <template v-slot:head(position)>
                    {{ $t("catalog.header.shockAbsorberPosition") }} 
                  </template>
                  <template v-slot:head(brand)>
                    Laboratoire
                  </template>
                  <template v-slot:head(price)>
                    {{ $t("catalog.header.price") }} 
                  </template>
                  <template v-slot:head(discountStr)>
                    {{ $t("catalog.header.discount") }} 
                  </template>
                  <template v-slot:head(discountedPrice)>
                    {{ $t("catalog.header.discountedPrice") }} 
                  </template>
                  <!-- <template v-slot:head(modal)>
                    {{ $t("catalog.header.modal") }} 
                  </template>
                  <template v-slot:head(salesUnit)>
                    {{ $t("catalog.header.multiple") }} 
                  </template> -->
                  <template v-slot:head(stockStatus)>
                    {{ $t("catalog.header.stockStatus") }} 
                  </template>
                  <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                  </template>
                  <template v-slot:cell(discountStr)="{value}">
                    {{value == 0 || value ==null ? '_' : value+'%'}} 
                  </template>
                  <template v-slot:cell(price)="{item,value}">
                    <div :class="item.stockStatus == 2 ? 'text-secondary' : item.stockStatus == 3 ? '' : 'text-dark'">{{value ? value : '_'}} </div>
                  </template>
                  <template v-slot:cell(priceTaxIncl)="{item, value}">
                    <!-- {{value ? value : '_'}}  -->
                    <div :style="item.vat || item.pricePublic ? 'margin:2px' : ''" :class="item.stockStatus == 2 ? 'text-secondary' : item.stockStatus == 3 ? '' : 'text-dark'">{{value ? value : '_'}} </div>

                    <div v-if="item.vat" class="text-muted font-weight-normal">{{item.vat ? 'TVA: ' + item.vat + '%' : '' }}</div>
                    <!-- <div v-if="item.vat" class="text-muted font-weight-normal">{{item.vat && item.priceTaxIncl ? 'TTC: ' + item.priceTaxIncl : '' }}</div> -->
                    <!-- <div v-if="item.pricePublic" class="text-muted font-weight-normal">{{item.pricePublic ? 'Public: ' + item.pricePublic : '' }}</div> -->

                  </template>
                  
                  <template v-slot:cell(brand)="{value}">
                    {{value.name}} 
                  </template>

                  <template v-slot:cell(ref)="{item}">
                    <span class="font-size-12 font-weight-bold" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-dark'">{{item.ref }}  </span>
                    <div v-if="item.barcode && isCAB" class="font-size-12 font-weight-normal text-muted">{{ item.barcode }}</div> 
                  </template>

                  <!-- <template v-slot:cell(vat)="{item}">
                    <span>{{item.vat ? item.vat + '%' : '' }}</span>
                  </template> -->

                  <template v-slot:cell(title)="{item}">
                        <span class="font-size-12 font-weight-bold" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-dark'" style="cursor: pointer;" >{{item.title }}  <sup> 
                        <i v-if="item.isFrigo" class="fas fa-snowflake ml-2 font-size-14 text-primary font-weight-bold" title="Produit Réfrigérateur" style="border-radius:5px; "></i> </sup> </span>
                        <div v-if="item.brand && item.brand.name && !isMobileCatalog" class="font-size-12 font-weight-normal" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-muted'">{{ item.brand ? item.brand.name : '-' }}</div> 
                        <div v-if="item.pharmaDci" class="font-size-12 font-weight-normal" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-muted'">{{ item.pharmaDci }}</div> 

                        <!-- VUE_APP_FEATURE_MOBILE_CATALOG, only when the add-to-cart column is off screen (isMobileCatalog):
                             ref · brand, then price · promo · stock (same CatalogStockStatus as the Stock column), then the same add
                             control as the add-to-cart column, which is hidden in this mode (same hide rules, same addToOrder) -->
                        <template v-if="isMobileCatalog">
                          <!-- mobile lines: missing information is left out (no "_" placeholders) -->
                          <div v-if="item.ref || (item.brand && item.brand.name)" class="m-quick-ref">{{ item.ref }}<span v-if="item.brand && item.brand.name" class="m-quick-ref__brand" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-muted'">{{ item.ref ? ' · ' : '' }}{{ item.brand.name }}</span></div>
                          <div v-if="item.priceTaxIncl || (item.gratuities && item.gratuities.length) || hasMobileStock(item)" class="m-quick-line">
                            <span v-if="item.priceTaxIncl" class="m-quick-price">{{ item.priceTaxIncl }} <small>TTC</small></span>
                            <div v-if="gratuitiesWithStartingFrom(item).length" class="promo-offers promo-offers--mobile">
                              
                              <span v-for="(itemGrat, index) in gratuitiesWithStartingFrom(item)" :key="index" class="promo-offer promo-offer--mobile">
                                <strong>{{ formatGratuityOffer(itemGrat) }}</strong>
                                <small>{{ formatGratuityStartingFrom(itemGrat) }}</small>
                              </span>
                            </div>
                            <span v-for="(itemGrat, index) in gratuitiesWithoutStartingFrom(item)" :key="`legacy-${index}`" class="badge badge-primary text-white font-weight-bold font-size-12 p-1">
                              <i class="fas fa-star mr-1"/>{{itemGrat.gratuity}} +{{itemGrat.gratuityGranted}}
                            </span>
                            <span v-if="hasMobileStock(item)" class="m-quick-stock"><CatalogStockStatus :item="item" :value="item.stockStatus" /></span>
                          </div>
                        </template>
                        <div v-if="isMobileCatalog" class="m-quick m-quick--add d-flex">
                          <div v-if="item.stockStatus !== 6 && item.stockStatus !== 7 " class="input-group mb-0 m-quick__add" :class="!item.id || item.stockStatus == 2 || item.stockStatus == 3 || (role ==1 && selectedCustomer == null) || (item.stockStatus == 4 && item.maxPerDay <= item.alreadyOrderedPerDay) ? 'd-none' : ''">
                            <span v-if="item.multiple && item.multiple != 1" class="input-group-prepend my-auto pr-1 text-success font-size-12" :title="'Multiple de ' + item.multiple">{{item.multiple}} x</span>
                            <b-form-input type="number" class="no-shadow p-1 form-control form-control-sm font-weight-bold font-size-14 text-right"
                              v-model="item.quantity" @keyup.native.enter="addToOrder(item)"/>
                            <div size="sm" class="input-group-append">
                              <button type="button" class="btn input-group-text text-dark btn-link btn-sm" @click="addToOrder(item)" :disabled="isAddToOrderStarting">
                                <i v-if="!isAddToOrderStarting" class=" fas fa-shopping-cart font-size-14"> </i>
                                <b-spinner v-if="isAddToOrderStarting" small ></b-spinner>
                              </button>
                            </div>
                          </div>
                        </div>

                  </template>

                  <template v-slot:cell(packageCount)="{value}">
                    {{value ? value + ' / carton' : '-'}} 
                  </template>

                  <template v-slot:cell(image)="{item}">
                    <i v-if="item.image" 
                          class="fas fa-image ml-2 font-size-24 text-dark font-weight-bold float-right item-align-center" 
                          title="image" 
                          style="border-radius:5px; cursor: pointer;" 
                          @click.stop="openImageModal(item)">
                        </i>   
                  </template>

                  <template v-slot:cell(gratuity)="{item}">

                    

                    <div v-if="gratuitiesWithStartingFrom(item).length" class="promo-offers">
                      
                      <span v-for="(itemGrat, index) in gratuitiesWithStartingFrom(item)" :key="index" class="promo-offer">
                        <strong>{{ formatGratuityOffer(itemGrat) }}</strong>
                        <small>{{ formatGratuityStartingFrom(itemGrat) }}</small>
                      </span>
                    </div>
                    <span  v-for="(itemGrat, index) in gratuitiesWithoutStartingFrom(item)" :key="`legacy-${index}`" href="javascript: void(0);" class="m-1 badge badge-primary text-white font-weight-bold font-size-14 p-1">
                      <i class="fas fa-star  mr-1"/>{{itemGrat.gratuity}} +{{itemGrat.gratuityGranted}}
                    </span>
                  </template>

                  <template  v-slot:cell(action)="{item}">
                    <div v-if="item.stockStatus !== 6 && item.stockStatus !== 7 " class="input-group    mb-0" style="width: 9em;" :class="!item.id || item.stockStatus == 2 || item.stockStatus == 3 || (role ==1 && selectedCustomer == null) || (item.stockStatus == 4 && item.maxPerDay <= item.alreadyOrderedPerDay) ? 'd-none' : ''">
                      
                      <div size="sm" class="input-group-append my-auto font-weight-bold font-size-14  " :style="item.multiple && item.multiple != 1 ? '':'opacity:0'"   :class="item.multiple && item.multiple != 1 ? 'text-success':'text-white'">
                        <span :title="item.multiple && item.multiple != 1 ? ('Multiple de '+item.multiple) : '' " class="pr-2 ">{{item.multiple}} x</span>
                      </div>
                      <b-form-input  type="number" class="no-shadow p-1 form-control form-control-sm font-weight-bold font-size-14 text-right"
                        v-model="item.quantity" @keyup.native.enter="addToOrder(item)"/>
                      <div size="sm" class="input-group-append">
                        <button  type="button"  class="btn input-group-text text-dark btn-link btn-sm" @click="addToOrder(item)" :disabled="isAddToOrderStarting"> 
                          <i v-if="!isAddToOrderStarting"  class=" fas fa-shopping-cart font-size-14"> </i>
                          <b-spinner v-if="isAddToOrderStarting" small ></b-spinner>
                        </button>
                      </div>
                    </div>
                  </template>

                  <template  v-slot:cell(stockStatus)="{item, value}">
                    <CatalogStockStatus :item="item" :value="value" />
                  </template>

                  <!--template v-slot:cell(show_similair)="{item}">
                    <span><i :title="$t('catalog.similairItems.title')" class="fab fa-creative-commons-nd font-size-22 text-warning" style="cursor: pointer; " @click="getSimilairItems(item)" ></i></span>
                  </template-->


                  <!-- <template v-slot:cell(modal)="{item}">
                      <i class="far fa-list-alt font-size-18 text-primary" style="cursor:pointer" @click="showDetailsModal=true;selectedItem=item;getItemsManufacturers();" ></i>
                  </template> -->
                  </b-table>
                  <span v-if="!isTableLoading && !itemsList.length" class="d-flex justify-content-center mr-4 ml-4 mt-4 mb-4 text-danger" >{{ $t("catalog.empty") }} </span>
                </div>
                  <!-- Pagination -->
                  <div v-if="!isTableLoading" class="row pt-3 pl-2 mb-sm-4">
                      <div class="col-sm-8">
                          <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                              <b-form-select @input="findItems()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="paginationOptions"></b-form-select>
                              <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="dataTables_paginate paging_simple_numbers float-right">
                              <ul class="pagination pagination-rounded mb-0">
                              <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="findItems()" :disabled="isTableLoading" ></b-pagination>
                              </ul>
                          </div>
                      </div>
                  </div> 
                  <!-- Fin Pagination  -->
                  
                  <!-- End Main Catalog -->
                  <!-- ---------------- -->

                  <!-- ------------ -->
                  <!-- Equivalences -->
                  <div class="row d-print-none" v-if="isReferenceSearchActif && equivalentItemFeatureIsEnable ">
                        <div  class ="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                          <b-card id="similairItemsCard" no-body header-class="bg-transparent border-secondary" class="rel-card mb-0 mt-4" > 
                            <div class="row rel-card__head">
                              <div class="col-12">
                                <h5 class="rel-card__title"><span class="rel-card__caption">EQUIVALENTS à</span><span class="rel-card__item">{{cardItem ? "" + cardItem.title + "" : ""}}</span></h5>
                              </div>
                              <!-- <div class="col-1 text-right ">
                                  <i  class=" fas fa-times font-size-16 pr-4 pt-2 pb-2 text-danger" @click="showcard=false" style="cursor:pointer" :title="$t('datPicker.label-close-button')"> </i>
                              </div> -->
                            </div>
                            <div class="table-responsive mb-0">
                              <b-table
                                
                                :small="true"
                                :hover="false"
                                :no-border-collapse="true"
                                class="rel-grid"
                                :busy="isSimilairItemsTableBusy"
                                :items="similairItemsList"
                                :fields="computedItemsListFields"
                                
                              >
                              <template v-slot:head(ref)>
                    {{ $t("catalog.header.reference") }} 
                  </template>
                  <template v-slot:head(title)>
                    {{ $t("catalog.header.title") }} 
                  </template>
                  <template v-slot:head(position)>
                    {{ $t("catalog.header.shockAbsorberPosition") }} 
                  </template>
                  <template v-slot:head(brand)>
                    Laboratoire
                  </template>
                  <template v-slot:head(price)>
                    {{ $t("catalog.header.price") }} 
                  </template>
                  <template v-slot:head(discountStr)>
                    {{ $t("catalog.header.discount") }} 
                  </template>
                  <template v-slot:head(discountedPrice)>
                    {{ $t("catalog.header.discountedPrice") }} 
                  </template>
                  <!-- <template v-slot:head(modal)>
                    {{ $t("catalog.header.modal") }} 
                  </template>
                  <template v-slot:head(salesUnit)>
                    {{ $t("catalog.header.multiple") }} 
                  </template> -->
                  <template v-slot:head(stockStatus)>
                    {{ $t("catalog.header.stockStatus") }} 
                  </template>
                  <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                  </template>
                  <template v-slot:cell(discountStr)="{value}">
                    {{value == 0 || value ==null ? '_' : value+'%'}} 
                  </template>
                  <template v-slot:cell(price)="{item,value}">
                    <div :class="item.stockStatus == 2 ? 'text-secondary' : item.stockStatus == 3 ? '' : 'text-dark'">{{value ? value : '_'}} </div>
                  </template>
                  <template v-slot:cell(priceTaxIncl)="{item, value}">
                    <!-- {{value ? value : '_'}}  -->
                    <div :style="item.vat || item.pricePublic ? 'margin:2px' : ''" :class="item.stockStatus == 2 ? 'text-secondary' : item.stockStatus == 3 ? '' : 'text-dark'">{{value ? value : '_'}} </div>

                    <div v-if="item.vat" class="text-muted font-weight-normal">{{item.vat ? 'TVA: ' + item.vat + '%' : '' }}</div>
                    <!-- <div v-if="item.vat" class="text-muted font-weight-normal">{{item.vat && item.priceTaxIncl ? 'TTC: ' + item.priceTaxIncl : '' }}</div> -->
                    <!-- <div v-if="item.pricePublic" class="text-muted font-weight-normal">{{item.pricePublic ? 'Public: ' + item.pricePublic : '' }}</div> -->

                  </template>
                  <template v-slot:cell(brand)="{value}">
                    {{value.name}} 
                  </template>

                  <template v-slot:cell(ref)="{item}">
                    <span class="font-size-12 font-weight-bold" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-dark'">{{item.ref }}  </span>
                  </template>

                  <template v-slot:cell(title)="{item}">
                    <span class="font-size-12 font-weight-bold" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-dark'">{{item.title }} <sup> <i v-if="item.isFrigo" class="fas fa-snowflake ml-2 font-size-14 text-primary font-weight-bold" title="Produit Réfrigérateur" style="border-radius:5px; "></i> </sup> </span>
                    <div v-if="item.brand && item.brand.name && !isMobileCatalog" class="font-size-12 font-weight-normal" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-muted'">{{ item.brand ? item.brand.name : '-' }}</div> 
                    <div v-if="item.pharmaDci" class="font-size-12 font-weight-normal" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-muted'">{{ item.pharmaDci }}</div> 
                        <!-- VUE_APP_FEATURE_MOBILE_CATALOG, only when the add-to-cart column is off screen (isMobileCatalog):
                             ref · brand, then price · promo · stock (same CatalogStockStatus as the Stock column), then the same add
                             control as the add-to-cart column, which is hidden in this mode (same hide rules, same addToOrder) -->
                        <template v-if="isMobileCatalog">
                          <!-- mobile lines: missing information is left out (no "_" placeholders) -->
                          <div v-if="item.ref || (item.brand && item.brand.name)" class="m-quick-ref">{{ item.ref }}<span v-if="item.brand && item.brand.name" class="m-quick-ref__brand" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-muted'">{{ item.ref ? ' · ' : '' }}{{ item.brand.name }}</span></div>
                          <div v-if="item.priceTaxIncl || (item.gratuities && item.gratuities.length) || hasMobileStock(item)" class="m-quick-line">
                            <span v-if="item.priceTaxIncl" class="m-quick-price">{{ item.priceTaxIncl }} <small>TTC</small></span>
                            <div v-if="gratuitiesWithStartingFrom(item).length" class="promo-offers promo-offers--mobile">
                              
                              <span v-for="(itemGrat, index) in gratuitiesWithStartingFrom(item)" :key="index" class="promo-offer promo-offer--mobile">
                                <strong>{{ formatGratuityOffer(itemGrat) }}</strong>
                                <small>{{ formatGratuityStartingFrom(itemGrat) }}</small>
                              </span>
                            </div>
                            <span v-for="(itemGrat, index) in gratuitiesWithoutStartingFrom(item)" :key="`legacy-${index}`" class="badge badge-primary text-white font-weight-bold font-size-12 p-1">
                              <i class="fas fa-star mr-1"/>{{itemGrat.gratuity}} +{{itemGrat.gratuityGranted}}
                            </span>
                            <span v-if="hasMobileStock(item)" class="m-quick-stock"><CatalogStockStatus :item="item" :value="item.stockStatus" /></span>
                          </div>
                        </template>
                        <div v-if="isMobileCatalog" class="m-quick m-quick--add d-flex">
                          <div v-if="item.stockStatus !== 6 && item.stockStatus !== 7 " class="input-group mb-0 m-quick__add" :class="!item.id || item.stockStatus == 2 || item.stockStatus == 3 || (role ==1 && selectedCustomer == null) || (item.stockStatus == 4 && item.maxPerDay <= item.alreadyOrderedPerDay) ? 'd-none' : ''">
                            <span v-if="item.multiple && item.multiple != 1" class="input-group-prepend my-auto pr-1 text-success font-size-12" :title="'Multiple de ' + item.multiple">{{item.multiple}} x</span>
                            <b-form-input type="number" class="no-shadow p-1 form-control form-control-sm font-weight-bold font-size-14 text-right"
                              v-model="item.quantity" @keyup.native.enter="addToOrder(item)"/>
                            <div size="sm" class="input-group-append">
                              <button type="button" class="btn input-group-text text-dark btn-link btn-sm" @click="addToOrder(item)" :disabled="isAddToOrderStarting">
                                <i v-if="!isAddToOrderStarting" class=" fas fa-shopping-cart font-size-14"> </i>
                                <b-spinner v-if="isAddToOrderStarting" small ></b-spinner>
                              </button>
                            </div>
                          </div>
                        </div>

                  </template>

                  <template v-slot:cell(image)="{item}">
                    <i v-if="item.image" 
                          class="fas fa-image ml-2 font-size-24 text-dark font-weight-bold float-right item-align-center" 
                          title="image" 
                          style="border-radius:5px; cursor: pointer;" 
                          @click.stop="openImageModal(item)">
                        </i>   
                  </template>

                  <template v-slot:cell(packageCount)="{value}">
                    {{value ? value + ' / carton' : '-'}} 
                  </template>

                  <template v-slot:cell(gratuity)="{item}">
                    <div v-if="gratuitiesWithStartingFrom(item).length" class="promo-offers">
                      
                      <span v-for="(itemGrat, index) in gratuitiesWithStartingFrom(item)" :key="index" class="promo-offer">
                        <strong>{{ formatGratuityOffer(itemGrat) }}</strong>
                        <small>{{ formatGratuityStartingFrom(itemGrat) }}</small>
                      </span>
                    </div>
                    <span  v-for="(itemGrat, index) in gratuitiesWithoutStartingFrom(item)" :key="`legacy-${index}`" href="javascript: void(0);" class="m-1 badge badge-primary text-white font-weight-bold font-size-14 p-1">
                      <i class="fas fa-star  mr-1"/>{{itemGrat.gratuity}} +{{itemGrat.gratuityGranted}}
                    </span>
                  </template>

                  <template  v-slot:cell(action)="{item}">
                    <div v-if="item.stockStatus !== 6 && item.stockStatus !== 7 " class="input-group    mb-0" style="width: 7em;" :class="!item.id || item.stockStatus == 2 || item.stockStatus == 3 || (role ==1 && selectedCustomer == null) || (item.stockStatus == 4 && item.maxPerDay <= item.alreadyOrderedPerDay) ? 'd-none' : ''">
                      <b-form-input  type="number" class="no-shadow p-1 form-control form-control-sm font-weight-bold font-size-14 text-right"
                        v-model="item.quantity" @keyup.native.enter="addToOrder(item)"/>
                      <div size="sm" class="input-group-append">
                        <button  type="button"  class="btn input-group-text text-dark btn-link btn-sm" @click="addToOrder(item)" :disabled="isAddToOrderStarting"> 
                          <i v-if="!isAddToOrderStarting"  class=" fas fa-shopping-cart font-size-14"> </i>
                          <b-spinner v-if="isAddToOrderStarting" small ></b-spinner>
                        </button>
                      </div>
                    </div>
                  </template>

                  <template  v-slot:cell(stockStatus)="{item, value}">
                    <CatalogStockStatus :item="item" :value="value" />
                  </template>

                  <!--template v-slot:cell(show_similair)="{item}">
                    <span><i :title="$t('catalog.similairItems.title')" class="fab fa-creative-commons-nd font-size-22 text-warning" style="cursor: pointer; " @click="getSimilairItems(item)" ></i></span>
                  </template-->


                  <!-- <template v-slot:cell(modal)="{item}">
                      <i class="far fa-list-alt font-size-18 text-primary" style="cursor:pointer" @click="showDetailsModal=true;selectedItem=item;getItemsManufacturers();" ></i>
                  </template> -->
                              </b-table>
                              <span v-if="!isSimilairItemsTableBusy && !similairItemsList.length" class="d-flex justify-content-center m-4 text-muted" >{{ $t("catalog.empty") }} </span>
                              <!-- Pagination -->
                              <div class="row pt-3 pl-2 mb-1">
                                  <div class="col-sm-8">
                                      <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                          <b-form-select @input="getSimilairItems([cardItem])"  v-model="similairItemsPagemodel.perPage" size="sm" style="width: 5em" :options="paginationOptions"></b-form-select>
                                          <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{similairItemsPagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                                      </div>
                                  </div>
                                  <div class="col-sm-4">
                                      <div class="dataTables_paginate paging_simple_numbers float-right">
                                          <ul class="pagination pagination-rounded mb-0">
                                          <b-pagination v-model="similairItemsPagemodel.currentPage" :per-page="similairItemsPagemodel.pageSize" :total-rows="similairItemsPagemodel.totalRows" @input="getSimilairItems([cardItem])" :disabled="isSimilairItemsTableBusy" ></b-pagination>
                                          </ul>
                                      </div>
                                  </div>
                              </div> 
                              <!-- Fin Pagination  -->
                            </div>
                
              
                          </b-card>
                        </div>
                  </div>
                  <!-- End Equivalences -->
                  <!-- ---------------- -->


                  <!-- --- -->
                  <!-- KITS -->

            

                  <div v-if="recommandationItemFeatureIsEnable" class="row d-print-none ">
                        <div  class ="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                          <b-card id="kitItemsCard" no-body header-class="bg-transparent border-secondary" class="rel-card mb-0 mt-4" > 
                            <div class="row rel-card__head">
                              <div class="col-12">
                                <h5 class="rel-card__title"><span class="rel-card__caption">Souvent Commandés Avec</span><span class="rel-card__item">{{cardItem ? "" + cardItem.title + "" : ""}}</span></h5>
                              </div>
                              <!-- <div class="col-1 text-right ">
                                  <i  class=" fas fa-times font-size-16 pr-4 pt-2 pb-2 text-danger" @click="showcard=false" style="cursor:pointer" :title="$t('datPicker.label-close-button')"> </i>
                              </div> -->
                            </div>
                            <div class="table-responsive mb-0">
                              <b-table
                                
                                :small="true"
                                :hover="false"
                                :no-border-collapse="true"
                                class="rel-grid"
                                :busy="isKitItemsTableBusy"
                                :items="kitItemsList"
                                :fields="computedItemsListFields"
                                
                              >

                              <template v-slot:head(ref)>
                    {{ $t("catalog.header.reference") }} 
                  </template>
                  <template v-slot:head(title)>
                    {{ $t("catalog.header.title") }} 
                  </template>
                  <template v-slot:head(position)>
                    {{ $t("catalog.header.shockAbsorberPosition") }} 
                  </template>
                  <template v-slot:head(brand)>
                    Laboratoire
                  </template>
                  <template v-slot:head(price)>
                    {{ $t("catalog.header.price") }} 
                  </template>
                  <template v-slot:head(discountStr)>
                    {{ $t("catalog.header.discount") }} 
                  </template>
                  <template v-slot:head(discountedPrice)>
                    {{ $t("catalog.header.discountedPrice") }} 
                  </template>
                  <!-- <template v-slot:head(modal)>
                    {{ $t("catalog.header.modal") }} 
                  </template>
                  <template v-slot:head(salesUnit)>
                    {{ $t("catalog.header.multiple") }} 
                  </template> -->
                  <template v-slot:head(stockStatus)>
                    {{ $t("catalog.header.stockStatus") }} 
                  </template>
                  <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                  </template>
                  <template v-slot:cell(discountStr)="{value}">
                    {{value == 0 || value ==null ? '_' : value+'%'}} 
                  </template>
                  <template v-slot:cell(price)="{item,value}">
                    <div :class="item.stockStatus == 2 ? 'text-secondary' : item.stockStatus == 3 ? '' : 'text-dark'">{{value ? value : '_'}} </div>
                  </template>
                  <template v-slot:cell(priceTaxIncl)="{item, value}">
                    <!-- {{value ? value : '_'}}  -->
                    <div :style="item.vat || item.pricePublic ? 'margin:2px' : ''" :class="item.stockStatus == 2 ? 'text-secondary' : item.stockStatus == 3 ? '' : 'text-dark'">{{value ? value : '_'}} </div>

                    <div v-if="item.vat" class="text-muted font-weight-normal">{{item.vat ? 'TVA: ' + item.vat + '%' : '' }}</div>
                    <!-- <div v-if="item.vat" class="text-muted font-weight-normal">{{item.vat && item.priceTaxIncl ? 'TTC: ' + item.priceTaxIncl : '' }}</div> -->
                    <!-- <div v-if="item.pricePublic" class="text-muted font-weight-normal">{{item.pricePublic ? 'Public: ' + item.pricePublic : '' }}</div> -->

                  </template>
                  <template v-slot:cell(brand)="{value}">
                    {{value.name}} 
                  </template>

                  <template v-slot:cell(ref)="{item}">
                    <span class="font-size-12 font-weight-bold" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-dark'">{{item.ref }}  </span>
                  </template>

                  <template v-slot:cell(title)="{item}">
                    <span class="font-size-12 font-weight-bold" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-dark'">{{item.title }} <sup> <i v-if="item.isFrigo" class="fas fa-snowflake ml-2 font-size-14 text-primary font-weight-bold" title="Produit Réfrigérateur" style="border-radius:5px; "></i> </sup> </span>
                    <div v-if="item.brand && item.brand.name && !isMobileCatalog" class="font-size-12 font-weight-normal" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-muted'">{{ item.brand ? item.brand.name : '-' }}</div> 
                    <div v-if="item.pharmaDci" class="font-size-12 font-weight-normal" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-muted'">{{ item.pharmaDci }}</div> 
                        <!-- VUE_APP_FEATURE_MOBILE_CATALOG, only when the add-to-cart column is off screen (isMobileCatalog):
                             ref · brand, then price · promo · stock (same CatalogStockStatus as the Stock column), then the same add
                             control as the add-to-cart column, which is hidden in this mode (same hide rules, same addToOrder) -->
                        <template v-if="isMobileCatalog">
                          <!-- mobile lines: missing information is left out (no "_" placeholders) -->
                          <div v-if="item.ref || (item.brand && item.brand.name)" class="m-quick-ref">{{ item.ref }}<span v-if="item.brand && item.brand.name" class="m-quick-ref__brand" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-muted'">{{ item.ref ? ' · ' : '' }}{{ item.brand.name }}</span></div>
                          <div v-if="item.priceTaxIncl || (item.gratuities && item.gratuities.length) || hasMobileStock(item)" class="m-quick-line">
                            <span v-if="item.priceTaxIncl" class="m-quick-price">{{ item.priceTaxIncl }} <small>TTC</small></span>
                            <div v-if="gratuitiesWithStartingFrom(item).length" class="promo-offers promo-offers--mobile">
                              
                              <span v-for="(itemGrat, index) in gratuitiesWithStartingFrom(item)" :key="index" class="promo-offer promo-offer--mobile">
                                <strong>{{ formatGratuityOffer(itemGrat) }}</strong>
                                <small>{{ formatGratuityStartingFrom(itemGrat) }}</small>
                              </span>
                            </div>
                            <span v-for="(itemGrat, index) in gratuitiesWithoutStartingFrom(item)" :key="`legacy-${index}`" class="badge badge-primary text-white font-weight-bold font-size-12 p-1">
                              <i class="fas fa-star mr-1"/>{{itemGrat.gratuity}} +{{itemGrat.gratuityGranted}}
                            </span>
                            <span v-if="hasMobileStock(item)" class="m-quick-stock"><CatalogStockStatus :item="item" :value="item.stockStatus" /></span>
                          </div>
                        </template>
                        <div v-if="isMobileCatalog" class="m-quick m-quick--add d-flex">
                          <div v-if="item.stockStatus !== 6 && item.stockStatus !== 7 " class="input-group mb-0 m-quick__add" :class="!item.id || item.stockStatus == 2 || item.stockStatus == 3 || (role ==1 && selectedCustomer == null) || (item.stockStatus == 4 && item.maxPerDay <= item.alreadyOrderedPerDay) ? 'd-none' : ''">
                            <span v-if="item.multiple && item.multiple != 1" class="input-group-prepend my-auto pr-1 text-success font-size-12" :title="'Multiple de ' + item.multiple">{{item.multiple}} x</span>
                            <b-form-input type="number" class="no-shadow p-1 form-control form-control-sm font-weight-bold font-size-14 text-right"
                              v-model="item.quantity" @keyup.native.enter="addToOrder(item)"/>
                            <div size="sm" class="input-group-append">
                              <button type="button" class="btn input-group-text text-dark btn-link btn-sm" @click="addToOrder(item)" :disabled="isAddToOrderStarting">
                                <i v-if="!isAddToOrderStarting" class=" fas fa-shopping-cart font-size-14"> </i>
                                <b-spinner v-if="isAddToOrderStarting" small ></b-spinner>
                              </button>
                            </div>
                          </div>
                        </div>

                  </template>

                  <template v-slot:cell(image)="{item}">
                    <i v-if="item.image" 
                          class="fas fa-image ml-2 font-size-24 text-dark font-weight-bold float-right item-align-center" 
                          title="image" 
                          style="border-radius:5px; cursor: pointer;" 
                          @click.stop="openImageModal(item)">
                        </i>   
                  </template>

                  <template v-slot:cell(packageCount)="{value}">
                    {{value ? value + ' / carton' : '-'}} 
                  </template>

                  <template v-slot:cell(gratuity)="{item}">
                    <div v-if="gratuitiesWithStartingFrom(item).length" class="promo-offers">
                      
                      <span v-for="(itemGrat, index) in gratuitiesWithStartingFrom(item)" :key="index" class="promo-offer">
                        <strong>{{ formatGratuityOffer(itemGrat) }}</strong>
                        <small>{{ formatGratuityStartingFrom(itemGrat) }}</small>
                      </span>
                    </div>
                    <span  v-for="(itemGrat, index) in gratuitiesWithoutStartingFrom(item)" :key="`legacy-${index}`" href="javascript: void(0);" class="m-1 badge badge-primary text-white font-weight-bold font-size-14 p-1">
                      <i class="fas fa-star  mr-1"/>{{itemGrat.gratuity}} +{{itemGrat.gratuityGranted}}
                    </span>
                  </template>

                  <template  v-slot:cell(action)="{item}">
                    <div  v-if="item.stockStatus !== 6 && item.stockStatus !== 7 " class="input-group    mb-0" style="width: 7em;" :class="!item.id || item.stockStatus == 2 || item.stockStatus == 3 || (role ==1 && selectedCustomer == null) || (item.stockStatus == 4 && item.maxPerDay <= item.alreadyOrderedPerDay) ? 'd-none' : ''">
                      <b-form-input  type="number" class="no-shadow p-1 form-control form-control-sm font-weight-bold font-size-14 text-right"
                        v-model="item.quantity" @keyup.native.enter="addToOrder(item)"/>
                      <div size="sm" class="input-group-append">
                        <button  type="button"  class="btn input-group-text text-dark btn-link btn-sm" @click="addToOrder(item)" :disabled="isAddToOrderStarting"> 
                          <i v-if="!isAddToOrderStarting"  class=" fas fa-shopping-cart font-size-14"> </i>
                          <b-spinner v-if="isAddToOrderStarting" small ></b-spinner>
                        </button>
                      </div>
                    </div>
                  </template>

                  <template  v-slot:cell(stockStatus)="{item, value}">
                    <CatalogStockStatus :item="item" :value="value" />
                  </template>
                           
                              </b-table>
                              <span v-if="!isKitItemsTableBusy && !kitItemsList.length" class="d-flex justify-content-center m-4 text-muted" >{{ $t("catalog.empty") }} </span>
                              <!-- Pagination -->
                               <div class="row pt-3 pl-2 mb-1">
                                  <div class="col-sm-8">
                                      <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                          <b-form-select @input="getRecommendedItemslist([cardItem])"  v-model="kitItemsPagemodel.perPage" size="sm" style="width: 5em" :options="paginationOptions"></b-form-select>
                                          <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{kitItemsPagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                                      </div>
                                  </div>
                                  <div class="col-sm-4">
                                      <div class="dataTables_paginate paging_simple_numbers float-right">
                                          <ul class="pagination pagination-rounded mb-0">
                                          <b-pagination v-model="kitItemsPagemodel.currentPage" :per-page="kitItemsPagemodel.pageSize" :total-rows="kitItemsPagemodel.totalRows" @input="getRecommendedItemslist([cardItem])" :disabled="isKitItemsTableBusy" ></b-pagination>
                                          </ul>
                                      </div>
                                  </div>
                              </div>  
                              <!-- Fin Pagination  -->
                            </div>
                
                            
              
                          </b-card>
                        </div>
                  </div>
                  <!-- KITS -->
                  <!-- ---- -->





                  <div class="row pt-1" >
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <p class="text-secondary mb-0 pb-0 mt-3">
                          <i>Les <strong>promotions</strong> seront accordées dans la <strong>limite des stocks disponibles</strong> pour la promotion.</i>
                          <br/><i>L'ajout des articles au bon de commande ne garantit pas leur réservation. La <strong>réservation</strong> ne sera effective qu'<strong>après validation de la commande</strong>.</i>
                        </p>
                    </div>
                  </div>


          </div>
        </div>
      </div>
        <div
          v-if="isCollapseCartBox && collapsed && !isQuickOrder"
          class="col-xl-0-5 d-xl-block d-none mt-2 align-items-center justify-content-center"
          :class="isLegacyCollapsedCart ? 'pr-sm-4' : 'pr-sm-2'"
        >
          <div v-if="isLegacyCollapsedCart" class="card h-100 fancy-card">
            <div class="card-body icon-column">
              <div
                class="icon-with-label"
                v-for="(item, index) in icons"
                :key="item.title"
                @click="toggleCollapse(index)"
                style="position: relative"
              >
                <!-- <img :src="item.src" :alt="item.title" class="icon-img"  :height="item.height" /> -->

                <div class="tooltip-wrapper">
                  <img :src="item.src" :alt="item.title" class="icon-img" :height="item.height" />
                  <span class="custom-tooltip">{{ item.title }}</span>
                </div>

                <span
                  v-if="index === 2 "
                  class="badge badge-danger badge-pill custom-badge"
                  :class="{ 'd-none': orderLinesPara.length === 0 }"
                >
                  {{orderLinesPara.length }}
                </span>

                <span
                  v-if="index === 1"
                  class="badge badge-danger badge-pill custom-badge"
                  :class="{ 'd-none': orderLinesPharma.length === 0 }"
                >
                  {{orderLinesPharma.length}}
                </span>

                <!-- <div class="vertical-title">{{ item.title }}</div> -->
              </div>

            </div>
          </div>
          <!-- collapsed cart, every instance with the feature except CAB: labelled rail with counts and the order total;
               each item opens the cart exactly like the icon column (same toggleCollapse index, 3 = drafts tab) -->
          <div v-else class="card h-100 cart-rail-card">
            <nav class="cart-rail" aria-label="Commande en cours">
              <span v-if="hasAgencySelector && cartAgencyName" class="cart-rail__agency" :style="cartAgencyColorStyle" :title="'Commande sur l\'agence ' + cartAgencyName">{{ cartAgencyName }}</span>
              <button v-if="!isQuickOrder" type="button" class="cart-rail__item cart-rail__item--open" title="Ouvrir la commande" @click="toggleCollapse(0)">
                <span class="cart-rail__icon"><i class="bx bx-chevrons-left" aria-hidden="true"></i></span>
                <span class="cart-rail__label">Ouvrir</span>
              </button>
              <span class="cart-rail__sep" aria-hidden="true"></span>
              <button type="button" class="cart-rail__item" title="Commande médicale" @click="toggleCollapse(1)">
                <span class="cart-rail__icon">
                  <i class="bx bx-plus-medical" aria-hidden="true"></i>
                  <span v-if="orderLinesPharma.length" class="cart-rail__badge">{{ orderLinesPharma.length }}</span>
                </span>
                <span class="cart-rail__label">Médicale</span>
              </button>
              <button type="button" class="cart-rail__item" title="Commande para" @click="toggleCollapse(2)">
                <span class="cart-rail__icon">
                  <i class="bx bx-spa" aria-hidden="true"></i>
                  <span v-if="orderLinesPara.length" class="cart-rail__badge">{{ orderLinesPara.length }}</span>
                </span>
                <span class="cart-rail__label">Para</span>
              </button>
              <span class="cart-rail__sep" aria-hidden="true"></span>
              <button type="button" class="cart-rail__item" title="Brouillons" @click="toggleCollapse(3)">
                <span class="cart-rail__icon"><i class="bx bx-edit-alt" aria-hidden="true"></i></span>
                <span class="cart-rail__label">Brouillons</span>
              </button>
              <button v-if="orderLines.length && order.totalWithTaxes" type="button" class="cart-rail__total" title="Total TTC de la commande" @click="toggleCollapse(0)">
                <i class="bx bx-cart" aria-hidden="true"></i>
                <span class="cart-rail__total-value">{{ order.totalWithTaxes }}</span>
                <span class="cart-rail__total-label">Total TTC</span>
              </button>
            </nav>
          </div>
        </div>



        <!-- Saisie rapide lives in this column: never collapsed in quick mode (the rail would hide the whole form) -->
        <div v-if="isLgScreen || !isCollapseCartBox || (isCollapseCartBox && !collapsed ) || isQuickOrder"
          ref="cartColumn"
          class="mt-2 pr-sm-4 align-items-center justify-content-center cart-col"
:class="[isQuickOrder ? 'col-12 pl-xl-2 ' : 'col-xl-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-xl-2 ', quickOrderIsEnable ? 'qo-cart-col' : '']"
        >
        <div class="card" :class=" isQuickOrder ? '' : 'h-100'">
            <div class="card-body border border-primary card bg-Default">
            <!-- empty without the collapse icon: not rendered in quick mode so "Saisie rapide" sits exactly like "Catalogue des articles"
                 (a d-none class would lose to d-flex, both are !important) -->
            <!-- no "Réduire" in quick mode: collapsing would hide the Saisie rapide form -->
            <div v-if="!isQuickOrder" class="d-flex align-items-start mb-3">
                 <!--i class="mr-1 text-muted" @click="toggleCollapse" style="cursor: pointer;">Minimiser</i-->
                <img v-if="isCollapseCartBox && isLegacyCollapsedCart" @click="toggleCollapse" src="@/assets/images/double-arrow-right.svg" height="17px"  style="cursor: pointer;" />
                <button v-else-if="isCollapseCartBox && !isLgScreen && !isQuickOrder" type="button" class="cart-rail-collapse" title="Réduire la commande" @click="toggleCollapse">
                  <i class="bx bx-chevrons-right" aria-hidden="true"></i>Réduire
                </button>
            </div>

              <!-- Quick order mode: same header as "Catalogue des articles", switch in front of the title -->
              <div v-if="quickOrderIsEnable && isQuickOrder" class="pt-1 row mb-4 qo-mode-enter">
                <div class="col-6">
                  <h3 class="text-primary font-weight-bold">Saisie rapide</h3>
                </div>
                <div class="col-6 text-right">
                  <div class="d-none d-md-block">
                    <quick-order-switch v-model="isQuickOrder" hint />
                  </div>
                </div>
              </div>
              <!-- quick order mode: labelled underlined tabs (not the Catalogue | Saisie rapide switch look); catalogue mode keeps its tabs -->
              <b-tabs v-model="activeTabIndex" :fill="!isQuickOrder" :nav-class="isQuickOrder ? 'qo-cart-tabs' : 'nav-tabs-custom'" content-class="p-0 text-muted" :align="isQuickOrder ? 'left' : 'center'" :active-nav-item-class="isQuickOrder ? '' : 'font-weight-bold text-uppercase '">
                <b-tab ref="orderLines-tab"  lazy  >
                  <template v-slot:title>
                    <span v-if="isQuickOrder" class="qo-cart-tab"><i class="bx bx-cart" aria-hidden="true"></i>Commande</span>
                    <span v-else class="d-inline-block p-0 font-size-14">
                      <i class="fas fa-cart-plus mr-2 font-size-16 text-primary"></i> {{$t('orderTabs.newOrderTab.title')}}
                      <!-- <br><span class="text-primary">Commandes</span> -->
                    </span>
                    <!-- <i class="d-none d-sm-inline-block fas fa-dolly font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('orderTabs.newOrderTab.title')}}</span> -->
                  </template>
                  <div >
                    <div :style="{ minHeight: isQuickOrder ? '25em' : '65em' }">

                      <AgentSelectorComponent v-if="isQuickOrder && quickOrderIsEnable"
                        v-model="pendingSelectedAgency"
                        :visible="hasAgencySelector && ((role === 1 && selectedCustomer != null) || role === 0)"
                        :agency-select-options="agencySelectOptions"
                        :selected-agency-color-style="selectedAgencyColorStyle"
                    :active-agency-id="selectedAgency"
                    :cart-has-items="orderLines.length > 0"
                        :can-request-agency-change="canRequestAgencyChange"
                        :selected-agency-name="selectedAgencyName"
                        :active-agency-name="activeAgencyName"
                        :pending-agency-name="pendingAgencyName"
                        @confirm="confirmAgencyChange"
                        @cancel="cancelAgencyChange"
                      />

                      <div class="row pt-4 mt-3">

                        <div v-if="hasAgencySelector && order && order.dbId" class="font-size-14 col-12 text-center mb-2 text-uppercase font-weight-bold">
                          Agence {{ getOrderAgencyName(order.dbId) }}
                        </div>
                        <div v-if="hasAgencySelector && !(order && order.dbId) && cartAgencyName" class="col-12 text-center mb-2">
                          <span class="agency-scope-chip" :style="cartAgencyColorStyle"><i class="bx bx-map" aria-hidden="true"></i>Nouvelle commande : <strong>{{ cartAgencyName }}</strong></span>
                        </div>

                        <div :class="quickOrderIsEnable ? 'text-left col-md-6 col-12' : 'text-center col-12' " >
                          <h5 class="card-title  mb-0 text-dark ">
                            {{$t('orderTabs.newOrderTab.cardTitle')}} 
                          </h5>
                        
                          <h6 class="card-title pt-0 mt-1 mb-0 text-dark font-weight-normal" :class="role==1 ? '' : 'd-none'">
                            {{order.customerName}}
                          </h6>
                        </div>

                      </div>


                      <!-- quick order mode: CSV import at the top of the order (the import itself runs in QuickOrder) -->
                      <div v-if="isQuickOrder && quickOrderIsEnable && isQuickOrderCsvImportEnabled" ref="quickOrderImportBox" class="qo-import qo-mode-enter qo-mode-enter--d1">
                        <span class="qo-import__icon" aria-hidden="true"><i class="bx bx-spreadsheet"></i></span>
                        <div class="qo-import__body">
                          <p class="qo-import__title">Vous avez déjà votre commande dans un fichier ?</p>
                          <p class="qo-import__text">Importez toutes les lignes en une fois depuis un fichier CSV ou TXT (Code à barre ; Code PCT ; Désignation ; Quantité) ou depuis le fichier Excel du bon de commande (code en colonne A, quantité en colonne B, à partir de la ligne 10).</p>
                        </div>
                        <div class="qo-import__actions">
                          <button type="button" class="qo-import__template" @click="$refs.quickOrder && $refs.quickOrder.downloadImportTemplate('txt')">
                            <i class="bx bx-download" aria-hidden="true"></i>Modèle TXT/CSV
                          </button>
                          <button type="button" class="qo-import__template" @click="$refs.quickOrder && $refs.quickOrder.downloadImportTemplate('xls')">
                            <i class="bx bx-download" aria-hidden="true"></i>Modèle Excel
                          </button>
                          <b-button variant="primary" class="qo-import__button" :disabled="quickOrderCsvImporting" @click="$refs.quickOrder && $refs.quickOrder.selectCsvFile()">
                            <b-spinner v-if="quickOrderCsvImporting" small class="mr-1"></b-spinner>
                            <i v-else class="bx bx-upload mr-1" aria-hidden="true"></i>
                            Importer une commande
                          </b-button>
                        </div>
                      </div>

                      <!-- cancelling the whole order: clear destructive button, same action (every instance, catalogue and Saisie rapide) -->
                      <div v-if="order.id" class="order-cancel">
                        <button type="button" class="order-cancel__btn" :title="$t('orderTabs.newOrderTab.clearOderButtonTitle')" @click="cancelOrder()">
                          <i class="bx bx-trash" aria-hidden="true"></i>Annuler toute la commande
                        </button>
                      </div>  

                      <div v-if="isQuickOrder && quickOrderIsEnable" ref="quickOrderSection" class="qo-mode-enter qo-mode-enter--d2">
                        <QuickOrder
                          ref="quickOrder"
                          class="mt-3"
                          :order="order"
                          :db-agency-id="selectedAgency"
                          :csv-import-errors-value.sync="quickOrderCsvImportErrors"
                          @refresh="refresh"
                          @csv-importing="quickOrderCsvImporting = $event"
                          :key="quickOrderRefreshKey"
                          @handlePanacheItemsError="handlePanacheItemsError"
                        />
                      </div>


                      <!-- <div class="row pb-3 pt-3">
                        <div class="col-11" >
                          
                          
                        </div>
                        <div class="col-1 text-right">
                         
                          <a :title="$t('orderTabs.newOrderTab.clearOderButtonTitle')" href="javascript:void(0);"  @click="cancelOrder()" class="action-icon text-danger">
                            <i class="fas fa-times font-size-14" />
                            
                          </a>  
                        </div>
                      </div> -->

                      <!-- COMMANDE MEDICALE -->
                      <div v-if="!isParaOnly" :class="isQuickOrder && orderLinesPharma && !orderLinesPharma.length ? 'd-none' : ''">
                        <div  class="row mt-4 mb-2"  style="border-radius:5px 0px 5px 0px;">
                          <div class="col-11" :class="isQuickOrder ? 'd-none' : ''">
                              <span v-if="this.order && this.order.id" class="font-weight-bold text-dark">Commande Médicale</span>
                          </div>
                          <!-- <div  class="col-1 text-right">
                              <a :title="$t('orderTabs.newOrderTab.clearOderButtonTitle')" href="javascript:void(0);"  @click="cancelOrder()" class="action-icon text-danger">
                                <i class="fas fa-times font-size-14" />
                              </a>  
                          </div> -->
                        </div>
                        
                        <div class="table-responsive mb-0"  >
                          
                            <b-table
                              :striped="true"
                              :small="!isQuickOrder"
                              :hover="true"
                              :items="orderLinesPharma"
                              :fields="isQuickOrder ? quickOrderFields : orderFields"
                              sortKey="itemTitle"
                              responsive
                            >
                      <template v-slot:head(ref)>

                        {{ isQuickOrder ? 'Commande Médicale' : $t("orderTabs.newOrderTab.orderFields.ref") }}

                      </template>
                      <template v-slot:head(itemTitle)> 
                        {{ isQuickOrder ? '' : $t("orderTabs.newOrderTab.orderFields.itemTitle") }}
                      </template>
                      <template v-slot:head(quantity)>
                        {{ isQuickOrder ? '' :  $t("orderTabs.newOrderTab.orderFields.quantity") }}
                      </template>
                      <template v-slot:head(price)>
                        {{ isQuickOrder ? '' :  $t("orderTabs.newOrderTab.orderFields.price")  }}
                      </template>
                      <template v-slot:head(lineTotalAmount)>
                        {{ isQuickOrder ? '' :  $t("orderTabs.newOrderTab.orderFields.total")  }}
                      </template>

                      <template v-slot:cell(ref)="{item}">
                        <a v-if="!item.isGratuity" :title="$t('parameters.hover.delete')" href="javascript:void(0);"  @click="removeOrderLine(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-danger">
                            <i class="fas fa-times font-size-14 mr-2" />
                          </a>  
                          <i v-if="item.isGratuity" class="fas fa-star text-success font-size-12 " />
                          <span class="text-black ml-1" :class="item.isGratuity ? 'text-success font-weight-bold' : 'text-black'">{{item.ref}}</span>                                                            
                      </template>

                      <template v-slot:cell(itemTitle)="{item}">
                        <a v-if="!item.isGratuity" :title="$t('parameters.hover.delete')" href="javascript:void(0);"  @click="removeOrderLine(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-danger">
                            <i class="fas fa-times font-size-14 mr-2" />
                          </a>  
                          <i v-if="item.isGratuity" class="fas fa-star text-success font-size-12 " />
                          <span class="text-black ml-1" :class="item.isGratuity ? 'text-success font-weight-bold' : 'text-black'">{{item.itemTitle}}</span>                                          
                         
                          <div v-if="item.isGratuityWarning && item.isGratuity">
                            <span class="font-size-12 text-danger ">
                              <i class="fas fa-exclamation-triangle mr-1" />  
                              <i>Quantité de promo insuffisante</i>
                            </span>
                          </div>
                          
                          <div v-if="item.oldOrderWarning">
                            <span class="font-size-12 text-primary ">
                              <router-link  target="_blank" :to="{ path: '/orders/order', query: { orderId: item.oldOrderWarning }}">
                                <i class="fas fa-info-circle mr-1" />  
                                <i>Déjà <u class="font-weight-bold">commandé</u> aujourd'hui</i>
                              </router-link>
                            </span>
                          </div>
                      </template>

                      <template v-slot:cell(price)="{item}">
                          <span class="text-black font-weight-normal ml-2">{{item.discountedPrice }}</span>                                          
                      </template>
                      <template v-slot:cell(quantity)="{value, item}">
                          <span v-if="!item.isOrderQuantityEdit"  :class="item.isGratuity ? 'text-success font-weight-bold' : 'text-black'">{{value}}</span>      
                          <a  v-if="!item.isOrderQuantityEdit && !item.isGratuity" @click="item.isOrderQuantityEdit = true" :title="$t('parameters.hover.editQty')" href="javascript:void(0);" :class="item.itemId ? '' : 'd-none'" class="action-icon text-warning">
                            <i class="fas fa-pencil-alt  ml-2 font-size-13"  @click="item.isOrderQuantityEdit = true; item.editedQuantity = item.quantity;"/>
                          </a>
                          <i v-if="item.isGratuity" class="fas fa-star text-info invisible  ml-2 font-size-12 " />

                          <div v-if="item.isOrderQuantityEdit" class="input-group input-group-sm pull-right mb-0" style="width:85px;" :class="isQuickOrder ? 'w-100' : ''">
                            <b-form-input v-model="item.editedQuantity" type="number"  size="sm" class="no-shadow p-1" @keyup.native.enter="editOrderLine(item)"></b-form-input>
                              <div class="input-group-append"  size="sm" >
                                <b-button variant="link"  size="sm" title="Changer la quantité"><i class="font-size-12 fas fa-pencil-alt text-warning" @click="editOrderLine(item)"></i></b-button>
                              </div>
                          </div>
                      </template>
                          </b-table>

                        </div>
                        <div v-if="this.order && this.order.id" class="col-sm-12 text-right mt-2 mb-2" >
                          <span class="text-muted pt-2 font-weight-bold" ><span class="text-muted font-weight-normal mr-2">Sous Total HT</span> {{order.totalPharma ? order.totalPharma : '_'}}</span>
                        </div>
                      </div>
                      
                      <div v-if="this.order && this.order.id" :class="isQuickOrder && orderLinesPara && !orderLinesPara.length ? 'd-none' : ''">
                        <div class="row pt-4 mt-4 mb-2"  style="border-radius:5px 0px 5px 0px;">
                          <div v-if="!isParaOnly" class="col-11" :class="isQuickOrder ? 'd-none' : ''" >
                              <span class=" text-dark font-weight-bold">Commande Para</span>
                          </div>
                          <!-- <div class="col-1 text-right">
                              <a :title="$t('orderTabs.newOrderTab.clearOderButtonTitle')" href="javascript:void(0);"  @click="cancelOrder()" class="action-icon text-danger">
                                <i class="fas fa-times font-size-14" />
                              </a>  
                          </div> -->
                        </div>
                        <div class="table-responsive mb-0" >
                          
                          
                        
                          
                          <b-table
                            :striped="true"
                            :small="!isQuickOrder"
                            :hover="true"
                            :items="orderLinesPara"
                            :fields="isQuickOrder ? quickOrderFields : orderFields"
                            sortKey="itemTitle"
                            
                            responsive
                            >
                      <template v-slot:head(ref)>
                        {{ isQuickOrder ? 'Commande Para' : $t("orderTabs.newOrderTab.orderFields.ref") }}
                        
                      </template>
                      <template v-slot:head(itemTitle)> 
                        {{ isQuickOrder ? '' : $t("orderTabs.newOrderTab.orderFields.itemTitle") }}
                        
                      </template>
                      <template v-slot:head(quantity)>
                        {{ isQuickOrder ? '' : $t("orderTabs.newOrderTab.orderFields.quantity") }} 
                      </template>
                      <template v-slot:head(price)>
                        {{ isQuickOrder ? '' : $t("orderTabs.newOrderTab.orderFields.price") }} 
                      </template>
                      <template v-slot:head(lineTotalAmount)>
                        {{ isQuickOrder ? '' : $t("orderTabs.newOrderTab.orderFields.total") }} 
                      </template>
                      <template v-slot:cell(ref)="{item}">
                        <a v-if="!item.isGratuity" :title="$t('parameters.hover.delete')" href="javascript:void(0);"  @click="removeOrderLine(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-danger">
                            <i class="fas fa-times font-size-14 mr-2" />
                          </a>  
                          <i v-if="item.isGratuity" class="fas fa-star text-success font-size-12 " />
                          <span class="text-black ml-1" :class="item.isGratuity ? 'text-success font-weight-bold' : 'text-black'">{{item.ref}}</span>                                                            
                      </template>
                      <template v-slot:cell(itemTitle)="{item}">
                          <a v-if="!item.isGratuity" :title="$t('parameters.hover.delete')" href="javascript:void(0);"  @click="removeOrderLine(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-danger">
                            <i class="fas fa-times font-size-14 mr-2" />
                          </a>  
                          <i v-if="item.isGratuity" class="fas fa-star text-success font-size-12 " />
                          <span class="text-black ml-1" :class="item.isGratuity ? 'text-success font-weight-bold' : 'text-black'">{{item.itemTitle}}</span>                                          
                         
                          <div v-if="item.isGratuityWarning && item.isGratuity">
                            <span class="font-size-12 text-danger ">
                              <i class="fas fa-exclamation-triangle mr-1" />  
                              <i>Quantité de promo insuffisante</i>
                            </span>
                          </div>
                          
                          <div v-if="item.oldOrderWarning">
                            <span class="font-size-12 text-primary ">
                              <router-link  target="_blank" :to="{ path: '/orders/order', query: { orderId: item.oldOrderWarning }}">
                                <i class="fas fa-info-circle mr-1" />  
                                <i>Déjà <u class="font-weight-bold">commandé</u> aujourd'hui</i>
                              </router-link>
                            </span>
                          </div>
                          
                        
                        </template>
                      <template v-slot:cell(price)="{item}">
                          <span class="text-black font-weight-normal ml-2">{{item.discountedPrice }}</span>                                          
                      </template>
                      <template v-slot:cell(quantity)="{value, item}">
                          <span v-if="!item.isOrderQuantityEdit"  :class="item.isGratuity ? 'text-success font-weight-bold' : 'text-black'">{{value}}</span>      
                          <a  v-if="!item.isOrderQuantityEdit && !item.isGratuity" @click="item.isOrderQuantityEdit = true" :title="$t('parameters.hover.editQty')" href="javascript:void(0);" :class="item.itemId ? '' : 'd-none'" class="action-icon text-warning">
                            <i class="fas fa-pencil-alt  ml-2 font-size-13"  @click="item.isOrderQuantityEdit = true; item.editedQuantity = item.quantity;"/>
                          </a>
                          <i v-if="item.isGratuity" class="fas fa-star text-info invisible  ml-2 font-size-12 " />

                          <div v-if="item.isOrderQuantityEdit" class="input-group input-group-sm pull-right mb-0" style="width:85px;" :class="isQuickOrder ? 'w-100' : ''">
                            <b-form-input v-model="item.editedQuantity" type="number"  size="sm" class="no-shadow p-1" @keyup.native.enter="editOrderLine(item)"></b-form-input>
                              <div class="input-group-append"  size="sm" >
                                <b-button variant="link"  size="sm" title="Changer la quantité"><i class="font-size-12 fas fa-pencil-alt text-warning" @click="editOrderLine(item)"></i></b-button>
                              </div>
                          </div>
                      </template>
                          </b-table>


                        </div>
                        <div class="col-sm-12 text-right mt-2 mb-4" >
                          <span class="text-muted font-weight-bold" ><span class="text-muted font-weight-normal mr-2">Sous Total HT</span> {{order.totalPara ? order.totalPara : '_'}}</span>
                        </div>
                      </div>

                    </div>
                    <div :class="isQuickOrder ? 'float-right' : ''" :style="{ width: isQuickOrder ? '40em' : '' }" >
                      <div class="table-responsive pt-4 mt-4" >
                        <table class="table table-centered mb-0 table-nowrap table-sm borderless">
                          <tbody>
                            <!-- <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-right font-weight-bold text-primary">{{$t("orderTabs.newOrderTab.orderSheetFields.total") }}</h6>
                              </td>
                                                                    
                              <td class="text-right text-primary font-weight-bold">{{order.totalBeforeDiscount}}</td>
                            </tr>  -->
                            <!-- <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-right font-weight-bold text-primary">{{$t("orderTabs.newOrderTab.orderSheetFields.discountAmount") }}</h6>
                              </td>
                                                                    
                              <td class="text-right text-primary font-weight-bold">{{order.discountAmount}}</td>
                            </tr>  -->
                            <!-- <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-right">{{$t("orderTabs.newOrderTab.orderSheetFields.total") }}</h6>
                              </td>
                              <td class="text-right">{{order.total}}</td>
                            </tr> -->
                            <!-- <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right">{{$t("orderTabs.newOrderTab.orderSheetFields.discountAmount") }}</h6>
                              </td>
                              <td class="text-right">{{order.discountAmount}}</td>
                            </tr> -->
                            <!-- <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right">{{$t("orderTabs.newOrderTab.orderSheetFields.taxes") }}</h6>
                              </td>
                              <td class="text-right">{{order.taxes}}</td>
                            </tr> -->
                            <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-primary">Total HT</h6>
                              </td>
                              <td class="text-right text-primary font-weight-bold">{{order.total}}</td>
                            </tr>
                            <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right">{{$t("orderTabs.newOrderTab.orderSheetFields.vat") }}</h6>
                              </td>
                              <td class="text-right">{{order.vatAmount}}</td>
                            </tr> 
                            <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-primary">{{$t("orderTabs.newOrderTab.orderSheetFields.totalWithTaxes") }}</h6>
                              </td>
                              <td class="text-right text-primary font-weight-bold">{{order.totalWithTaxes}}</td>
                            </tr>
                            
                          </tbody>
                        </table>
                        <div class="row pb-0 pt-3">
                          <div class="col-sm-12">
                              <b-button variant="danger" style="width:100%" @click="checkOrder()" :disabled="this.isCheckingOrder || !this.orderLines.length"> 
                                <b-spinner small :class="this.isCheckingOrder ? '' : 'd-none'"></b-spinner>
                                <i class="bx bx-check-double font-size-24 align-middle mr-2"></i> 
                                <span class="font-weight-bold font-size-14">{{$t("orderTabs.newOrderTab.validateOrderButton") }}</span>
                                <span v-if="hasAgencySelector && this.selectedAgencyName && getOrderAgencyName(order.dbId)" class="order-validation-agency">Agence {{ getOrderAgencyName(order.dbId) }}</span>
                              </b-button>
                          </div>
                        </div>

                         
                      <p v-if="this.orderErrors" class="text-dark text-justify mt-4 "><strong class="text-danger mr-2"><i class="fas fa-exclamation-triangle mr-1"></i>ERREUR : </strong>{{this.orderErrors}}</p>
                      

                      </div>
                    </div>
                  </div>

                  <!-- <p class="mt-4 pt-4 text-justify"><i>L'ajout des articles au bon de commande ne garantit pas leur réservation. La réservation ne sera effective qu'après validation de la commande.</i></p> -->

                </b-tab>
                <!-- <b-tab  lazy >
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-question font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-question  font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('orderTabs.requestTab.title')}}</span>
                  </template>
                    <h5 class="card-title mt-3 mb-0 text-secondary text-center">{{$t('orderTabs.requestTab.cardTitle')}}</h5><br> 
                </b-tab> -->
                <b-tab @click="getDraftMethode()" lazy >
                  <template v-slot:title>
                    <span v-if="isQuickOrder" class="qo-cart-tab"><i class="bx bx-edit" aria-hidden="true"></i>Brouillons</span>
                    <span v-else class="d-inline-block ">
                        <img src="@/assets/images/rule-draft.svg" height="20px"  style="cursor: pointer;" />
                    </span>
                    <!-- <i class="d-none d-sm-inline-block fas fa-archive font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('orderTabs.draftsTab.title')}}</span> -->
                  </template>
                  <h5 class="card-title mt-3 mb-0" :class="isQuickOrder ? 'text-dark text-left pt-3' : 'text-secondary text-center'">{{$t('orderTabs.draftsTab.cardTitle')}}</h5><br>
                  <div class="table-responsive mb-0" style="min-height:42em;max-height:42em">
                  <b-table
                      :busy="isDraftsTableLoading"
                      :striped="true"
                      :small="true"
                      :hover="true"
                      :items="draftLines"
                      :fields="draftFields"
                    >
                  <template v-slot:head(ref)>
                    {{ $t("orderTabs.draftsTab.draftFields.ref") }} 
                  </template>
                  <template v-slot:head(creationDate)>
                    {{ $t("orderTabs.draftsTab.draftFields.date") }} 
                  </template>
                  <template v-slot:cell(ref)="{value,item}">
                        <a :class="item.isPendingValidation ? 'font-weight-bold' : '' "  title="" href="javascript:void(0);"  @click="getOrderLines(item)" >
                          {{value}}
                        </a>  
                  </template>
                  <template v-slot:cell(actions)="{item}"> 
                        <a  :title="$t('parameters.hover.delete')" href="javascript:void(0);"  @click="removeDraft(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-danger">
                          <i class="mdi mdi-trash-can font-size-18" />
                        </a>  
                  </template>
                  <template v-slot:table-busy>
                    <div class="text-center m-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                  </template>
                  </b-table>
                  <span v-if="!isDraftsTableLoading & !draftLines.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("orderTabs.draftsTab.emptyDraftTable")}}</span>
                  <!-- Pagination -->
                  <div class="row pt-3 mb-sm-4">
                      <div class="col-sm-8">
                          <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                              <b-form-select @input="getDrafts()"  v-model="draftsPagination.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                              <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t("pagination.from")}}</span><span class="font-weight-bold"> {{draftsPagination.totalRows}} {{$t("pagination.lines")}}</span></div>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="dataTables_paginate paging_simple_numbers float-right">
                              <ul class="pagination pagination-rounded mb-0">
                              <b-pagination v-model="draftsPagination.currentPage" :per-page="draftsPagination.pageSize" :total-rows="draftsPagination.totalRows" @input="getDrafts()" :disabled="isDraftsTableLoading" ></b-pagination>
                              </ul>
                          </div>
                      </div>
                  </div> 
                  <!-- Fin Pagination  -->
                  </div> 

                </b-tab>
              </b-tabs>
              
            </div>
        </div>
      </div>
    </div>

<b-modal
  v-model="showPanacheItemsDataModal"
  centered
  hide-footer
  hide-header
  size="lg"
  title="Détail de l'offre panachée"
  title-class="modal-title-custom"
  header-close-variant="danger">

  <div class="panache-container">
    <div class="modal-title-custom mb-3">Détail de l'offre panachée</div>
    <!-- Top Summary Header -->
    <div class="summary-banner">
      <div class="summary-item">
        <span class="label">Déclencheur</span>
        <span class="value text-danger">{{ itemsToOrder.length ? itemsToOrder[0].panQte : 0 }}</span>
      </div>
      <div class="summary-divider"></div>
      <div class="summary-item">
        <span class="label">Quantité Offre</span>
        <span class="value text-success">{{ offeredItems.length ? offeredItems[0].panPromo : 0 }}</span>
      </div>
      <div class="summary-divider"></div>
      <div class="summary-item">
        <span class="label">Offre N°</span>
<span class="value text-primary">{{ (panacheItemsData && panacheItemsData.itemsToOrder && panacheItemsData.itemsToOrder[0]) ? panacheItemsData.itemsToOrder[0].panNum : '_' }}</span>      </div>
    </div>

    <!-- Section 1: Items to Order -->
    <div class="panache-section order-section">
      <div class="section-header text-danger">
        <i class="fas fa-shopping-cart mr-2"></i>
        <span>Produits à commander</span>
      </div>
      
      <div class="table-responsive">
        <table class="table custom-table">
          <thead>
            <tr>
              <th>Ref</th>
              <th>Désignation</th>
              <th class="text-center col-qte">Qté</th>
              <th class="col-note">Note</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in itemsToOrder" :key="'order-' + item.itemId">
              <td class="font-weight-bold">{{ item.panArtCod }}</td>
              <td class="text-truncate-custom" :title="item.panArtLib">{{ item.panArtLib }}</td>
              <td>
                <div class="d-flex align-items-center justify-content-center">
                  <b-form-input
                    v-model.number="item.quantityToOrder"
                    type="number"
                    min="0"
                    size="sm"
                    class="input-centered"
                    aria-label="Qté à Commander">
                  </b-form-input>
                  <i v-if="item.quantityToOrder > 0"
                    class="fas fa-times font-size-14 text-danger ml-2 reset-quantity-icon"
                    title="Réinitialiser la quantité"
                    @click.stop="item.quantityToOrder = null"
                  ></i>
                </div>
              </td>
              <td>
                <b-form-input v-model="item.note" size="sm" placeholder="Ajouter une note..."></b-form-input>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="section-footer">
        <span class="total-label">Total Commandées :</span>
        <span class="total-value">{{ panacheItemsToOrderTotal }}</span>
      </div>
    </div>

    <!-- Section 2: Offered Items -->
    <div class="panache-section offer-section">
      <div class="section-header " style="justify-content: space-between;">
        <div>
          <i class="fas fa-gift mr-2"></i>
          <span>Produits Offerts</span>
        </div>

        <span class="max-qte">Max. Quantité de l'Offre : {{gratuityMaxCount}}</span>
      </div>
      
      <div class="table-responsive">
        <table class="table custom-table">
          <thead>
            <tr>
              <th>Ref</th>
              <th>Désignation</th>
              <th class="text-center col-qte">Qté</th>
              <th class="col-note">Note</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in offeredItems" :key="'offer-' + item.itemId">
              <td class="font-weight-bold">{{ item.panArtCod }}</td>
              <td class="text-truncate-custom" :title="item.panArtLib">{{ item.panArtLib }}</td>
              <td>
                <div class="d-flex align-items-center justify-content-center">
                  <b-form-input
                    v-model.number="item.quantityOffered"
                    type="number"
                    min="0"
                    size="sm"
                    class="input-centered"
                    aria-label="Qté de l'Offre">
                  </b-form-input>
                  <i v-if="item.quantityOffered > 0"
                    class="fas fa-times font-size-14 text-danger ml-2 reset-quantity-icon"
                    title="Réinitialiser la quantité"
                    @click.stop="item.quantityOffered = null"
                  ></i>
                </div>
              </td>
              <td>
                <b-form-input v-model="item.note" size="sm" placeholder="Ajouter une note..."></b-form-input>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="section-footer">
          <span class="total-label">Total Offerts :</span>
        <div class="total-group">
          <span class="total-value">{{ panacheOfferedItemsTotal }}</span>
        </div>
      </div>
    </div>

    <!-- Modal Actions -->
    <div class="modal-actions">
      <b-button variant="light" class="btn-quit" @click="showPanacheItemsDataModal = false">
        <i class="fas fa-times mr-1"></i> Quitter
      </b-button>
      <b-button variant="primary" class="btn-validate" @click="handleValidatePanacheOffer()">
        <i class="fas fa-check mr-1"></i> Confirmer
      </b-button>
    </div>
  </div>
</b-modal>

    <b-modal v-if="selectedItem"
        v-model="showImageModal" 
        hide-footer 
        centered 
        title-class="text-dark"
        size="lg"
        header-close-variant="danger">

        <template #modal-title>
            <div class="text-primary font-weight-bold">{{ selectedItem.title }}</div>

            <div class="text-dark font-size-14 mt-1">
              <span>{{ selectedItem.ref }}</span>
              <span v-if="selectedItem.brand && selectedItem.brand.name" > - {{ selectedItem.brand.name }}</span>
            </div>
           


        </template>
       
       <div class="row p-2 zoom-container">

        <img v-bind:src="'/api/image/get/'+selectedItem.image"    alt height="100%" width="100%" /> 

       </div>
       

    </b-modal>

    <b-modal
      v-if="isRequiredBannerAds && bannerAdsList && bannerAdsList.length"
      v-model="showRequiredBannerModal"
      centered
      size="xl"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      hide-header
      hide-footer
      modal-class="required-banner-modal"
      content-class="required-banner-content"
      body-class="p-0"
    >
      <div class="rb-stage">
        <transition name="rb-slide" mode="out-in">
          <div v-if="requiredBannerCurrent" :key="requiredBannerCurrent.id" class="rb-story">
            <img class="rb-image" :src="'/api/image/get/' + requiredBannerCurrent.generatedName" alt="">
            <div class="rb-scrim rb-scrim-top"></div>
            <div class="rb-scrim rb-scrim-bottom"></div>
            <div class="rb-progress">
              <span v-for="(b, i) in bannerAdsList" :key="b.id" class="rb-progress-seg" :class="{ done: i < requiredBannerIndex, active: i === requiredBannerIndex }"><span class="rb-progress-fill"></span></span>
            </div>
            <span class="rb-counter"><strong>{{ requiredBannerIndex + 1 }}</strong> / {{ bannerAdsList.length }}</span>
            <button v-if="!isRequiredBannerLast" type="button" class="rb-btn rb-btn-final" @click="nextRequiredBanner">
              Suivant
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 5 16 12 9 19"></polyline></svg>
            </button>
            <button v-else type="button" class="rb-btn rb-btn-final" @click="finishRequiredBanner">
              Catalogue
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 5 16 12 9 19"></polyline></svg>
            </button>
          </div>
        </transition>
      </div>
    </b-modal>

    <!-- no-close-on-esc -->
    <b-modal
      v-if="order.id "
      v-model="showOrdersDetailsModal"
      title="Valider la commande"
      centered 
      title-class="text-primary d-print-none"
      title-tag="h5"
      header-close-variant="danger"
      header-class="d-print-none"
      class="modal-fullscreen"
      modal-class="order-validate-modal"
      size="xl"
      full-screen
      
      hide-footer
      hide-header
      >

      <!-- hide-header modal: explicit close (X), top right; only hides the modal, the order is kept -->
      <button type="button" class="order-modal-close d-print-none" title="Fermer" aria-label="Fermer" @click="showOrdersDetailsModal = false"><i class="bx bx-x" aria-hidden="true"></i></button>
      <OrderModal :orderId="this.order.id" 
        :linesCount="this.order.lines.length" 
        :submitAgencyName="getOrderAgencyName(order.dbId)"
        :agencyDbId="this.order.dbId"
        v-on:update="closeOrderModal" 
        @removePanacheItem="handleRemovePanacheItem"
        @updatePanacheItem="handleUpdatePanacheItem"
        :hasAgencySelector="hasAgencySelector">
      </OrderModal>
    </b-modal>

    <b-modal
      v-if="role==0"
      v-model="showHistoryModal"
      :title="$t('topItems.historyModal.title')"
      centered 
      title-class="text-primary"
      title-tag="h5"
      header-close-variant="danger"
      hide-footer
      size="lg">
      <OrdersList :isHomePage=true />
    </b-modal>

    <b-modal
      v-if="isSharedDocumentsEnabled"
      v-model="showSharedDocumentsModal"
      centered 
      hide-header
      hide-footer
      size="lg">

      <SharedDocuments :isHomePage=true :type="seletedDocumentType"/>
      
    </b-modal>
<!-- phones/tablets (< 1200px), catalogue mode, every instance: the cart is below a long catalogue;
         this button jumps to it and disappears while the cart is visible -->
    <button v-if="showCartShortcut" type="button" class="cart-fab d-print-none" title="Voir la commande" @click="scrollToCart">
      <span class="cart-fab__icon">
        <i class="bx bx-cart" aria-hidden="true"></i>
        <span v-if="orderLines.length" class="cart-fab__badge">{{ orderLines.length }}</span>
      </span>
      <span class="cart-fab__label">Commande</span>
      <span v-if="hasAgencySelector && cartAgencyName" class="cart-fab__agency" :style="cartAgencyColorStyle">{{ cartAgencyName }}</span>
      <span v-if="orderLines.length && order.totalWithTaxes" class="cart-fab__total">{{ order.totalWithTaxes }}</span>
    </button>
       
  </div>

   
</Layout>
</template>



<style scoped>
/* catalogue header: shared-documents buttons + Catalogue | Saisie rapide switch on one right-aligned line */
.cat-head-actions { display: flex; flex-wrap: wrap; align-items: center; justify-content: flex-end; gap: 10px; }
/* the Catalogue | Saisie rapide switch always stays the right-most element of the catalogue card, as before */
.cat-head-actions .cat-head-switch { order: 99; margin-left: auto; }
.cat-head-actions > .btn + .cat-head-switch { margin-left: 0; }
#high-carousel img {
  width: 100%;
  height: auto; /* replace with your desired height */
  object-fit: cover;
}
#high-carousel p {
  padding-right: 10px; 
}

#high-carousel p::-webkit-scrollbar {
  width: 5px; /* replace with your desired scrollbar width */
}

#high-carousel p::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* replace with your desired track color */
}

#high-carousel p::-webkit-scrollbar-thumb {
  background-color: #888; /* replace with your desired thumb color */
  border-radius: 5px; /* replace with your desired thumb border radius */
}

#high-carousel p::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* replace with your desired hover thumb color */
}

.transition-width {
  transition: all 0.4s ease;
}


/* Modal Title Customization */
.modal-title-custom {
  font-size: 1.25rem !important;
  font-weight: 500 !important;
  color: #2d3748 !important;
  text-align: center;
  text-transform: uppercase;
}

.panache-container {
  padding: 1rem;
}

/* Summary Banner */
.summary-banner {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: white;
  padding: 1rem;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  margin-bottom: 1.5rem;
  border: 1px solid #e2e8f0;
}

.summary-item {
  text-align: center;
}

.summary-item .label {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #718096;
  font-weight: 600;
  margin-bottom: 4px;
}

.summary-item .value {
  font-size: 1.1rem;
  font-weight: 800;
}

.summary-divider {
  width: 1px;
  height: 30px;
  background-color: #e2e8f0;
}

/* Section Cards */
.panache-section {
  background: white;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  margin-bottom: 1.5rem;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.section-header {
  padding: 0.75rem 1rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  background-color: #f1f5f9;
  border-bottom: 1px solid #e2e8f0;
}

.order-section .section-header {
  border-left: 4px solid #e53e3e;
}

.offer-section .section-header {
  border-left: 4px solid #38a169;
  color: #38a169;
}

/* Table Styling */
.custom-table {
  margin-bottom: 0;
}

.custom-table thead th {
  background: transparent;
  color: #718096;
  font-size: 0.8rem;
  text-transform: uppercase;
  font-weight: 600;
  border-top: none;
  border-bottom: 2px solid #edf2f7;
  padding: 0.75rem;
}

.custom-table td {
  vertical-align: middle;
  padding: 0.1rem 0.75rem;
  border-bottom: 1px solid #edf2f7;
  color: #2d3748;
}

.text-truncate-custom {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Input Styling */
.input-centered {
  text-align: center;
  font-weight: 700;
  border-radius: 6px;
}

.reset-quantity-icon {
  cursor: pointer;
  line-height: 1;
}

.reset-quantity-icon:hover {
  color: #c53030;
}

.col-qte { width: 100px; }
.col-note { width: 150px; }

/* Footer of Sections */
.section-footer {
  padding: 0.75rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8fafc;
  border-top: 1px solid #edf2f7;
}

.total-label {
  font-size: 0.9rem;
  color: #718096;
  margin-right: 8px;
}

.total-value {
  font-size: 1.1rem;
  font-weight: 800;
  color: #1a202c;
}

.order-section .total-value { color: #c53030; }
.offer-section .total-value { color: #2f855a; }

.max-qte {
  font-weight: bold;
  font-size: 0.85rem;
  font-style: italic;
}

/* Actions */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 1rem 0;
}

.btn-validate {
  padding: 0.5rem 1.5rem;
  font-weight: 600;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(66, 153, 225, 0.2);
}

.btn-quit {
  border-radius: 8px;
  color: #718096;
}
@media (min-width: 1200px) {
  .col-xl-11-5 {
    flex: 0 0 95.8333%;
    max-width: 95.8333%;
  }
}

@media (min-width: 1200px) {
  .col-xl-0-5 {
    flex: 0 0 4.1667%;
    max-width: 4.1667%;
  }
}

</style>



<style scoped>
.icon-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  padding: 1rem 0;
  gap: 2rem;
}

.icon-with-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.icon-img {
  transition: transform 0.2s ease;
}

.icon-with-label:hover .icon-img {
  transform: scale(1.1);
}

.vertical-title {
  writing-mode: vertical-rl;
  /* transform: rotate(180deg); */
  font-size: 0.75rem;
  color: #333;
  text-align: center;
  text-orientation: upright;
}


.tooltip-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.custom-tooltip {
  visibility: hidden;
  opacity: 0;
  width: max-content;
  max-width: 200px;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 6px 10px;
  border-radius: 4px;
  position: absolute;
  z-index: 10;
  bottom: 110%; /* position above image */
  left: 50%;
  transform: translateX(-50%);
  transition: opacity 0.3s;
  pointer-events: none;
  font-size: 0.85rem;
  white-space: nowrap;
}

.tooltip-wrapper:hover .custom-tooltip {
  visibility: visible;
  opacity: 1;
}
</style>

<style scoped>
/* CSV import of the quick order screen */
.qo-import { display: flex; flex-wrap: wrap; align-items: center; gap: .75rem 1rem; margin: 1.75rem 0 2rem; padding: .9rem 1rem; background: #f8f9fb; border: 1px dashed #d0d5dd; border-radius: 12px; }
.qo-import__icon { display: flex; align-items: center; justify-content: center; flex: 0 0 auto; width: 40px; height: 40px; border-radius: 10px; background: #eef1f6; color: #344054; font-size: 22px; }
.qo-import__body { flex: 1 1 260px; min-width: 0; }
.qo-import__title { margin: 0; font-size: 14px; font-weight: 700; color: #101828; }
.qo-import__text { margin: .1rem 0 0; font-size: 13px; color: #667085; }
.qo-import__actions { display: flex; flex-wrap: wrap; align-items: center; gap: .5rem .75rem; margin-left: auto; }
.qo-import__template { display: inline-flex; align-items: center; gap: .35rem; padding: .45rem .6rem; border: 0; border-radius: 8px; background: transparent; color: #344054; font-size: 13px; font-weight: 600; cursor: pointer; }
.qo-import__template:hover { background: #eef1f6; color: #101828; }
.qo-import__template .bx { font-size: 17px; }
.qo-import__template:focus-visible { outline: 2px solid #344054; outline-offset: 2px; }
.qo-import__button { display: inline-flex; align-items: center; font-weight: 600; }
@media (max-width: 575.98px) {
  .qo-import__actions { width: 100%; margin-left: 0; }
  .qo-import__actions > * { flex: 1 1 auto; justify-content: center; }
}

/* "Annuler toute la commande" (every instance, both modes) */
.order-cancel { display: flex; justify-content: flex-end; margin: 1.25rem 0 .75rem; }
.order-cancel__btn { display: inline-flex; align-items: center; gap: .4rem; padding: .4rem .8rem; border: 1px solid #fecdca; border-radius: 8px; background: #fff; color: #b42318; font-size: 13px; font-weight: 600; cursor: pointer; transition: background-color .15s ease, border-color .15s ease; }
.order-cancel__btn .bx { font-size: 16px; }
.order-cancel__btn:hover { background: #fef3f2; border-color: #fda29b; }
.order-cancel__btn:focus-visible { outline: 2px solid #b42318; outline-offset: 2px; }
@media (prefers-reduced-motion: reduce) { .order-cancel__btn { transition: none; } }

/* État encours client */
.rs-card { padding: .75rem .9rem; border: 1px solid #e4e7ec; border-radius: 12px; background: #fff; transition: opacity .2s ease; }
.rs-card--loading { opacity: .65; }
.rs-card--ok { --rs: #146c43; --rs-bg: #e3f4ec; }
.rs-card--warn { --rs: #c2410c; --rs-bg: #fff1e6; }
.rs-card--over { --rs: #b42318; --rs-bg: #fdecea; }
.rs-card--none { --rs: #475467; --rs-bg: #f2f4f7; }
.rs-card__head { display: flex; align-items: center; justify-content: space-between; gap: .5rem; }
.rs-card__label { display: inline-flex; align-items: center; gap: .4rem; font-size: 12px; font-weight: 600; letter-spacing: .04em; text-transform: uppercase; color: #475467; }
.rs-card__label .bx { font-size: 16px; color: #667085; }
.rs-card__badge { padding: .15rem .55rem; border-radius: 999px; background: var(--rs-bg); color: var(--rs); font-size: 12px; font-weight: 700; font-variant-numeric: tabular-nums; }
.rs-card__amounts { margin-top: .35rem; font-size: 15px; color: #101828; font-variant-numeric: tabular-nums; }
.rs-card__amounts strong { font-weight: 700; }
.rs-card__of { margin-left: .25rem; color: #667085; font-size: 13px; font-weight: 500; }
.rs-card__bar { height: 8px; margin-top: .5rem; overflow: hidden; border-radius: 999px; background: #eef1f6; }
.rs-card__bar span { display: block; height: 100%; border-radius: inherit; background: var(--rs); transition: width .4s ease; }
.rs-card__note { display: block; margin-top: .4rem; font-size: 12px; font-weight: 600; color: var(--rs); }
@media (prefers-reduced-motion: reduce) { .rs-card, .rs-card__bar span { transition: none; } }
/* Catalogue filters (every instance): the switches as chips (whole pill clickable), one caption style
   for the dropdown filters and the search, dropdowns in an aligned grid. Look only. */
.cat-filters__caption { margin: .5rem 0 .45rem; font-size: 11.5px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase; color: #101828; }
/* both chip groups flow as one line of chips, wrapping chip by chip only when there is no room */
.cat-chips-line { display: flex; flex-wrap: wrap; gap: .35rem; margin: 0 0 .45rem; }
.cat-chips { display: contents; }
.cat-chips > div { flex: 0 0 auto; width: auto; max-width: none; padding: 0; }
.cat-chips ::v-deep .custom-switch { float: none !important; margin: 0 !important; padding-left: 0; }
.cat-chips ::v-deep .custom-switch .custom-control-label { display: inline-flex; align-items: center; min-height: 32px; padding: .25rem .6rem .25rem 1.7rem; border: 1px solid #d0d5dd; border-radius: 999px; background: #fff; cursor: pointer; transition: background-color .15s ease, border-color .15s ease, padding .15s ease; }
.cat-chips ::v-deep .custom-switch .custom-control-label:hover { border-color: #98a2b3; background: #f9fafb; }
/* plain chips: the switch track and knob are not drawn; a white check mark shows when the filter is on */
.cat-chips ::v-deep .custom-switch .custom-control-label::before,
.cat-chips ::v-deep .custom-switch .custom-control-label::after { display: none; }
.cat-chips ::v-deep .custom-switch .custom-control-input:checked ~ .custom-control-label { padding-left: 1.7rem; }
.cat-chips ::v-deep .custom-switch .custom-control-input:checked ~ .custom-control-label::before { display: block; top: 50%; left: .6rem; width: 13px; height: 13px; border: 0; border-radius: 0; box-shadow: none; transform: translateY(-50%);
  background: transparent url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E") no-repeat center / 13px 13px; }
/* chip type icons, drawn while the filter is off; the check mark replaces them when it is on
   (allocation: répartition, ventes contrôlées / range: pharma, para / new: nouveautés, à nouveau disponibles, arrivages / promotion) */
.cat-chips > .cat-chip--alloc ::v-deep .custom-switch .custom-control-label::before { display: block; top: 50%; left: .6rem; width: 13px; height: 13px; border: 0; border-radius: 0; box-shadow: none; transform: translateY(-50%); background: transparent url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23667085' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M21.21 15.89A10 10 0 1 1 8 2.83'/%3E%3Cpath d='M22 12A10 10 0 0 0 12 2v10z'/%3E%3C/svg%3E") no-repeat center / 13px 13px; }
.cat-chips > .cat-chip--range ::v-deep .custom-switch .custom-control-label::before { display: block; top: 50%; left: .6rem; width: 13px; height: 13px; border: 0; border-radius: 0; box-shadow: none; transform: translateY(-50%); background: transparent url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23667085' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M10.5 20.5l10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7z'/%3E%3Cpath d='M8.5 8.5l7 7'/%3E%3C/svg%3E") no-repeat center / 13px 13px; }
.cat-chips > .cat-chip--new ::v-deep .custom-switch .custom-control-label::before { display: block; top: 50%; left: .6rem; width: 13px; height: 13px; border: 0; border-radius: 0; box-shadow: none; transform: translateY(-50%); background: transparent url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23667085' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M12 3l1.9 5.8L20 11l-6.1 2.2L12 19l-1.9-5.8L4 11l6.1-2.2z'/%3E%3C/svg%3E") no-repeat center / 13px 13px; }
.cat-chips > .cat-chip--promo ::v-deep .custom-switch .custom-control-label::before { display: block; top: 50%; left: .6rem; width: 13px; height: 13px; border: 0; border-radius: 0; box-shadow: none; transform: translateY(-50%); background: transparent url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23667085' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z'/%3E%3Cline x1='7' y1='7' x2='7.01' y2='7'/%3E%3C/svg%3E") no-repeat center / 13px 13px; }
/* the text sits in a nested <label> that activates nothing: let the click reach the chip's own label so the text toggles too */
.cat-chips ::v-deep .custom-control-label label { pointer-events: none; margin: 0; font-size: 12px; font-weight: 500 !important; letter-spacing: 0 !important; text-transform: none !important; color: #344054 !important; white-space: nowrap; cursor: pointer; }
.cat-chips ::v-deep .custom-control-label label strong { font-weight: 700; color: inherit !important; }
.cat-chips ::v-deep .custom-control-input:checked ~ .custom-control-label { border-color: var(--primary, #34469c); background: var(--primary, #34469c); }
.cat-chips ::v-deep .custom-control-input:checked ~ .custom-control-label label { color: #fff !important; font-weight: 600 !important; }
.cat-chips ::v-deep .custom-control-input:focus-visible ~ .custom-control-label { box-shadow: 0 0 0 3px rgba(52, 70, 156, .18); }
.cat-filter-grid { display: grid; grid-template-columns: minmax(0, 1fr); gap: .9rem 1rem; margin: 1rem 0 0; }
@media (min-width: 576px) { .cat-filter-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (min-width: 992px) { .cat-filter-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); } }
.cat-filter-grid > div { width: auto; max-width: none; flex: none; padding: 0 !important; }
/* dropdowns and search: no caption above; the label is the placeholder, and floats onto the field border once filled */
.cat-field { position: relative; }
.cat-field__label { position: absolute; top: -7px; left: .55rem; z-index: 6; display: flex; align-items: center; margin: 0; padding: 0 .3rem; border-radius: 4px;
  background: linear-gradient(#fff 55%, #f9fafb 55%); color: #475467; font-size: 10.5px; font-weight: 700; letter-spacing: .04em; line-height: 14px; text-transform: uppercase; white-space: nowrap;
  opacity: 0; transform: translateY(4px); transition: opacity .15s ease, transform .15s ease; pointer-events: none; }
.cat-field__label i { display: none; }
.cat-field--filled .cat-field__label { opacity: 1; transform: none; }
/* above the focused input (Bootstrap raises a focused input-group field to z-index 3) */
.cat-search__label-col { position: relative; z-index: 6; height: 0; }
.cat-search__label-col .cat-field__label { left: calc(15px + 2.05rem); background: #fff; }
@media (prefers-reduced-motion: reduce) { .cat-field__label { transition: none; } }
@media (prefers-reduced-motion: reduce) { .cat-chips ::v-deep .custom-switch .custom-control-label { transition: none; } }
/* dropdown filters: calm field, grey chevron, primary border once a value is chosen */
.cat-select ::v-deep .vs__dropdown-toggle { min-height: 40px; padding: 0 .35rem 0 .15rem; border: 1px solid #d0d5dd; border-radius: 8px; background: #fff; transition: border-color .15s ease, box-shadow .15s ease; }
.cat-select ::v-deep .vs__dropdown-toggle:hover { border-color: #98a2b3; }
.cat-select ::v-deep .vs__dropdown-toggle:has(.vs__selected) { border-color: var(--primary, #34469c); background: #f9fafb; }
.cat-select.vs--open ::v-deep .vs__dropdown-toggle { border-color: var(--primary, #34469c); border-radius: 8px; box-shadow: 0 0 0 3px rgba(16, 24, 40, .08); }
.cat-select ::v-deep .vs__selected-options { padding: 0 .35rem; }
.cat-select ::v-deep .vs__search, .cat-select ::v-deep .vs__selected { font-size: 14px; color: #101828; }
.cat-select ::v-deep .vs__search::placeholder { font-size: 14px; color: #98a2b3; }
.cat-select ::v-deep .vs__selected { margin: 0; padding: 0 .25rem; font-weight: 600; }
.cat-select ::v-deep .vs__open-indicator { fill: #667085; transform: scale(.8); }
.cat-select.vs--open ::v-deep .vs__open-indicator { transform: rotate(180deg) scale(.8); }
.cat-select ::v-deep .vs__clear { margin-right: 4px; fill: #98a2b3; }
.cat-select ::v-deep .vs__clear:hover { fill: #475467; }
.cat-select ::v-deep .vs__dropdown-menu { margin-top: 4px; padding: .25rem; border: 1px solid #e4e7ec; border-radius: 10px; box-shadow: 0 12px 24px -6px rgba(16, 24, 40, .16), 0 4px 8px -2px rgba(16, 24, 40, .08); font-size: 14px; color: #101828; }
.cat-select ::v-deep .vs__dropdown-option { padding: .45rem .65rem; border-radius: 6px; white-space: normal; }
.cat-select ::v-deep .vs__dropdown-option--highlight { background: #f2f4f7; color: #101828; }
.cat-select ::v-deep .vs__no-options { padding: .5rem; font-size: 13px; color: #667085; }
/* search: icon inside the field, same height as the button, quiet "recherche élargie" line */
.cat-search { margin-top: 1.1rem; padding-bottom: 1.5rem; }
.cat-search__input { height: 42px; padding-left: 2.4rem; border: 1px solid #d0d5dd; border-right: 0; border-radius: 8px 0 0 8px !important; font-size: 14px; font-weight: 500; color: #101828;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2398a2b3' stroke-width='2' stroke-linecap='round'%3E%3Ccircle cx='11' cy='11' r='7'/%3E%3Cline x1='16.5' y1='16.5' x2='21' y2='21'/%3E%3C/svg%3E") no-repeat .8rem center / 16px 16px; }
.cat-search__input::placeholder { font-weight: 400; color: #98a2b3; }
.cat-search__input:focus { border-color: var(--primary, #34469c); box-shadow: 0 0 0 3px rgba(16, 24, 40, .08); }
.cat-search__btn { display: inline-flex; align-items: center; height: 42px; padding: 0 1rem; border-radius: 0 8px 8px 0 !important; font-size: 14px; font-weight: 600; }
.cat-search__btn-content { display: inline-flex; align-items: center; gap: .4rem; }
.cat-search__btn .bx { font-size: 18px; }
.cat-search__wider { margin-top: .6rem; font-size: 13px; color: #475467; }
.cat-search__wider-link { color: #475467 !important; cursor: pointer; }
.cat-search__wider-link i { font-style: normal; }
.cat-search__wider-link strong { font-weight: 600; color: var(--primary, #34469c); }
.cat-search__wider-link:hover strong { text-decoration: underline; }
@media (prefers-reduced-motion: reduce) { .cat-select ::v-deep .vs__dropdown-toggle { transition: none; } }
/* palier cards: the card's own top margin only separates stacked cards (phones); not above the first card, nor above both when side by side */
.palier-row > div:first-child > div:not(.rs-card) { margin-top: 0 !important; }
.palier-row > div > .rs-card:first-child { margin-top: 0 !important; }
@media (min-width: 992px) { .palier-row > div > div:not(.rs-card) { margin-top: 0 !important; } }
/* "Équivalents à" / "Souvent commandés avec" cards (instances with these sections): card, header and column headers, look only */
.rel-card { border: 1px solid #e4e7ec !important; border-radius: 12px; overflow: hidden; box-shadow: 0 1px 2px rgba(16, 24, 40, .04); }
.rel-card__head { margin: 0; padding: .7rem .9rem; background: #eff2f7; border-bottom: 1px solid #e4e7ec; }
.rel-card__head > div { padding: 0; }
.rel-card__title { display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: .35rem .6rem; margin: 0; font-size: 14px; line-height: 1.35; text-align: center; }
.rel-card__caption { font-size: 11.5px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase; color: #101828; }
.rel-card__item { font-weight: 700; color: var(--primary, #34469c); }
.rel-grid ::v-deep thead th { padding: .6rem .75rem; border-top: 0; border-bottom: 1px solid #e4e7ec; background: #f8f9fb; color: #475467; font-size: 11px; font-weight: 700; letter-spacing: .05em; line-height: 1.35; text-transform: uppercase; vertical-align: middle; }
/* main catalogue grid: column headers as one light rounded band, like the Saisie rapide grid (look only) */
.cat-grid { border-collapse: separate; border-spacing: 0; }
.cat-grid ::v-deep thead th { padding: .65rem .75rem; border-top: 1px solid #e4e7ec; border-bottom: 1px solid #e4e7ec; background: #f8f9fb; color: #475467; font-size: 11px; font-weight: 700; letter-spacing: .05em; line-height: 1.35; text-transform: uppercase; vertical-align: middle; }
.cat-grid ::v-deep thead th:first-child { border-left: 1px solid #e4e7ec; border-radius: 10px 0 0 10px; }
.cat-grid ::v-deep thead th:last-child { border-right: 1px solid #e4e7ec; border-radius: 0 10px 10px 0; }
.cat-grid ::v-deep tbody tr:first-child td { border-top: 0; }
.promo-offers { display: inline-flex; align-items: center; justify-content: center; padding: .45rem .55rem; border: 1px solid #dcefe4; border-radius: 7px; background: #fbfffc; box-shadow: 0 1px 2px rgba(16, 24, 40, .04); }
.promo-offer { display: inline-flex; flex-direction: column; align-items: center; min-width: 58px; padding: 0 .4rem; font-variant-numeric: tabular-nums; line-height: 1.05; }
.promo-offer + .promo-offer { border-left: 1px solid #d0d5dd; }
.promo-offer strong { color: #07852f; font-size: 15px; font-weight: 800; white-space: nowrap; }
.promo-offer small { margin-top: .3rem; color: #475467; font-size: 12px; font-weight: 700; white-space: nowrap; }
.promo-offers--mobile { min-width: 0; padding: .4rem .45rem; justify-content: flex-start; }
.promo-offer--mobile { min-width: 48px; padding: 0 .5rem; }
.promo-offer--mobile strong { font-size: 13px; }
.promo-offer--mobile small { font-size: 11px; }
</style>

<style scoped>
/* collapsed cart rail (VUE_APP_FEATURE_COLLAPSE_CART_BOX, every instance except CAB) */
.cart-rail-card { border: 1px solid #e4e7ec; border-radius: 12px; background: #fff; box-shadow: none; }
.cart-rail { display: flex; flex-direction: column; align-items: center; gap: .25rem; padding: .6rem .15rem; }
.cart-rail__item { display: flex; flex-direction: column; align-items: center; gap: .25rem; width: 100%; padding: .45rem 0; border: 0; border-radius: 10px; background: transparent; color: #475467; cursor: pointer; transition: background-color .15s ease, color .15s ease; }
.cart-rail__item:hover { background: #f2f4f7; color: #101828; }
.cart-rail__item:focus-visible, .cart-rail__total:focus-visible { outline: 2px solid var(--primary, #34469c); outline-offset: -2px; }
.cart-rail__icon { position: relative; display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 9px; background: #f2f4f7; font-size: 18px; }
.cart-rail__item:hover .cart-rail__icon { background: #e4e7ec; }
.cart-rail__item--open { color: var(--primary, #34469c); }
.cart-rail__item--open .cart-rail__icon { background: transparent; border: 1px solid #d0d5dd; font-size: 20px; }
.cart-rail__badge { position: absolute; top: -7px; right: -9px; min-width: 18px; height: 18px; padding: 0 5px; border-radius: 999px; background: var(--primary, #34469c); color: #fff; font-size: 11px; font-weight: 700; line-height: 18px; text-align: center; box-shadow: 0 0 0 2px #fff; font-variant-numeric: tabular-nums; }
.cart-rail__label { max-width: 100%; overflow: hidden; font-size: 9.5px; font-weight: 600; line-height: 1.1; text-overflow: ellipsis; white-space: nowrap; }
.cart-rail__sep { width: 55%; height: 1px; margin: .2rem 0; background: #e4e7ec; }
.agency-scope-chip { --agency-rgb: 0, 122, 51; display: inline-flex; align-items: center; gap: .35rem; margin-top: .4rem; padding: .15rem .6rem; border: 1px solid rgba(var(--agency-rgb), .35); border-radius: 999px; background: rgba(var(--agency-rgb), .08); color: #344054; font-size: 12px; }
.agency-scope-chip .bx { color: rgb(var(--agency-rgb)); font-size: 14px; }
.agency-scope-chip strong { color: rgb(var(--agency-rgb)); text-transform: uppercase; }
.cart-rail__agency { --agency-rgb: 0, 122, 51; display: block; margin: 0 auto .4rem; padding: .5rem .2rem; border-radius: 6px; background: rgb(var(--agency-rgb)); color: #fff; font-size: 10.5px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase; writing-mode: vertical-rl; transform: rotate(180deg); white-space: nowrap; }
.cart-fab__agency { --agency-rgb: 0, 122, 51; padding: .1rem .45rem; border-radius: 999px; background: #fff; color: rgb(var(--agency-rgb)); font-size: 11px; font-weight: 700; text-transform: uppercase; }
.cart-rail__total { display: flex; flex-direction: column; align-items: center; gap: .45rem; width: 100%; margin-top: .4rem; padding: .6rem 0; border: 0; border-top: 1px solid #e4e7ec; background: transparent; color: #101828; cursor: pointer; }
.cart-rail__total .bx { font-size: 18px; color: var(--primary, #34469c); }
.cart-rail__total-value, .cart-rail__total-label { writing-mode: vertical-rl; transform: rotate(180deg); white-space: nowrap; }
.cart-rail__total-value { font-size: 13px; font-weight: 700; font-variant-numeric: tabular-nums; }
.cart-rail__total-label { font-size: 9.5px; font-weight: 600; letter-spacing: .06em; text-transform: uppercase; color: #667085; }
/* expanded cart: the control that collapses it again */
.cart-rail-collapse { display: inline-flex; align-items: center; gap: .3rem; padding: .3rem .65rem .3rem .45rem; border: 1px solid #d0d5dd; border-radius: 8px; background: #fff; color: #344054; font-size: 12px; font-weight: 600; cursor: pointer; transition: background-color .15s ease, border-color .15s ease; }
.cart-rail-collapse .bx { font-size: 16px; }
.cart-rail-collapse:hover { background: #f9fafb; border-color: #98a2b3; }
.cart-rail-collapse:focus-visible { outline: 2px solid var(--primary, #34469c); outline-offset: 2px; }
@media (prefers-reduced-motion: reduce) { .cart-rail__item, .cart-rail-collapse { transition: none; } }
</style>

<style scoped>
/* cart column: land below the fixed topbar when scrolled to */
.cart-col { scroll-margin-top: 90px; }
/* floating "Commande" shortcut (< 1200px, catalogue mode) */
.cart-fab { position: fixed; right: 16px; bottom: calc(16px + env(safe-area-inset-bottom, 0px)); z-index: 1030; display: inline-flex; align-items: center; gap: .5rem; max-width: calc(100vw - 32px); padding: .55rem .95rem .55rem .7rem; border: 0; border-radius: 999px; background: var(--primary, #34469c); color: #fff; font-size: 14px; font-weight: 600; box-shadow: 0 6px 18px rgba(16, 24, 40, .22); cursor: pointer; }
.cart-fab:focus-visible { outline: 3px solid #fff; outline-offset: -5px; }
.cart-fab__icon { position: relative; display: inline-flex; font-size: 22px; }
.cart-fab__badge { position: absolute; top: -8px; right: -10px; min-width: 18px; height: 18px; padding: 0 5px; border-radius: 999px; background: #fff; color: var(--primary, #34469c); font-size: 11px; font-weight: 700; line-height: 18px; text-align: center; font-variant-numeric: tabular-nums; }
.cart-fab__total { padding-left: .5rem; border-left: 1px solid rgba(255, 255, 255, .4); white-space: nowrap; font-variant-numeric: tabular-nums; }
@media (max-width: 359.98px) { .cart-fab__label { display: none; } }
</style>

<style scoped>
/* mobile catalogue lines under the designation, VUE_APP_FEATURE_MOBILE_CATALOG (isMobileCatalog) */
.m-quick-ref { margin-top: .15rem; font-size: 11px; font-weight: 600; color: #667085; white-space: normal; }
.m-quick-ref__brand { font-weight: 400; }
::v-deep .m-title { white-space: normal !important; }
.m-quick-line { display: flex; flex-wrap: wrap; align-items: center; gap: .5rem; margin-top: .35rem; }
.m-quick { align-items: center; gap: .5rem; margin-top: .35rem; font-weight: 600; }
.m-quick-stock { display: inline-flex; align-items: center; }
.m-quick-stock ::v-deep .justify-content-center { justify-content: flex-start !important; }
.m-quick-stock ::v-deep .p-1 { padding-left: 0 !important; }
.m-quick-price { font-size: 14px; font-weight: 700; color: #101828; white-space: nowrap; }
.m-quick-price small { font-size: 10px; font-weight: 600; color: #667085; }
.m-quick--add { margin-top: .9rem; }
.m-quick__add { width: 9em; flex-wrap: nowrap; }
</style>

<style scoped>
/* "Valider la commande" modal (hide-header): close button, top right, stays reachable on phones */
.order-modal-close { position: absolute; top: .5rem; right: .5rem; z-index: 5; display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; padding: 0; border: 0; background: transparent; color: #344054; font-size: 28px; line-height: 1; cursor: pointer; }
.order-modal-close:hover { color: #101828; }
.order-modal-close:focus-visible { outline: 2px solid var(--primary, #34469c); outline-offset: 2px; }
.order-validation-agency { display: block; margin-top: .15rem; color: inherit; font-size: 10px; font-weight: 600; line-height: 1.2; opacity: .85; }
</style>
